const localisationConstants = {
  // common error messages
  APP_CATCH_ERR: 'App Catch error',
  GENERAL_ERR: 'General error',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  NO_RECORDS_FOUND: 'No records were found',
  ERR_DUPLICATE_REFERENCE_ID: 'Already Exists',
  PANDO_PRIVACY_POLICY: 'I allow Pando to collect personal information of myself. I consent to collection, storing and processing of my personal data in accordance with Pando Privacy Policy as well as to share my data with its respective clients. For more details click on',

  INDENT_INDENT: 'Indent',
  INDENT_FREIGHT_CHANGE_REQUESTED_STATUS: 'Freight change requested',
  INDENT_FREIGHT_CHANGE_REQUESTED: 'Freight change requested',
  INDENT_SELECT_FREIGHT_UNIT: 'Choose Freight unit',
  INDENT_ENTER_FREIGHT_RATE: 'Enter freight rate',
  INDENT_ENTER_REJECTION_REASON: 'Enter rejection reason',
  // Indent lisitng headers
  INDENT_INDENT_ID: 'Indent ID',
  INDENT_STATUS: 'Status',
  INDENT_ROUTE: 'Route',
  INDENT_TRANSPORTER: 'Transporter',
  INDENT_VEHICLE_TYPE: 'Vehicle type',
  INDENT_POINT_CHARGE: 'POINT CHARGE',
  INDENT_MIN_CHARGE: 'MIN CHARGE',
  INDENT_CARRIER: 'CARRIER',
  INDENT_VEHICLE_NUMBER: 'Vehicle Number',
  INDENT_CUSTOMER: 'CUSTOMER',
  INDENT_DROP_OFF_CONSIGNEE: 'Drop off consignee',
  INDENT_DROP_OFF_DEPOT: 'Drop off depot',
  INDENT_DELIVERY_NUMBER: 'delivery number',
  INDENT_OTHER_INFO: 'Other Info',
  INDENT_CONSIGNEE_NAME_REF_ID: 'Consignee Name or Ref ID',
  INDENT_DEPOT_NAME_REF_ID: 'Depot Name or Ref ID',
  INDENT_SOURCE_CONSIGNEE: 'Source Consignee',
  INDENT_SOURCE_VENDOR_DEPOT: 'Source Vendor Depot',
  INDENT_SOURCE_DEPOT_NAME: 'Source Vendor Depot Name',
  INDENT_SOURCE_DEPOT_REF_ID: 'Source Vendor Depot Ref Id',

  INDENT_CONTACT_DETAILS: 'Contact Details',
  // Indent actions
  INDENT_UPDATE_VEHICLE: 'UPDATE VEHICLE',
  'INDENT_VEHICLE_LENGTH(CM)': 'Vehicle Length (cm)',
  'INDENT_VEHICLE_WIDTH(CM)': 'Vehicle Width (cm)',
  'INDENT_VEHICLE_HEIGHT(CM)': 'Vehicle Height (cm)',
  INDENT_LOADING: 'Loading',
  INDENT_UPDATE: 'Update',
  INDENT_EDIT_TRUCK_IN: 'Edit Truck In',
  INDENT_BASE_FREIGHT: 'Base Freight',
  INDENT_FREIGHT: 'Freight',
  INDENT_TRANSPORTER_QUOTES: 'Transporter Quotes',
  INDENT_QUOTES: 'Quotes',
  INDENT_DELIVERY_WINDOW: 'Expected Date | Delivery Window',
  INDENT_PTL_GROUPING: 'PTL Grouping',
  INDENT_RE_INDENT: 'Re-indent',
  INDENT_CHANGE_REQUEST: 'Change Request',
  INDENT_VEHICLE: 'Vehicle',
  INDENT_MARK_AS_DELIVERED: 'Mark as delivered',
  INDENT_NOT_DELIVERED: 'Not Delivered',
  INDENT_ADD_DOCKS: 'Add Docks',
  INDENT_DOCKS: 'Docks',
  INDENT_REPORTED: 'Reported',
  INDENT_CONTAINER_PICKED: 'Container Picked',
  INDENT_CONTAINER_PICKUP: 'Container Pickup',
  INDENT_CONTAINER_NOT_BOOKED: 'Container Not Booked',
  LAST_MILE_ACTIONS: 'ACTIONS',
  INDENT_TRUCK_IN: 'Truck in',
  INDENT_REACHED_LOADING_POINT: 'REACHED LOADING POINT',
  INDENT_REACHED_DOCK: 'REACHED DOCK',
  INDENT_START_LOADING: 'START LOADING',
  INDENT_START_LOAD: 'START LOAD',
  INDENT_END_LOADING: 'END LOADING',
  INDENT_END_LOAD: 'END LOAD',
  INDENT_TRUCK_OUT: 'TRUCK OUT',
  INDENT_EMPTY_CONTAINER_RETURNED: 'EMPTY CONTAINER RETURNED',
  INDENT_EWAY_BILL: 'EWAY BILL',
  INDENT_LR_DETAILS: 'LR Details',
  INDENT_CONSIGNEE_NAME: 'Consignee Name',
  INDENT_LR_NUMBER: 'LR Number',
  INDENT_LR_NUMBERS: 'LR',
  INDENT_DELIVERY_NUMBERS: 'DN',
  INDENT_DELIVERY_DETAILS: 'Delivery Details',
  INDENT_DELIVERY_NUMBER: 'Delivery Numbers',
  INDENT_UPDATE_EDD: 'UPDATE EDD',
  INDENT_EDD: 'EDD',
  INDENT_DOCUMENT: 'Document',
  INDENT_MOVED_TO_DOCK: 'Moved to Dock',
  INDENT_HANDOVER_COMPLETE: 'Handover Complete',
  INDENT_MOVED_BACK_TO_INDENTED: 'Moved back to Indented',
  INDENT_DELIVERED_AT_CONSIGNEE: 'Delivered at consignee',
  INDENT_GATE_PASS: 'Gate Pass',
  INDENT_GATE_PASS_NA: 'Gate Pass N/A',
  CONSIDER_RETURN_FRIEGHT_CHARGE: 'Consider Return Freight Charge',
  // indent success messages
  INDENT_TRACKING_SUCCESS_MSG: 'Tracking enabled for indent {order_number}',
  GATE_PASS_SUCCESS_MSG: 'Gate pass enabled for indent {order_number}',
  INDENT_REPORTED_SUCCESS_MSG:
    'Truck reported at depot for indent {order_number}',
  INDENT_CONSENT_SUCCESS_MSG: 'Consent sent for phone no {phone}',
  INDENT_LOADING_START_SUCCESS_MSG: 'Loading started for indent {order_number} on {loading_date} at {loading_time}',
  INDENT_LOADING_END_SUCCESS_MSG: 'Loading ended for indent {order_number} on {loading_date} at {loading_time}',
  INDENT_VEHICLE_REACH_SUCCESS_MSG:
    'Vehicle reached loading point for {order_number}',
  INDENT_HANDOVER_COMPLETE_SUCCESS_MSG:
    'Indent {order_number} has moved to Shipped',
  INDENT_MOVED_BACK_TO_INDENTED_MSG:
    'Indent {order_number} has moved back to Indented Status',
  INDENT_MOVE_TO_DOCK_SUCCESS_MSG:
    'Indent {order_number} has moved to Ship Ready',
  INDENT_DOCK_ASSIGNED_SUCCESS_MSG: 'Dock assigned for {order_number}',
  INDENT_BLACKLIST_VEH_SUCCESS_MSG:
    '{status_name} vehicle {vehicle_number} success',
  INDENT_BLACKLIST_DRIVER_SUCCESS_MSG:
    '{status_name} Driver {driver_number} success',
  // indent error messages
  INDENT_ARRIVED_DATE_ERROR_MSG: 'Selected time cannot be in the future',
  INDENT_TRUCKIN_AFTER_ASSIGNED_ERROR_MSG:
    'Truck In time should be after assigned',
  VEHICLE_TYPE_SUCCESS_MSG:'Vehicle Type Updated Successfully',
  TRUCK_CHANGE_REQUEST: "Truck Change Request",
  INDENT_REASON_TRUCK_TYPE_CHANGE: "Truck Change Request Reason",
  INDENT_REJECT_VEHICLE_CHANGE: "Truck Type Change Reject",
  INDENT_REJECTION_REASON_VEHICLE_CHANGE: "Truck Type Change Reject Reason",
  VEHICLE_TYPE_ERROR_MSG: 'Vehicle Type is not allowed to be empty',
  VEHICLE_UTILIZATION_NOT_MET: 'Vehicle Utilization is not met',
  GATE_PASS_ERROR_MSG: 'Enable gate pass failed for indent {order_number}',
  INDENT_UPLOAD_FAILED: 'Upload failed!',
  INDENT_TRUCK_OUT_AFTER_IN: 'Selected time cannot be in the future',
  INDENT_ATTACHMENT_MANDATORY: 'Attachment is Mandatory',
  INDENT_COMMENT_MANDATORY: 'Comment is mandatory',
  INDENT_SELECT_MANDATORY: 'Selection is mandatory',
  INDENT_ENTER_FREIGHT_AMOUNT: 'Enter the freight amount',
  INDENT_UPDATED_FREIGHT_SUCCESS_MSG:
    'Updated the freight rate for {order_number}',
  INDENT_LOAD_MAP_FAILED: 'Unable to load Map',
  INDENT_DRAFT: 'Draft',
  INDENT_REQUEST: 'Request',
  INDENT_CONTRACTED_TRANSPORTER_PROMPT: 'Few of the selected transporters already have contracts. Clicking on proceed will have them removed and request will not be sent to contracted transporters. Do you still want to proceed?',
  INDENT_MULTI_DROP_PTL_PROMPT: 'You have chosen multiple drop points for a PTL indent. These drop points will be created as separate indents. Are you sure to continue?',
  INDENT_LIMIT_MULTI_DROP_PTL_PROMPT:'More than {IndentPromptLimit} drop points for a PTL indent is not possible',
  INDENT_PROMPT_NO: 'NO',
  INDENT_PROMPT_PROCEED: 'YES, PROCEED',
  INDENT_DELIVERED_AT_CONSIGNEE_DATE_ERROR: 'Delivered at consignee date should be after indent creation',
  INDENT_LR_ALREADY_EXISTS_ERROR: 'LR Number {lr_number} already exists',
  CONSIGNMENT_NOT_FOUND_AND_SAVE_LR: 'Consignment not found from tracking response, Continue and save as Lr',
  CONSIGNMENT_NOT_VALID_WARNING_MSG: 'Consignment number is not valid. Enter the correct consignment number to begin tracking',

  // order statuses
  INDENT_ALL_STATUSES: 'All Statuses',
  INDENT_DRAFT_STATUS: 'Draft',
  INDENT_DRAFT_DELETED_STATUS: 'Draft Deleted',
  INDENT_INDENTED_STATUS: 'Indented',
  INDENT_TRANSPORTER_REJECTED_STATUS: 'Transporter Rejected',
  INDENT_ACCEPTED_STATUS: 'Accepted',
  INDENT_REJECTED_STATUS: 'Rejected',
  INDENT_SLA_BREACH_STATUS: 'SLA Breach',
  INDENT_ASSIGNED_STATUS: 'Assigned',
  INDENT_REPORTED_STATUS: 'Reported',
  INDENT_ARRIVED_STATUS: 'Arrived',
  INDENT_INSPECTION_REJECTED_STATUS: 'Inspection Rejected',
  INDENT_LOAD_STARTED_STATUS: 'Load Started',
  INDENT_LOAD_ENDED_STATUS: 'Load Ended',
  INDENT_DISPATCHED_STATUS: 'Dispatched',
  INDENT_DELIVERED_STATUS: 'Delivered',
  INDENT_DELIVERY_PENDING_STATUS: 'Delivery Pending',
  INDENT_CANCELLED_STATUS: 'Cancelled',
  OPTIMA_SUGGESTED: 'Optima Suggested',
  INDENT_REQUESTED_STATUS: 'Requested',
  INDENT_CONTAINER_PICKED_STATUS: 'Container Picked',
  INDENT_UNLOADING_REPORTED_STATUS: 'Unloading Reported',
  INDENT_REPORTED_AT_DESTINATION_STATUS: 'Reported at Destination',
  INDENT_UNLOADING_STARTED_STATUS: 'Unloading Started',
  INDENT_SHIP_READY_STATUS: 'Ship Ready',
  INDENT_SHIPPED_STATUS: 'Shipped',
  INDENT_CANCEL_STATUS: 'Cancel',
  INDENT_TRUCK_CHANGE_REQUESTED_STATUS: 'Truck Change Requested',
  INDENT_LOADING_STARTED_STATUS: 'Loading Started',
  INDENT_LOADING_ENDED_STATUS: 'Loading Ended',
  INDENT_ASSIGNMENT_DUE_STATUS: 'Assignment Due',
  INDENT_ACCEPTANCE_DUE_STATUS: 'Acceptance Due',
  INDENT_ARRIVAL_DUE_STATUS: 'Arrival Due',
  INDENT_DEL_PENDING_STATUS: 'Del Pending',
  INDENT_CTR_PICKED_STATUS: 'CTR Picked',

  INDENT_ALL_MOVEMENT_TYPES: 'All Movement Types',
  INDENT_SECONDARY: 'Secondary',
  INDENT_PRIMARY: 'Primary',
  INDENT_VENDOR: 'Vendor',
  INDENT_RETURNS: 'Returns',

  INDENT_NOT_AVAILABLE: 'Not available',
  INDENT_AVAILABLE: 'Available',

  INDENT_EX_WORKS: 'EX-Works',
  INDENT_PARTY_COLLECT: 'Party Collect',

  INDENT_DONT_ADD_INVOICE: 'Don’t add to Invoice',
  INDENT_ADD_INVOICE: 'Add to Invoice',

  INDENT_ALL_CHECKS: 'All Checks',
  INDENT_CHECK: 'Check',
  INDENT_PROCESSED: 'Processed',
  INDENT_RETURNED: 'Returned',

  INDENT_OUTBOUND: 'Outbound',
  INDENT_INBOUND: 'Inbound',

  INDENT_PTL: 'PTL',
  INDENT_FTL: 'FTL',

  INDENT_ALL_INDENT_TYPES: 'All Indent Types',
  INDENT_ALL_DELIVERY_TYPES: 'All Delivery Types',

  INDENT_CONTRACT: 'Contract',
  INDENT_OPEN: 'Open',
  INDENT_NO_FREIGHT: 'No Freight',
  INDENT_MARKET: 'Market',
  INDENT_CONTRACT_QUOTE: 'Contract Quote',

  INDENT_BLACKLIST: 'Blacklist',
  INDENT_UNBLACKLIST: 'Unblacklist',

  INDENT_TRANSPORTER_REF_ID: 'Transporter Ref id',
  INDENT_TRANSPORTER_ID: 'Transporter id',
  INDENT_IN_REF_ID: 'in Ref id',
  INDENT_TRANSPORTER_NAME: 'Transporter Name',
  INDENT_IN_NAME: 'in Name',
  INDENT_CONSIGNEE_REF_ID: 'Consignee Ref id',
  INDENT_DROP_OFF_DEPOT_NAME: 'Drop off depot Name',
  INDENT_DROP_OFF_DEPOT_REF_ID: 'Drop off depot Ref id',
  INDENT_CONSIGNMENT_NO: 'Consignment no',
  INDENT_MATERIAL_INVOICE_NO: 'Material invoice no',
  INDENT_IN_CONSIGNMENT_NO: 'in Consignment no',
  INDENT_IN_MATERIAL_INVOICE_NO: 'in Material invoice no',
  INDENT_REF_ID: 'Ref Id',
  INDENT_IN_MATERIAL_CODE: 'in Material code',

  INDENT_REJECTIONS: 'Rejections',
  INDENT_BULK_UPLOAD: 'Indent Bulk Upload',
  INDENT_DIRECT_DELIVERY_INDENT_BULK_UPLOAD:
    'Direct Delivery Indent Bulk Upload',
  INDENT_GRN_BULK_UPLOAD: 'GRN Bulk Upload',

  INDENT_POD_BULK_UPLOAD: 'POD Bulk Upload',
  INDENT_MATERIAL_BULK_UPLOAD: 'Material Bulk Upload',
  INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD: 'Material Invoice Grn Bulk Upload',
  INDENT_MATERIAL_DELETE_UPLOAD: 'Material Delete Bulk Upload',
  INDENT_DIRECT_DISPATCH_BULK_UPLOAD: 'Direct Dispatch Bulk Upload',
  CHARGEABLE_WEIGHT_BULK_UPLOAD: 'Chargeable Weight Bulk Upload',
  INDENT_ADD: 'Add',
  INDENT_ADD_INBOUND: 'Add Inbound',
  INDENT_GENERATE_MANIFEST: 'Generate Manifest',
  LR_BULK_UPLOAD: 'Lr Bulk Upload',

  INDENT_DEPOT: 'DEPOT',
  INDENT_CREATION_DATE: 'Creation Date',
  INDENT_VEHICLE_REQUIREMENT_DATE: 'Vehicle Requirement Date',
  INDENT_INDENT_TYPE: 'Indent Type',
  INDENT_MOVEMENT: 'Movement',
  INDENT_DELIVERY_TYPE: 'Delivery Type',
  INDENT_UTILIZATION_CHECK: 'Utilization Check',
  MATERIAL_PRIORITY: 'Material Priority',
  INDENT_ALL_MATERIAL_PRIORITY: 'All Material Priorities',

  INDENT_DOCUMENTS: 'Documents',
  INDENT_SAVE: 'Save',
  INDENT_UPLOAD: 'UPLOAD',
  INDENT_DOWNLOAD: 'DOWNLOAD',
  INDENT_RETRIGGER_EPOD: 'Re-trigger EPOD',
  INDENT_APPROVE: 'APPROVE',
  INDENT_MATERIAL_EPOD: 'Materials + EPoD',
  INDENT_FREIGHT_BIFURCATION: 'Freight Bifurcation',
  INDENT_FREIGHT_CALCULATION: 'Freight Calculation',
  INDENT_3D_VISUALIZATION: '3D Visualization',
  INDENT_NO_DOCUMENT_DATA: 'No Data found for the indent',
  INDENT_TRUCK_OVERLOADED_BY: 'Truck overloaded By',
  INDENT_KG: 'KG',
  INDENT_CFT: 'CFT',
  INDENT_ORIGINAL_TRUCK_WEIGHT: 'Original Truck Weight',
  INDENT_ORIGINAL_TRUCK_VOLUME: 'Original Truck Volume',
  INDENT_OTP_SUBMIT_SUCCESS: 'OTP sucessfully submitted for consignee',
  INDENT_SHIP_TO: 'Ship To',
  INDENT_SOLD_TO: 'Sold To',
  INDENT_TRANSPORTER_MOBILE_NUMBER: 'Transporter Mobile No',
  INDENT_DRIVER_MOBILE_NO: 'Driver Mobile No',
  INDENT_ENTER_OTP: 'ENTER OTP',
  INDENT_OTP_SUBMITTED: 'OTP Submitted',
  INDENT_OTP_ENTER_FOR_GRN_RELEASE: 'Enter OTP to confirm GRN Release',
  INDENT_RESEND_OTP: 'Resend OTP OTP',
  INDENT_CANCEL: 'Cancel',
  INDENT_RESHIP: 'Re-ship',
  INDENT_SUBMIT: 'Submit',
  INDENT_VALIDATE: 'Validate',
  INDENT_CONFIRM: 'Confirm',
  INDENT_CHARGE_WEIGHT: 'Charge Wt',
  ACTUAL_INDENT_WEIGHT: 'Actual Wt',
  ACTUAL_INDENT_VOLUME: 'Actual Vl',
  ACTUAL_INDENT_QUANTITY: 'Actual Qt',
  INDENT_WEIGHT: 'Wt',
  INDENT_VOLUME: 'Vl',
  INDENT_QUANTITY: 'Qt',
  INDENT_NUMBER_OF_CARTON: 'No. of Carton',
  INDENT_INVOICE_VALUE: 'Invoice Value',
  INDENT_INR: 'INR',
  INDENT_NO_MATERIAL_UPLOADED: 'No Materials Uploaded',
  INDENT_ENTER_LR_NUMBER: 'Enter LR number',
  INDENT_ENTER_MATERIAL_INVOICE_LR: 'Enter Material Invoice LR Number',
  INDENT_LOAD_PLAN: 'Load plan',
  INDENT_LOAD_PLAN_3D: '3D Load plan',
  INDENT_EDIT_LR: 'Edit LR',
  INDENT_VIEW_LR: 'View LR',
  INDENT_CONSIGNMENT_NUMBER: 'Consignment Number',
  INDENT_ENTER_CONSIGNMENT_NUMBER: 'Enter Consignment Number',
  INDENT_EDIT_CONSIGNMENT_NUMBER: 'Edit Consignment Number',
  INDENT_ENTER_HERE: 'Enter Here',
  INDENT_ADD_DELIVERY_NUMBERS: 'Add Delivery Numbers',
  INDENT_GATE: 'Gate',
  INDENT_DIVISION: 'Division',
  INDENT_BUSINESS_DIVISION: 'Business Division',
  INDENT_NO_DATA_FOUND: ' No data found',
  INDENT_TOTAL: 'Total',
  INDENT_RUPEES: 'Rs',
  INDENT_CODE: 'Code',
  INDENT_NAME: 'Name',
  INDENT_ACTUAL_QUANTITY: 'Actual Quantity',
  INDENT_BILLED_QUANTITY: 'Billed Quantity',
  INDENT_COST_CENTER: 'Cost Center',
  INDENT_COST: 'Cost',
  INDENT_NO_VISUALISATION: 'No Visualization data available',
  INDENT_FREIGHT_CHANGE_REQUEST: 'Freight Change Request',
  INDENT_INDENTED_FREIGHT_RATE_AND_UNIT: 'Indent Freight Rate/Unit',
  INDENT_REQUESTED_FREIGHT_CHANGE_REQUESTED: 'Requested Freight Rate/Unit',
  INDENT_SHORTAGES: 'Shortages',
  INDENT_DAMAGES: 'Damages',
  INDENT_CARTON_DAMAGES: 'Carton Damages',
  INDENT_DISTANCE: 'Distance',
  INDENT_CONTRACT_RATE: 'Contract Rate/ Type',
  INDENT_MULTIPLYING_FACTOR: 'Multiplying Factor',
  INDENT_FREIGHT_AMOUNT: 'Freight Amount',
  INDENT_SUM_COST: 'Sum Cost',
  INDENT_CALCULATION: 'Calculation',
  INDENT_VOLUME_CFT: 'Volume(CFT)',
  INDENT_WEIGHT_KG: 'Weight(KG)',
  INDENT_ALL_TRANSPORTER: 'All Transporters',
  INDENT_GRN_REJECT: 'GRN Reject',
  INDENT_GRN_APPROVE: 'GRN Approve',
  INDENT_REJECTION_REASON: 'Rejection Reason',
  INDENT_REJECT_EPOD: 'Reject Shortage/Damage/Carton Damage',
  INDENT_EPOD_DESCRIPTION: 'Are you sure you want to reject Shortage/Damage/Carton Damage values for this indent?',
  INDENT_EPOD_ADD_REASON: 'Add Reason for rejection if sure.',
  INDENT_EPOD_CONFIRM: 'Confirm',
  INDENT_EPOD_CANCEL: 'Cancel',
  INDENT_DAMAGE_REJECT: 'S/D/CD VALUES REJECTED',
  INDENT_TRIGGER_ZPOD: 'Indent Sync',
  INDENT_LR_NOT_AVAILABLE: 'LR Number does not Exist',
  INDENT_MATERIAL_INV_NOT_AVAILABLE: 'Material Invoice not Available',
  INDENT_ZPOD_TRIGGERED: 'ZPOD TRIGGERED SUCCESSFULLY',
  INDENT_NO_OF_MATERIALS: 'Number of Materials',
  INDENT_ENTER_MATERIAL_COUNT: 'Enter number of materials',
  INDENT_ENTER_MATERIAL_VOLUME: 'Enter material volume',
  INDENT_ENTER_MATERIAL_WEIGHT: 'Enter material weight',

  // Pay Anomaly
  INDENT_CHARGE_LEVEL_ANOMALIES: 'Charge Level Anomalies',
  INDENT_APPROVE_PAYMENT_GENERATION: 'Approve Payment Generation',
  INDENT_ANOMALY_TYPE: 'Anomaly Type',
  INDENT_ACTUAL: 'Actual',
  INDENT_VARIANCE: 'Variance',
  INDENT_PAY_ANOMALY: 'Pay Anomaly',

  // Indent Details
  INDENT_SHIPPED_FROM: 'Shipped From',
  INDENT_SHIPPED_TO: 'Shipped To',
  INDENT_CARRIER_TYPE: 'Carrier Type',
  INDENT_SHIP_METHOD: 'Ship Method',
  INDENT_WEIGHT_IN_DATE_AND_TIME: 'Weigh In Date & Time',
  INDENT_WEIGHT_OF_VEHICLE_KG: 'Weight of Vehicle(KG)',
  INDENT_WEIGHT_OUT_DATE_AND_TIME: 'Weigh Out Date & Time',
  INDENT_VEHICLE_WEIGHT_AT_WEIGH_IN: 'Vehicle Weight at Weigh in',
  INDENT_VEHICLE_WEIGHT_AT_WEIGH_OUT: 'Vehicle Weight at Weigh out',
  INDENT_ADD_RETURN: 'Add Return',
  INDENT_UPDATE_TRUCK_TYPE: 'UPDATE TRUCK TYPE',
  INDENT_RETRY_MODIFIED_PICKLIST: 'RETRY MODIFIED PICKLIST',
  INDENT_EDIT: 'Edit',
  INDENT_CANCEL_DRAFT: 'Cancel Draft',
  INDENT_CLONE: 'CLONE',
  INDENT_YES: 'Yes',
  INDENT_NO: 'No',
  INDENT_COMMENT: 'COMMENT',
  INDENT_REFERENCE_ID: 'Reference Id',
  INDENT_LOADERS: 'Loaders',
  INDENT_PAID_BY: 'Paid by',
  INDENT_UNLOADERS: 'Unloaders',
  INDENT_PACK_QUANTITY: 'Pack Qty',
  INDENT_PINCHEMS_CODE: 'Pinchems code',
  INDENT_GROSS_WEIGHT: 'Gross WT',
  INDENT_DIMENSIONS: 'DIM (DM)',
  INDENT_CARTON_TYPE: 'Carton Type',
  INDENT_HAZ_TYPE: 'Hazardous',
  INDENT_VOLUME_TYPE: 'Volume',
  INDENT_BOX: 'Box',
  INDENT_CLASS: 'Class',
  INDENT_HILLY_ROUTE: 'Hilly Route',
  INDENT_LR_ATTACHMENT_MISSING: 'LR attachment missing',
  INDENT_NOTE: 'Note',
  INDENT_REPORTED_POD_TIME_DEFAULTS_TO_GEO_FENCE_TIME: 'Reported and POD time defaults to geo-fenced time',

  INDENT_SOURCE_DEPOT: 'Source Depot',
  INDENT_GROUPED_INDENTS: 'Grouped Indents',
  INDENT_ASSIGN_VEHICLE: 'Assign Vehicle',
  INDENT_REMOVE_FROM_AUTO_GROUP: 'Remove from Auto-group',
  INDENT_REMOVED_AUTO_GROUP_CONFIRM_MSG: 'This indent will be removed from the auto-group. Do you want to confirm?',

  INDENT_NO_DOCUMENT_GENERATED: 'No Documents Generated',
  INDENT_SHIPMENT_DOCUMENTS: 'Shipment Documents',
  INDENT_CARTON_DOCUMENTS: 'Carton Documents',
  INDENT_ITEM_DOCUMENTS: 'Item Documents',
  INDENT_NOT_GENERATED: 'Not Generated',
  INDENT_PRINT_SELECTED: 'Print Selected',

  INDENT_CANCEL_INDENT: 'Cancel Indent',
  INDENT_ADD_CANCELLATION_REASON: 'Add reason for cancellation if sure.',
  INDENT_CANCELLATION_PROMPT:
    'Are you sure you want to cancel Indent #{order_number}?',
  INDENT_DETAILS: 'Details',
  INDENT_TIMELINE: 'Timeline',
  INDENT_FREIGHT_CHARGES: 'Freight Charges',
  INDENT_OTHER_INFORMATION: 'Other Information',

  INDENT_INDENT_TIMELINE: 'Indent Timeline',
  INDENT_RFQ_REMARK: 'RFQ Remark',
  INDENT_CONSIGNMENT_STATUS_TIMELINE: 'Consignment Status Timeline',
  INDENT_LR_STATUS_TIMELINE: 'LR Status Timeline',
  INDENT_APPROVAL_TIMELINE: 'Approval Timeline',
  INDENT_TRACKING_NUMBER: 'Tracking Number',
  INDENT_NO_CONSIGNMENT_NUMBERS:
    'No consignment numbers are available to track.',
  INDENT_INVALID_CONSIGNMENT_NUMBER:
    'Verify that correct consignment numbers have been added on the LR+EPOD page to begin tracking.',
  INDENT_INDENT_CREATED: 'Indent Created',
  INDENT_SCHEDULED_SHIPPING_DATE: 'Scheduled Shipping date',
  INDENT_NO_EXIST: 'No Exist',
  INDENT_VEHICLE_CHECK_AT_ASSIGN: 'Entered Vehicle Number {vehicleNo} is already used in the indent {indentNo} which is still not delivered. Are you sure to continue ?',
  TRUCK_DETAINED_CHECK: 'Truck was detained more than {n} days. Please confirm',
  INDENT_TRIP_EXIST_CHECK_AT_ASSIGN: 'There is an active Indent {indentNo} being tracked for the entered vehicle/mobile number.Are you sure to end the previous trip?',
  INDENT_VEHICLE_CHANGED: 'Vehicle Changed',
  INDENT_GATE_OR_DESTINATION_DELETION: 'Gate/Destination Deletion',
  INDENT_ALL_CONSIGNMENT_DELIVERED: 'All Consignments Delivered',
  INDENT_VEHICLE_TYPE_CHANGED: 'Vehicle Type Changed',
  INDENT_RFQ_ACCEPTED: 'Request for Quote Accepted',
  INDENT_ALLOCATED_TO: 'Allocated to {name} - {refId}',
  INDENT_INDENT_CANCELLED: 'Indent Cancelled',
  INDENT_CONSIGNEE_REPORTED: 'Consignee Reported',
  INDENT_CONSIGNEE_RELEASED: 'Consignee Released',
  INDENT_CONSIGNEE_UNLOADING_STARTED: 'Consignee Unloading Started',
  INDENT_CONSIGNEE_UNLOADING_ENDED: 'Consignee Unloading Ended',
  INDENT_CONSIGNEE_MISSED_CALL: 'Consignee_missedcall',
  INDENT_TRANSPORTER_CHANGE_HISTORY: 'New Transporter Allocated',
  INDENT_TRANSPORTER_UPDATED_BY: 'Updated by {updatedBy}',
  INDENT_VEHICLE_NO_CHANGE_HISTORY: 'Vehicle Number Changed to',
  INDENT_VEHICLE_TYPE_CHANGE_HISTORY: 'Vehicle Type Changed to',
  INDENT_VEHICLE_TYPE_APPROVE:'Vehicle Type Change Approved & Changed to ',
  INDENT_VEHICLE_TYPE_REQUEST:'Vehicle Type Change Request for ',
  INDENT_VEHICLE_TYPE_APPROVED_BY:'Approved by {updatedBy}',
  INDENT_VEHICLE_TYPE_REQUESTED_BY:'Requested by {updatedBy}',
  INDENT_REJECTION_TRUCK: 'Rejection Truck',
  INDENT_CARRIER_BOOKING_CANCELLED: 'Carrier booking cancelled',
  INDENT_CARRIER_BOOKING_CANCELLED_FOR_TRACKING_NUMBER:
    'Carrier booking cancelled for tracking number {tracking_number}',
  INDENT_ARRIVED_AT_GATE: 'Arrived at {gate_name}',
  INDENT_START_LOADING_AT_GATE: 'Started loading at {gate_name}',
  INDENT_END_LOADING_AT_GATE: 'End loading at {gate_name}',
  INDENT_START_LOADING_AT_GATE_FOR_DOCKS: 'Started loading for {dock} at {gate_name}',
  INDENT_END_LOADING_AT_GATE_FOR_DOCKS: 'End loading for {dock} at {gate_name}',
  INDENT_DISPATCHED_AT_GATE: 'Dispatched at {gate_name}',
  INDENT_VEHICLE_ASSIGNED: 'Vehicle Assigned',
  INDENT_SLA_BREACH: 'SLA Breach',
  INDENT_INDENT_REJECTED_BY: 'Indent Rejected By',
  INDENT_ASSIGNED_TO_TRANSPORTER: ' assigned to {transporter_name} transporter',
  INDENT_REJECTED_AND_INDENT: '{transporter_name} is rejected and Indent',
  INDENT_INSPECTION_ACCEPTED: 'Inspection Accepted',
  INDENT_INSPECTION_REJECTED: 'Inspection Rejected',
  INDENT_REJECTED: 'Indent Rejected',
  INDENT_TRANSPORTER_HAS_REJECTED: '{transporter_name} has rejected the indent',
  INDENT_SELECTED_DOCKS: 'Selected Docks',
  INDENT_SELECT_DOCKS: 'Select Docks',
  INDENT_SELECT_DOCK: 'SELECT DOCK',
  INDENT_VEHICLE_NO: 'Vehicle No',
  INDENT_ENTER_VALID_VEHICLE_NO: 'Please enter a valid vehicle number',
  INDENT_QUOTE_REJECTION: 'Reject Quote Approval?',
  INDENT_QUOTE_REJECTION_REASON: 'Please add reason for rejection of selected quote',
  INDENT_CHASIS_NUMBER: 'CHASIS NUMBER',
  INDENT_ENGINE_NUMBER: 'ENGINE NUMBER',
  INDENT_INSURANCE_VALID_TILL: 'INSURANCE VALID TILL',
  INDENT_FITNESS_CERTIFICATE: 'FITNESS CERTIFICATE',
  INDENT_PHONE_NUMBER: 'PHONE NUMBER',
  INDENT_DRIVER_NAME: 'DRIVER NAME',
  INDENT_DRIVER_NO: 'Driver No',
  INDENT_VEHICLE_INSPECTION: 'Vehicle Inspection',
  INDENT_VEHICLE_INSPECTION_AT_SOURCE: 'Vehicle Inspection At Source',
  INDENT_VEHICLE_INSPECTION_AT_DESTINATION: 'Vehicle Inspection At Destination',
  INDENT_LICENSE_NUMBER: 'LICENSE NUMBER',
  INDENT_DRIVER_DOB: 'DRIVER DOB',
  INDENT_ENTER_VALID_MOBILE_MSG: 'Please enter a valid mobile number',
  INDENT_PICK_DATE: 'Pick a date',
  INDENT_EWB_EXPIRY_DATE: 'EWB expiry date',
  INDENT_EWB_NO: 'EWB no.',
  INDENT_ENTER_VALUE_HERE: 'enter value here',
  INDENT_VEHICLE_NUMBER_REQUIRED_MSG: 'Vehicle number is required',
  INDENT_MOBILE_NUMBER_REQUIRED_MSG: 'Mobile number required',
  INDENT_ENABLE_SIM_TRACKING: 'ENABLE SIM TRACKING',
  INDENT_RESEND_CONTENT_SMS: 'RESEND CONSENT SMS',
  INDENT_CONTAINER_NUMBER: 'CONTAINER NUMBER',
  INDENT_LINE_SEAL_NUMBER: 'LINE SEAL NUMBER',
  INDENT_SEAL_NUMBER: 'Seal Number',
  INDENT_IS_SEAL_NUMBER_INTACT:'Is Seal Number Intact ?',

  INDENT_CONTAINER_PICKUP_SUCCESS_MSG: 'Container pickup successful',
  INDENT_CONTAINER_PICKUP_ERROR_MSG: 'Container picked for indent failed',
  INDENT_TRUCK_IN_DATE_TIME: 'Truck In- Date & Time',
  INDENT_TRUCK_OUT_DATE_TIME: 'Truck Out- Date & Time',
  INDENT_ARRIVAL_LESSER_DISPATCH_ERROR_MSG:
    'Arrival time should be lesser than Dispatch time',
  INDENT_EMPTY_CTR_RETURN_ERROR_MSG: 'Empty container returned failed',
  INDENT_EMPTY_CTR_RETURN_SUCCESS_MSG:
    'Empty container returned for {order_number}',
  INDENT_ENTER_DATE: 'Enter date here',
  INDENT_LOADING_ENDED_SUCCESS_MSG: 'Loading ended for order {order_number} on {loading_date} at {loading_time}',
  INDENT_EWAY_BILL_COPY: 'E-way bill copy',
  INDENT_EWAY_BILL_ERROR_MSG: 'E-way bill submit failed',
  INDENT_EWAY_BILL_SUCCESS_MSG: 'Eway bill submitted for {order_number}',

  INDENT_FREIGHT_TYPE: 'Freight type',
  INDENT_REASON_FREIGHT_RATE: 'Reason For Freight rate',
  INDENT_ATTACHMENT: 'Attachment',

  INDENT_VEHICLE_CHECK: 'VEHICLE CHECK',
  INDENT_DOCUMENTS_CHECK: 'DOCUMENTS CHECK',
  INDENT_INSPECTION_DOCUMENTS: 'INSPECTION DOCUMENTS',
  INDENT_INSPECTION_ATTACHMENT: 'INSPECTION ATTACHMENT',
  INDENT_INSPECTION: 'INSPECTION',

  INDENT_REASON_REJECTING_VEHICLE:
    'Please enter a reason for rejecting the vehicle',
  INDENT_VEHICLE_NUMBER_BLACKLISTED: 'Vehicle number blacklisted',
  INDENT_DRIVER_NUMBER_BLACKLISTED: 'Driver number blacklisted',

  INDENT_REJECT: 'Reject',
  INDENT_ACCEPT: 'Accept',

  INDENT_TRIP_NOT_ACCEPTED: 'Trip is yet to be created for tracking',
  INDENT_ACCEPT_TRUCK_PROMPT: 'Are you sure you want to accept the truck?',
  INDENT_INSPECTED_ACCEPTANCE: 'Inspection Acceptance',
  INDENT_INSPECTION_ERROR_MSG: 'Inspection save failed for {order_number}',
  INDENT_REJECT_TRUCK_PROMPT: 'Are you sure you want to reject the truck?',
  INDENT_INSPECTED_REJECTION: 'Inspection Rejection',
  INDENT_REPORTED_AFTER_DISPATCHED_ERROR_MSG:
    'Reported time should be after dispatched',
  INDENT_RELEASE_AFTER_DISPATCHED_ERROR_MSG:
    'Release time should be after dispatched',
  INDENT_RELEASE_AFTER_REPORTED_ERROR_MSG:
    'Release time should be after reported',
  INDENT_REPORTED_RELEASE_FUTURE_TIME_ERROR_MSG:
    'Reported/Release cannot have future time',
  INDENT_UNLOADING_END_BTWN_UNLOADING_START_RELEASE: 'Unloading end time should be between unloading start and release time',
  INDENT_UNLOADING_START_BTWN_REPORTED_RELEASE: 'Unloading start time should be between reported and release time',
  INDENT_UNLOADING_END_ERROR_MSG: 'Unloading end time should be between unloading start and release time',

  INDENT_REPORTED_AT: 'REPORTED AT',
  INDENT_UNLODING_START_AT: 'UNLOADING START AT',
  INDENT_UNLOADING_END_AT: 'UNLOADING END AT',
  INDENT_POD_DATE: 'POD DATE',
  INDENT_EXPECTED_DATE: 'Expected Date',
  INDENT_EXPECTED_DATE_TIME: 'Expected Date and Time',
  INDENT_SELECT: 'Select',
  INDENT_UPDATE_SUCCESS_MSG: 'Update is successful',
  INDENT_PREVIOUSLY_ACCEPTED_QUOTES: 'Previously Accepted Quotes',
  INDENT_CURRENT_ACTIVE_CONTRACTS:'CURRENT ACTIVE CONTRACTS',
  INDENT_EDIT_CONSIGNEE: 'Edit Consignee',
  INDENT_TRUCK_REPORT_CONFIRMATION:
    'Are you sure you want to report the truck?',
  INDENT_TRUCK_REPORTING: 'Truck Reporting',
  INDENT_TRUCK_DETAILS: 'Truck details',
  INDENT_ENABLE_SIM_TRACK: 'Enable sim tracking in truck details tab.',
  INDENT_TRACK_AFTER_TRUCKIN: 'Tracking will be enabled after Truckin.',
  INDENT_TRACK_AFTER_DISPATCH: 'Tracking will start after dispatch.',

  INDENT_TRANSPORTERS: 'TRANSPORTERS',
  INDENT_BASE_QUOTE: 'Base Quote',
  INDENT_FREIGHT_QUOTE: 'Freight Quote',
  INDENT_FREIGHT_UNIT: 'Freight Unit',
  INDENT_FREIGHT_RATE: 'Freight rate',
  INDENT_CHOOSE_FREIGHT_UNIT: 'Choose Freight Unit',
  INDENT_REQUEST_FOR_QUOTE: 'REQUEST FOR QUOTE',
  INDENT_OPEN_INDENT: 'OPEN INDENT',
  INDENT_REMARKS: 'REMARKS',
  INDENT_REMARKS_ADDED: 'Remarks Added',
  INDENT_ENTER_REMARKS: 'Enter Remarks',
  INDENT_NO_VIEW_TRANSPORTER_QUOTES_PERMISSION:
    'You do not have permission to view or accept transporter quotes',
  INDENT_REASON: 'Reason',
  INDENT_REJECT_ALL: 'REJECT ALL',
  INDENT_SEND_FOR_APPROVAL: 'SEND FOR APPROVAL',
  INDENT_BID_IN_PROGRESS: 'Bid in Progress',
  INDENT_BID_EXPIRED: 'Bid Expired',
  INDENT_BID_EXPIRY: 'Bid Expiry',
  INDENT_DECREMENT: 'Decrement',
  INDENT_TRANSPORTER_YET_TO_RESPOND: 'Transporter yet to respond',
  INDENT_ALREADY_ACCEPTED: 'Already Accepted',
  INDENT_SHIPPER_REJECTED: 'Rejected by Shipper',
  INDENT_TRANSPORTER_REJECTED: 'Rejected by Transporter',
  INDENT_UPDATED_SUCCESS_MSG: 'Indent updated',
  INDENT_TRANSPORTER_ASSIGNED_SUCCESS_MSG : 'Transporter assigned successfully',
  INDENT_TRANSPORTER_ASSIGNMENT: 'Transporter assigned successfully since approval setting is not available for the selected quote.',

  INDENT_TRIP_ID_NOT_AVAILABLE: 'trip id not available',
  INDENT_LOAD_MAP_ERROR_MSG: 'Unable to load map',
  INDENT_OPERATOR: 'Operator',
  INDENT_DETAILED_TRACK: 'Detailed Track',

  INDENT_INDENTED_VEHICLE: 'INDENTED VEHICLE',
  INDENT_CHANGE_REQUESTED: 'CHANGE REQUESTED',
  INDENT_COMMENTS: 'Comments',
  INDENT_ACCEPT_HILLY_REQUEST: 'Accept Hilly Route Request',
  INDENT_CONTINUE: 'CONTINUE',
  INDENT_DELETE_DROPOFF: 'Delete Drop-Off',
  INDENT_SWITCH_SOLD_TO: 'Switch Sold-To',

  INDENT_SELECT_GATE: 'SELECT GATE',
  INDENT_SELECT_GATES: 'SELECT GATES',
  INDENT_DATE: 'Date',
  INDENT_EDD_DATE: 'EDD Date',
  INDENT_FIND_A_TRANSPORTER: 'FIND A TRANSPORTER',
  INDENT_REJECTED_TRANSPORTER: 'Rejected Transporter',
  INDENT_INDENT_TO_YOUR_TRANSPORTERS: 'INDENT TO YOUR TRANSPORTERS',

  INDENT_VEHICLE_CHANGED_TO: 'VEHICLE changed to',
  INDENT_CONTINUE_SAME_VEHICLE: 'Continue with same vehicle',
  INDENT_CHANGE_VEHICLE_TYPE: 'Change vehicle type',
  INDENT_VEHICLE_DETAILS: 'Vehicle Details',
  INDENT_MATERIAL_DETAILS: 'material Details',
  INDENT_UTILIZATION: 'Utilization',
  INDENT_SEND: 'Send',
  INDENT_CONFIRMATION: 'Confirmation',
  FREIGHT_RATE_CONFIRMATION_MSG: 'You have entered base freight {freight_rate} with freight unit {freight_unit}',
  DO_YOU_WANT_TO_PROCEED: 'Do you want to proceed?',
  INDENT_UNABLE_PROCESS_ERROR_MSG: 'Unable to process',
  INDENT_CONTRACT_LOADING_ERROR_MSG: 'Contract loading issues!Please try after some time',
  INDENT_CONTRACT_NOT_FOUND_PROMPT: 'Contracts are not found for the consignments!',
  INDENT_SWITCH_TO_OPEN: 'Switch to Open Indent',
  INDENT_SWITCH_OPEN: 'Switch To Open',
  INDENT_SWITCH_TO_RFQ: 'Switch To RFQ',
  INDENT_CHOOSE_TRANSPORTERS: 'CHOOSE TRANSPORTERS',
  INDENT_SELECTED_TRANSPORTERS: 'SELECTED TRANSPORTERS',
  INDENT_NO_TRANSPORTER_SELECTED: 'No Transporters Selected',
  INDENT_NO_CONTRACTS: 'No contracts',
  INDENT_VENDOR_DEPOT: 'Vendor depot',
  INDENT_CONSIGNEE: 'Consignee',
  INDENT_ENTER_VEHICLE_NUMBER: 'Enter vehicle number',

  INDENT_UTILIZATION_SUCCESS_MSG:
    'Vehicle Utilization request has sent for indent {order_number}',
  INDENT_UTILIZATION_SENT_SUCCESS_MSG:
    'Vehicle Utilization request has {message} for indent {order_number}',
  INDENT_UTILIZATION_UPDATE_SUCCESS_MSG:
    'Vehicle Utilization request has updated for indent {order_number}',
  INDENT_DROP_OFF: 'Drop-Off',
  INDENT_BUILD_INDENT: 'Add Source, pickups and drop-offs to build an Indent',
  INDENT_ADD_PICKUP: 'Add Pickup',
  INDENT_CLICK_ADD_PICKUP: 'Click here to add a pickup',
  INDENT_LIKELY_CONGESTION: 'Likely Congestion',
  INDENT_SAME_VRD_PROMPT_MSG: 'Are you sure you want to create Indent with same vehicle requirement date?',
  INDENT_VEHICLE_CONGESTION_MSG: 'Vehicle will arrive at {name} on {time}, which is likely to cause congestion.',
  INDENT_SOURCE: 'Source',
  INDENT_DELETE_SOURCE: 'Delete Source',
  INDENT_DELETE: 'Delete',
  INDENT_DELETE_GATE: 'Delete Gate',
  INDENT_SELECT_SOURCE: 'Select Source',
  INDENT_ADD_SOURCE_LOCATION: 'Add Source location',
  INDENT_ADDITIONAL_SOURCE: 'Additional Source',
  INDENT_CLICK_TO_ADD: 'Click here to add',
  INDENT_DELETE_SOURCE_CONFIRM_MSG: 'Are you sure you want to delete the Source',
  INDENT_SEARCH_NAME_CITY_ID: 'Search by {label} Name, city or ID',
  INDENT_LABEL_NAME: '{label} Name',
  INDENT_LABEL_NAME_REF_ID: '{label} Name & Ref ID',
  INDENT_LABEL_CITY: '{label} City',
  INDENT_LABEL_ID: '{label} ID',
  INDENT_SELECT_DROP_OFFS: 'Select Drop-off(s)',
  INDENT_CHANGE_SOLD_TO: 'Change sold to',
  INDENT_NEW_CONSIGNEE: 'New Consignee',
  INDENT_SELECTED_DROPOFFS: 'Selected Drop-offs',
  INDENT_NO_DROPOFFS_SELECTED: 'No drop-offs selected',

  INDENT_ENABLE_RFQ: 'Enable RFQ',
  INDENT_PANDO_NETWORK_TRANSPORTER: 'Pando network transporter',
  INDENT_NO_OF_VEHICLES: 'No. of vehicles',
  INDENT_TRANSIT_DAYS: 'Transit Days',
  INDENT_TOTAL_PICKUPS: 'Total Pickups',
  INDENT_ENTER_CONSIGNEE_NAME: 'Enter Consignee Name',
  INDENT_ENTER_REF_ID: 'Enter Ref id',
  INDENT_ENTER_ADDRESS: 'Enter Address',
  INDENT_ENTER_REGION: 'Enter Region',
  INDENT_ENTER_CITY_NAME: 'Enter city name',
  INDENT_ENTER_STATE_NAME: 'Enter state name',
  INDENT_ENTER_PIN_CODE: 'Enter Pin code',
  INDENT_ENTER_EMAIL_ADDRESS: 'Enter Email Address',
  INDENT_EMAIL_ADDRESS: 'Email Address',
  INDENT_CITY: 'City',
  INDENT_STATE: 'State',
  INDENT_REGION: 'Region',
  INDENT_PINCODE: 'Pincode',
  INDENT_ADDRESS: 'Address',
  INDENT_SEARCH: 'Search',
  INDENT_PICK_ATLEAST_TWO: 'Pick at least two',
  DELIVERY_EXCEPTION: 'Delivery Exception',
  INDENT_LOADING_FUTURE_ERROR: 'Selected time cannot be in the future',
  INDENT_LOADING_TRUCK_IN_ERROR: 'Selected date and time cannot be before truck-in time',
  INDENT_LOADING_END_BEFORE_START_ERROR: 'Selected date and time cannot be before loading start time',

  // start of transporter side label
  INDENT_REJECT_VEHICLE_TYPE_NA: 'Vehicle type is not available in the market',
  INDENT_REJECT_EXISTING_RATE_ARE_NOT_COMPETITIVE: 'Existing rates are not competitive',
  INDENT_REJECT_LANE_NOT_SERVICEABLE: 'Lane is not serviceable today',
  INDENT_VEHICLE_AND_DATE: 'Vehicle & Date',
  INDENT_SLA_BREACH_IN: 'SLA Breach in',
  INDENT_ACCEPTANCE_SLA_BREACH_IN: 'Acceptance SLA Breach in',
  INDENT_ARRIVAL_SLA_BREACH_IN: 'Arrival SLA Breach in',
  INDENT_ASSIGN_TRUCK: 'Assign Truck',
  INDENT_CHANGE: 'Change',
  INDENT_INDENT_DATE: 'Indent Date',
  INDENT_SHIPMENT_NUMBER: 'Shipment Number',
  INDENT_BID_RATE: 'Bid Rate',
  INDENT_TOTAL_QUANTITY: 'Total Quantity',
  INDENT_TOTAL_MATERIAL_WEIGHT: 'Total Material Weight',
  INDENT_TOTAL_MATERIAL_VOLUME: 'Total Material Volume',
  INDENT_OTP: 'OTP',
  INDENT_INDENT_ACCEPTED: 'Indent Accepted',
  INDENT_TRUCK_ASSIGNED: 'Truck Assigned',
  INDENT_ARRIVED_AT: 'Arrived at',
  INDENT_DISPATCHED_AT: 'Dispatched at',
  INDENT_RELEASE_AT: 'Release at',
  INDENT_NO_ATTACHMENTS_FOUND: 'No attachments found',
  INDENTS_NO_COMMENTS_FOUND: 'No comments yet!',
  INDENT_MASTER_ATTACHMENTS: 'Master Attachments',
  INDENT_ROAD_ATTACHMENTS: 'Road Attachments',
  INDENT_TYPE1: 'type1',
  INDENT_TYPE2: 'type2',
  INDENT_CONTAINER_BOOKING_DOCUMENT: 'Container Booking Document',
  INDENT_CHASSIS_NUMBER: 'Chassis Number',
  INDENT_DRIVER_MOBILE_NUMBER: 'Driver Mobile Number',
  INDENT_PICK_A_DATE: 'Pick a date',
  INDENT_ENTER_DRIVER_NAME: 'Enter Driver Name',
  INDENT_ACTIONS: 'Actions',
  INDENT_ATTACHMENTS: 'Attachments',
  INDENT_CHOOSE_VEHICLE: 'Choose Vehicle',
  INDENT_SELECT_VEHICLE_TYPE: 'Select Vehicle Type',
  INDENT_SELECT_DATE_AND_TIME: 'Select Date and Time',
  INDENT_ESTIMATE_ARRIVAL: 'Estimated Arrival Time',
  INDENT_DATE_AND_TIME: 'Date and Time',
  BIDS_NO_BIDS_FOUND: 'Enjoy your day, no bids found!',
  BIDS_BASE_FREIGHT_RATE: 'Base Freight Rate',
  BIDS_VEHICLE_TYPE: 'Vehicle Type',
  BIDS_FREIGHT_TYPE: 'Freight Type',
  BIDS_CEILING_PRICE: 'Ceiling Price',
  BIDS_HISTORICAL_PRICE: 'Historical Price',
  BIDS_LOWEST_BID: 'Lowest Bid',
  BIDS_WITHDRAW: 'Withdraw',
  BIDS_SEND: 'Send',
  BIDS_ROUTE: 'Route',
  BIDS_PICKUPS: 'PICKUPS',
  BIDS_ADDRESS: 'Address',
  BIDS_DROPOFFS: 'DROPOFFS',
  BIDS_INR: 'INR',
  BIDS_SELECT_VEHICLE_TYPE: 'Select Vehicle Type',
  BIDS_HEADER_ORDER_NO: 'order_no',
  BIDS_HEADER_ROUTE: 'route',
  BIDS_HEADER_VEHICLE_TYPE: 'vehicle_type',
  BIDS_HEADER_EXPIRES_AT: 'expires_at',
  BID_DECREMENT: 'BID DECREMENT',
  LEADING_BID_BUFFER: 'LEADING BID BUFFER',
  BID_BY_COST: 'By Cost',
  BID_BY_PERCENTAGE: 'By Percentage',
  BID_DECREMENT_MESSAGE: 'NOTE - NEW BID SHOULD BE LESS THAN EXISTING BID BY',
  BIDS_QUOTE_REMARKS: 'Quote Remarks',
  BIDS_REMARKS: 'Remarks',
  BIDS_ENTER_REMARKS: 'Enter Remarks',
  BIDS_FREIGHT_QUOTE: 'Freight Quote',
  CONTRACTED_TRANSPORTERS: 'Contracted Transporters',
  EXCLUDE: 'Exclude',
  INDENTS_NO_INDENTS_FOUND: 'Enjoy your day, no indents found!',
  HEADER_COLUMN_PICKER: 'Column Picker',
  ENTER_SOURCE_SEAL_NUMBER: 'Enter source seal number',
  ENTER_DESTINATION_SEAL_NUMBER: 'Enter destination seal number',
  CONFIRMATION_POPUP_TRANSPORTER_DEBITED: 'Transporters will be debited for any shortage-damage. Are you sure?',
  ENTER_SEAL_NUMBER: 'Enter Seal Number',
  SEAL_NUMBER: 'Seal Number',
  HEADER_MAX_DISPLAY_COLUMN:
    'can display upto {maxDisplayColumn} columns at any instance',
  SOB_EXISTS: 'Running SOB',
  SOB_ESTIMATED: 'Ideal SOB',
  BASE_FREIGHT: 'BASE FREIGHT',
  BASE_FREIGHT_UNIT: 'FREIGHT UNIT',
  PER_TRIP: 'Per trip',
  PER_TON: 'Per ton',
  PER_KG: 'Per kg',
  PER_CFT: 'Per cft',
  PER_PACKAGE: 'Per package',
  PER_CASE: 'Per case',
  PER_BOX: 'Per box',
  PER_KM: 'Per km',
  PERCENTAGE: 'Percentage',
  INDENT_ORDER_LOADING: 'Order loading.......',
  INDENT_REACHED: 'Reached',
  INDENT_RELEASED: 'Released',
  INDENT_MATERIAL_LOADING: 'Material Loading...',
  INDENT_NO_MATERIALS: ' There are no materials',
  INDENT_DATE_FILTER: 'Date Filter',

  INDENT_EXCESS: 'Excess',
  INDENT_LEAKAGE: 'Leakage',
  INDENT_CARTON_DAMAGE: 'Carton Damage',
  INDENT_DAMAGE: 'Damage',
  INDENT_SHORTAGE: 'Shortage',

  INDENT_MATERIAL_UNIQUE_NUMBER: 'Material Unique Number',
  INDENT_MATERIAL_CODE: 'Material Code',
  INDENT_QUANTITY_TABLE: 'Qty',
  INDENT_PICKUP: 'Pickup',
  INDENT_DROPOFF: 'Drop-off',
  INDENT_CATEGORY: 'Category',
  INDENT_MRP_INR: 'MRP (INR)',
  INDENT_MRP: 'MRP',
  INDENT_CUSTOM_FIELD_1: 'Custom Field 1',
  INDENT_CUSTOM_FIELD_2: 'Custom Field 2',

  INDENT_PACKAGE_RECEIVED: 'Package received',
  INDENT_PACKAGE_DAMAGED: 'Package damaged',
  INDENT_PACKAGE_SHORTAGE: 'Package shortage',
  INDENT_DUPLICATE_VEHICLE_ASSIGN: 'Entered vehicle number is already assigned to indent {indentNo}. Please verify the same.',
  WARNING:'Warning',
  VAHAN_SARATHI_INTEGRATION_INVALID_DETAILS:'Entered Vehicle number does not have valid details - from Vahan/Sarathi Integration',
  SARATHI_INTEGRATION_INVALID_DETAILS:'Entered Vehicle number does not have valid details - from Sarathi Integration',
  VAHAN_INTEGRATION_INVALID_DETAILS:'Entered Vehicle number does not have valid details - from Vahan Integration',
  OVERRIDE_WARNING: 'Override the warning',
  OVERRIDE_REASON_SELECT: 'Please select the reason to proceed with the selected vehicle/driver details',
  NEED_LICENSE_FOR_DRIVER_VALIDATION: '',
  INDENT_PICKUP_AND_DROPOFF: 'PICKUP & DROPOFF',
  INDENT_CHANGE_SEQUENCE_IF_REQUIRED: 'Change Sequence if required',
  INDENT_DRAG_DROP_TO_CHANGE_SEQUENCE: 'Drag and drop to change the sequence',
  INDENT_START_CANNOT_BE_DROP: 'Start point cannot be a drop-off',
  INDENT_REACH_CANNOT_BE_PICKUP: 'Reach point cannot be a pickup',
  INDENT_START_CANNOT_BE_CONSIGNEE: 'Start point cannot be a consignee',
  INDENT_PIECES: 'Pieces',
  // mdm
  MDM_STATUS_APPROVAL_PENDING: 'Approval Pending',
  MDM_STATUS_UPLOAD_STARTED: 'Started',
  MDM_STATUS_UPLOAD_IN_PROGRESS: 'In Progress',
  MDM_STATUS_VALIDATION_COMPLETED: 'Validated',
  MDM_STATUS_UPLOAD_COMPLETED: 'Uploaded',
  MDM_STATUS_APPROVAL_REJECTED: 'Approval Rejected',
  MDM_STATUS_UPLOAD_DISCARDED: 'Discarded',
  MDM_STATUS_UPLOAD_FAILED: 'Failed',
  MDM_STATUS_UPLOAD_PARTIAL_FAILED: 'Partial Failed',
  MDM_REJECT_MASTER_UPLOAD: 'Reject Master Upload',
  MDM_UPLOADING: 'UPLOADING...',
  MDM_CHECK_STATUS: 'Check Status',
  MDM_CHECK_APPROVAL_STATUS: 'Check Approval Status',
  MDM_APPROVAL_STATUS: 'Approval Status',
  MDM_LEVEL: 'LEVEL',
  MDM_PENDING: 'Pending',
  MDM_APPROVED: 'Approved',
  MDM_REJECTED: 'Rejected',
  MDM_DOWNLOAD_SAMPLE_FILE: 'Download Sample File',
  MDM_ADD_NEW_MASTERS: 'Add multiple masters for approval',
  MDM_NEW_MASTER_UPLOAD: 'Upload New Master',
  MDM_ALL_MASTERS: 'All Masters',
  MDM_REFRESH: 'Refresh',
  MDM_STATUS: 'STATUS',
  MDM_SHORT_CODE: 'Short Code',
  MDM_PORT_TYPE: 'PORT TYPE',
  MDM_CITY: 'City',
  MDM_STATE: 'State',
  MDM_ADDRESS: 'Address',
  MDM_COUNTRY: 'Country',
  MDM_GEO_CODE: 'GEO Code',
  MDM_PINCODE: 'Postal Code',
  MDM_NEW: 'New',
  MDM_EDIT: 'Edit',
  MDM_CANCEL: 'Cancel',
  MDM_UPDATE: 'Update',
  MDM_SAVE: 'Save',
  MDM_CREATE: 'Create',
  MDM_NO_DATA_FOUND: 'No Data Found!',
  MDM_CONFIRM: 'Confirm',
  MDM_UPLOAD: 'UPLOAD',
  MDM_DISCARD: 'Discard',
  MDM_APPROVE: 'Approve',
  MDM_REJECT: 'Reject',
  MDM_REMARKS: 'Remarks',
  MDM_COMPANY_NAME: 'Company Name',
  MDM_PAN_NUMBER: 'Pan Number',
  MDM_GOVT_ID_PAN_NUMBER: 'Govt ID(Pan No.)',
  MDM_REFERENCE_ID: 'Reference Id',
  MDM_STATE_ENTITY_ID: 'State Entity ID',
  MDM_STATUS: 'Status',
  MDM_COUNT: 'Count',
  MDM_BATCH: 'Batch',
  MDM_MASTER: 'Master',
  MDM_OPTION: 'Option',
  MDM_VALID_ENTRIES: 'Valid Entries',
  MDM_INVALID_ENTRIES: 'Invalid Entries',
  MDM_STATUS_CHECK: 'Status Check',
  MDM_ADMIN: 'Admin',
  MDM_ADMIN_NAME: 'Admin Name',
  MDM_ADMIN_EMAIL: 'Admin Email',
  MDM_ADMIN_PHONE: 'Admin Phone',
  ADMIN_CHAT: 'CHAT',
  ADMIN_CHAT_TAGS: 'Tags',
  ADMIN_CHAT_ADD_TAGS: 'Add Tag',
  MDM_SERVICE: 'Service',
  MDM_CODE: 'Code',
  MDM_PACKAGING: 'Packaging',
  MDM_DESCRIPTION: 'Description',
  MDM_WEIGHT: 'Weight (KG)',
  MDM_VOLUME: 'Volume (CFT)',
  MDM_VOLUME_PER_PIECE: 'Volume Per Piece/KG',
  MDM_LENGTH: 'Length (CM)',
  MDM_HEIGHT: 'Height (CM)',
  MDM_NAME: 'Name',
  MDM_CAPACITY_CFT: 'Capacity CFT',
  MDM_PREFERERED_TRUCK_TYPE: 'Preferred Truck Type',
  MDM_TARE_WEIGHT_KG: 'Tare weight(KG)',
  MDM_MAX_GROSS_WEIGHT_KG: 'Max gross weight(KG)',
  MDM_MAX_PAYLOAD_KG: 'Max payload(KG)',
  MDM_INTERIOR: 'Interior',
  MDM_EXTERIOR: 'Exterior',
  MDM_DOOR_OPENING: 'Door Opening',
  MDM_LENGTH_FT: 'Length (FT)',
  MDM_WIDTH_FT: 'Width (FT)',
  MDM_HEIGHT_FT: 'Height (FT)',
  MDM_PORTS_ASSOCIATED: 'Ports Associated',
  MDM_GST_NUMBER: 'GST Number',
  MDM_EMAIL: 'Email',
  MDM_MOBILE: 'Mobile',
  MDM_DEPOT_ID: 'Depot Id',
  MDM_CUTOFF_TIME: 'Cutoff Time',
  MDM_CARRIER_CODE: 'Carrier Code',
  MDM_NO_OF_DAYS: 'No of Days',
  MDM_DEFAULT_REGULATION: 'Default Regulation',
  MDM_CAUTION_CODE: 'Caution Code',
  MDM_MODE_OF_TRANSPORT: 'Mode Of Transport',
  MDM_DOMESTIC_TRANSPORT_MODE: 'Domestic transport mode',
  MDM_INTERNATIONAL_TRANSPORT_MODE: 'International transport mode',
  MDM_DOMESTIC_COURIER: 'Domestic Carrier',
  MDM_DOMESTIC_COURIER_DEFAULT: 'Domestic Carrier Default',
  MDM_INTERNATIONAL_CARRIER: 'International Carrier ',
  MDM_INTERNATIONAL_CARRIER_DEFAULT: 'International Carrier Default',
  MDM_NO_DATA_FOUND: 'No Data Found',
  MDM_SHIP_METHOD: 'Ship Method',
  MDM_CARRIER_MASTER: 'Carrier Master',
  MDM_CARRIER: 'Carrier',
  MDM_PORT: 'Port',
  MDM_FREIGHT_FORWARDER: 'Freight Forwarder',
  MDM_CONTAINER: 'Container',
  MDM_CHA: 'Cha',
  MDM_CONSIGNEE: 'Consignee',
  MDM_BOX_MASTER: 'Box Master',
  MDM_EXCLUDE_TRUCK_TYPE: 'EXCLUDE TRUCK TYPE',
  MDM_ENTER_CONSIGNEE_NAME: 'Enter Consignee Name',
  MDM_ENTER_REF_ID: 'Enter Ref id',
  MDM_ENTER_ADDRESS: 'Enter Address',
  MDM_ENTER_CITY_NAME: 'Enter city name',
  MDM_ENTER_STATE_NAME: 'Enter state name',
  MDM_ENTER_PIN_CODE: 'Enter Pin code',
  MDM_ENTER_THE_GROUP_NAME: 'Enter the group name',
  MDM_ENTER_THE_REGION_NAME: 'Enter the region name',
  MDM_ENTER_THE_NAME: 'Enter the Name',
  MDM_ENTER_DISPLAY_REFERENCE_NAME: 'Enter the Display Reference Name',
  MDM_ENTER_THE_EMAIL: 'Enter the Email',
  MDM_ENTER_THE_MOBILE: 'Enter the Mobile',
  MDM_ENTER_THE_CATEGORY: 'Enter the category',
  MDM_CUSTOMER_LOGISTIC_LEADER: 'Customer Logistic Leader',
  MDM_TIME: 'HH:MM',
  MDM_CHOOSE_TAGS_FOR_YOUR_ARTICLE: 'Choose tags for your article',
  MDM_CHOOSE_YOUR_PORT_FOR_ASSOCIATION: 'Choose your port for association',
  MDM_COLUMN_DISPLAYED: 'COLUMN DISPLAYED',
  MDM_DISPLAY_COLUMNS:
    'can display upto {maxColumnCan} columns at any instance',
  MDM_NAME_IS_REQUIRED: 'Name is required',
  MDM_REF_ID: 'Ref Id',
  MDM_REF_ID_IS_REQUIRED: 'Ref id is required',
  MDM_CITY_IS_REQUIRED: 'City is required',
  MDM_STATE_IS_REQUIRED: 'State is required',
  MDM_PINCODE_IS_REQUIRED: 'Postal code is required',
  MDM_GROUP: 'Group',
  MDM_REGION: 'Region',
  MDM_REGION_IS_REQUIRED: 'Region is required',
  MDM_REFERENCE_ID_IS_REQUIRED: 'Reference Id is required',
  MDM_COUNTRY_IS_REQUIRED: 'Country is required',
  MDM_REPRESENTATIVE_NAME: 'Representative Name',
  MDM_REPRESENTATIVE_MOBILE: 'Representative Mobile',
  MDM_DISTRIBUTION_EMAILS: 'Logistics SPOC – Email ID',
  MDM_PHONE_NUMBER: 'Logistics SPOC – Mobile number',
  MDM_CATEGORY: 'Category',
  MDM_ADDITIONAL_FACTOR: 'Additional Factor',
  MDM_COMBINE: 'Combine',
  MDM_YES: 'Yes',
  MDM_PORT_ASSOCIATION: 'Port Association',
  MDM_PORT_IS_REQUIRED: 'Port is required',
  MDM_SALES_CONTACT_NAME: 'Sales Contact Name',
  MDM_REPRESENTATIVE_EMAIL: 'Representative Email',
  MDM_ENTER_VALID_EMAIL_ID: 'Enter Valid Email id',
  MDM_SALES_CONTACT_MOBILE: 'Sales Contact Mobile',
  MDM_SALES_CONTACT_EMAIL: 'Sales Contact Email',
  MDM_DELIVERY_DO_NOT_COMBINE: 'Delivery Do Not Combine',
  MDM_INACTIVE: 'InActive',
  MDM_OVERSEAS_CUSTOMER: 'Overseas Customer',
  MDM_LOADING_START_TIME: 'Loading start time',
  MDM_LOADING_END_TIME: 'Loading end time',
  MDM_UNLOADING_START_TIME: 'Unloading start time',
  MDM_UNLOADING_END_TIME: 'Unloading end time',
  MDM_CUSTOM_LOGISTIC_LEADER: 'Custom Logistic Leader',
  MDM_GATES_NOT_AVAILABLE: 'NO GATES/PICKUPS ADDED',
  MDM_TRANSPORTER_USER_NOT_AVAILABLE: 'Transporter User NA',
  MDM_GENERATE_LR: 'Generate LR',
  MDM_ROLE_SEARCH_PLACEHOLDER: 'Search by Role name',
  MDM_USER_SEARCH_PLACEHOLDER: 'Search by user name',
  MDM_DEPOT_SEARCH_PLACEHOLDER: 'Search by Depot Name / Ref id',
  MDM_CONSIGNEE_SEARCH_PLACEHOLDER: 'Search by Consignee Name, Ref id',
  MDM_VENDOR_DEPOT_SEARCH_PLACEHOLDER: 'Search by Vendor Depot Name / Ref id',
  MDM_PHONE: 'Phone',
  MDM_ROLE: 'Role',
  MDM_FILTER_BY: 'Filter By',
  MDM_SEARCH_BY: 'Search By',
  MDM_RATE_CALCULATOR: 'Rate Calculator',
  MDM_REJECTED_LIST: 'Rejected List',
  MDM_ADD: 'Add',
  MDM_STOP: 'Stop',
  MDM_EXPORT: 'Export',
  MDM_BULK_UPLOAD: 'Bulk Upload',
  MDM_SAMPLE_FORMAT: 'Sample format',
  MDM_PICKUP_DETAILS: 'Pickup details',
  MDM_EXPORT_FAILS: 'Export failed. Please try after some time',
  MDM_CONTACT: 'Contact',
  MDM_DELIVERY_TYPE: 'DELIVERY TYPE',
  MDM_SHT_CODE: 'SHT CODE',
  MDM_UNLOADING_CAPACITY: 'Unloading Capacity',
  MDM_TYPE: 'Type',
  MDM_TIMEZONE: 'Timezone',
  MDM_FAX_NUMBER: 'Fax Number',
  MDM_DISPLAY_REFERENCE_NAME: 'Display Reference Name',
  MDM_GATE_DISPLAY_REFERENCE_NAME: 'Display Reference Name',
  MDM_FUEL_TYPE: 'Fuel Type',
  MDM_OPTIMA_CLUSTER: 'Cluster',
  MDM_BFR_LABEL: 'BFR Label',
  MDM_BFR_PER_KM_RATE: 'BFR Per KM Rate',
  MDM_BFR_MINIMUM_GUARANTEE: 'BFR Minimum Guarantee',
  MDM_ENTER_BFR_PER_KM_RATE: 'Enter BFR Per KM Rate',
  MDM_ENTER_BFR_MINIMUM_GUARANTEE: 'Enter BFR Minimum Guarantee',
  MDM_ENTER_BFR_LABEL: 'Enter BFR Label',
  MDM_UPDATED_BY: 'Updated by',
  MDM_UPDATED_DATE: 'Updated date',
  MDM_CREATED_DATE: 'Created date',
  MDM_INDENT_DISTRIBUTION_COUNT: 'Indent Distribution Count',
  MDM_DEPOT: 'Depot',
  MDM_NEW_DEPOT: 'New Depot',
  MDM_CANT_LOAD_ROLES: 'Cannot load roles',
  MDM_SAVE_DEPOT_FAILS: 'Unable to save depot',
  MDM_ADD_DEPOT_SUCESS: 'Depot added successfully',
  MDM_DEPOT_ERROR_MSG: 'Depot {errorMessage}',
  MDM_DOCK_ERROR_MSG: 'Dock {errorMessage}',
  MDM_UPDATE_DEPOT_SUCCESS: 'Depot updated successfully',
  MDM_UPDATE_DEPOT_FAILURE: 'Unable to update depot',
  MDM_LISTING_FAILS: 'Initial data load problem. Please try again!',
  MDM_ENTER_USER_NAME: 'Enter User Name',
  MDM_ROLE_REQUIERD: 'Role is required',
  MDM_INVALID_PHONE_NUMBER: 'Invalid Phone Number',
  MDM_EMAIL_IS_REQUIRED: 'Email is required',
  MDM_ENTER_PHONE: 'Enter Phone',
  MDM_ENTER_EMAIL: 'Enter Email',
  MDM_DEPOT_NAME_IS_REQUIRED: 'Depot Name is required',
  MDM_ADDRESS_IS_REQUIRED: 'Address is required',
  MDM_ENTER_DEPOT_NAME: 'Enter Depot Name',
  MDM_GST_IN: 'GST IN',
  MDM_ENTER_GST_IN: 'Enter GST IN',
  MDM_GST_IN_REQUIRED: 'GST IN is required',
  MDM_ENTER_LATITUDE: 'Enter Latitude',
  MDM_ENTER_LONGITUDE: 'Enter Longitude',
  MDM_LATITUDE_LONGITUDE_REQUIRED: 'Latitude and Longitude are required',
  MDM_LATITUDE_REQUIRED: 'Latitude is required',
  MDM_LONGITUDE_REQUIRED: 'Longitude is required',
  MDM_LATITUDE: 'Latitude',
  MDM_LONGITUDE: 'Longitude',
  MDM_DEPOT_TYPE: 'Depot Type',
  MDM_SELECT_PLANT_TYPE: 'Select Plant Type',
  MDM_ENTER_STATE: 'Enter state',
  MDM_ONLY_NUMBERS_ACCEPTED: 'Only numbers value accepted',
  MDM_SELECT_REGION: 'Select Region',
  MDM_ENTER_PHONE_NUMBER: 'Enter Phone Number',
  MDM_SELECT_DELIVERY_TYPE: 'Select Delivery Type',
  MDM_CHOOSE_PORT_ASSOCIATION: 'Choose your port for association',
  MDM_ENTER_SHORT_CODE: 'Enter Short Code',
  MDM_SHORT_CODE_IS_REQUIRED: 'Short Code is required',
  MDM_SEZ: 'SEZ',
  MDM_GATES: 'GATES',
  MDM_GATES_DOCKS: 'GATES + DOCKS',
  MDM_GATE: 'Gate',
  MDM_NO_GATE_TAGGED: 'No Gate tagged',
  MDM_USERS: 'USERS',
  MDM_SEARCH_USER: 'Search user',
  MDM_VIRTUAL_RECEIVER_LOCATIONS: 'VIRTUAL RECEIVER LOCATIONS',
  MDM_SELECT_GATE_USER: 'Please select gate user',
  MDM_ADD_GATE_SUCCESS_MSG: 'Gate has been added',
  MDM_SAVE_GATE_ERROR_MSG: 'Unable to save gate',
  MDM_DEPOT_USER_UPDATE_SUCCESS_MSG: 'Depot users updated',
  MDM_LAT: 'Lat',
  MDM_LONG: 'Long',
  MDM_SPECIAL_TAX_REBATE: 'SPECIAL TAX REBATE',
  MDM_DOCKS: 'DOCKS',
  MDM_LEGAL_ENTITY: 'Legal Entity',
  MDM_DOCK: 'DOCK',
  MDM_DEPOT_USERS: 'DEPOT USERS',
  MDM_MANAGER: 'Manager',
  MDM_GATE_NAME: 'Gate Name',
  MDM_EDIT_GATE_DETAILS: 'EDIT GATE DETAILS',
  MDM_ENTER_GATE_NAME: 'Enter Gate Name',
  MDM_GATE_NAME_IS_REQUIRED: 'Gate Name is required',
  MDM_PINCODE_MAXLENGTH: 'Pincode must have at most {maxlength}',
  MDM_SELECT_TRUCK_TYPE: 'Select truck type',
  MDM_DOCK_CREATE_SUCCESS_MSG: 'Dock created successfully',
  MDM_SAVE_DOCK_ERROR_MSG: 'Unable to save dock',
  MDM_INVALID_COORDINATES: 'Latitude must be between -90 and 90, and Longitude between -180 and 180',
  MDM_LATITUDE_DECIMAL_LIMIT: 'Latitude must have at most 4 decimal places',
  MDM_LONGITUDE_DECIMAL_LIMIT: 'Longitude must have at most 4 decimal places',
  MDM_MANAGERS: 'MANAGERS',
  MDM_DOCK_NAME: 'DOCK NAME',
  MDM_DOCK_NAME_IS_REQUIRED: 'Dock Name is required',
  MDM_DOCK_MANAGER: 'DOCK MANAGER',
  MDM_DELETE: 'DELETE',
  MDM_REFERENCE_NO: 'REFERENCE NO',
  MDM_UPDATE_DOCK_SUCCESS_MSG: 'Dock has been updated',
  MDM_ENTER_TRANSPORTER_NAME: 'Enter Transporter Name',
  MDM_PAN_NO: 'Pan No',
  MDM_ENTER_PAN_NO: 'Enter Pan No',
  MDM_GST_TYPE: 'GST TYPE',
  MDM_GST_TYPE_IS_REQUIRED: 'GST Type is required',
  MDM_GST_PERCENTAGE: 'GST Percentage',
  MDM_ENTER_GST_PERCENTAGE: 'Enter Gst Percentage',
  MDM_GST_PERCENTAGE_IS_REQUIRED: 'GST Percentage is required',
  MDM_DISCOUNT: 'Discount',
  MDM_ADD_MANAGER: 'Add Manager',
  MDM_ENTER_NAME: 'Enter Name',
  MDM_ENTER_MOBILE: 'Enter Mobile',
  MDM_EMAIL_ID_IS_INVALID: 'Email id is Invalid',
  MDM_EMAIL_ID_IS_REQUIRED: 'Email id is Required',
  MDM_REMOVE: 'Remove',
  MDM_ENTER_MATERIAL_CODE: 'Enter Material Code',
  MDM_CODE_IS_REQUIRED: 'Code is required',
  MDM_BUSINESS_UNIT: 'Business Unit',
  MDM_ENTER_BUSINESS_UNIT: 'Enter Business Unit',
  MDM_BUSINESS_UNIT_IS_REQUIRED: 'Business Unit is required',
  MDM_PCE_PER_BOX: 'PCE Per Box',
  MDM_ENTER_PCE_PER_BOX: 'Enter PCE Per Box',
  MDM_PCE_PER_BOX_IS_REQUIRED: 'PCE Per Box is required',
  MDM_ENTER_LENGTH: 'Enter Length',
  MDM_LENGTH_IS_REQUIRED: 'Length is required',
  MDM_WIDTH: 'Width (CM)',
  MDM_ENTER_WIDTH: 'Enter Width',
  MDM_WIDTH_IS_REQUIRED: 'Width is required',
  MDM_ENTER_HEIGHT: 'Enter Height',
  MDM_HEIGHT_IS_REQUIRED: 'Height is required',
  MDM_ENTER_WEIGHT: 'Enter Weight',
  MDM_WEIGHT_IS_REQUIRED: 'Weight is required',
  MDM_ENTER_CATEGORY: 'Enter Category',
  MDM_DIVISION: 'Division',
  MDM_ENTER_DIVISION: 'Enter Division',
  MDM_GST_EXEMPT: 'GST Exempt',
  MDM_PALLETS: 'Pallets',
  MDM_ENTER_PALLET: 'Enter Pallet',
  MDM_PALLET_IS_REQUIRED: 'Pallet is required',
  MDM_BRAND: 'Brand',
  MDM_ENTER_BRAND: 'Enter Brand',
  MDM_SUB_BRAND: 'Sub Brand',
  MDM_ENTER_SUB_BRAND: 'Enter Sub Brand',
  MDM_THICKNESS: 'Thickness',
  MDM_ENTER_THICKNESS: 'Enter Thickness',
  MDM_LOAD_SEQUENCE: 'Load Sequence',
  MDM_ENTER_LOAD_SEQUENCE: 'Enter Load Sequence',
  MDM_CAN_TELESCOPE: 'Can Telescope',
  MDM_ENTER_BUCC_CODE: 'Enter Bucc Code',
  MDM_ENTER_DESCRIPTION: 'Enter Description',
  MDM_SECTOR: 'Sector',
  MDM_ENTER_SECTOR: 'Enter Sector',
  MDM_CENTER: 'Center',
  MDM_ENTER_CENTER: 'Enter Center',
  MDM_CENTER_IS_REQUIRED: 'Center is required',
  MDM_ENTER_MATERIAL_CATEGORY_NAME: 'Enter Material Category Name',
  MDM_CLUSTER: 'Cluster',
  MDM_ENTER_CLUSTER: 'Enter Cluster',
  MDM_CLUSTER_CAN_CONTAIN_ONLY_AN_ALPHANUMERIC_VALUE: 'Cluster can contain only an AlphaNumeric Value',
  MDM_STACKING_NORMS: 'Stacking Norms',
  MDM_ENTER_STACKING_NORMS: 'Enter Stacking Norms',
  MDM_POSITIONING_CONSTRAINTS: 'Positioning Constraints',
  MDM_SHORTAGE_UNIT: 'Shortage Unit',
  MDM_DAMAGE_UNIT: 'Damage Unit',
  MDM_CARTON_DAMAGE_UNIT: 'Carton Damage Unit',
  MDM_CARTON_DAMAGE_FACTOR: 'Carton Damage factor',
  MDM_DAMAGE_FACTOR: 'Damage factor',
  MDM_SHORTAGE_FACTOR: 'Shortage factor',
  MDM_ENTER_CARTON_DAMAGE_FACTOR: 'Enter Carton Damage factor',
  MDM_FACTOR_IS_REQUIRED: 'Factor is required',
  MDM_CARTON_DAMAGE_TYPE: 'Carton Damage Type',
  MDM_SHORTAGE_TYPE: 'Shortage Type',
  MDM_DAMAGE_TYPE: 'Damage Type',
  MDM_TYPE_IS_REQUIRED: 'Type is required',
  MDM_SHORTAGE_TOLERANCE: 'Shortage Tolerance',
  MDM_ENTER_SHORTAGE_TOLERANCE: 'Enter Shortage Tolerance',
  MDM_THE_SHORTAGE_TOLERANCE_MUST_BE_BETWEEN_0_AND_100: 'The shortage tolerance must be between 0 and 100',
  MDM_DAMAGE_TOLERANCE: 'Damage Tolerance',
  MDM_THE_DAMAGE_TOLERANCE_MUST_BE_BETWEEN_0_AND_100: 'The damage tolerance must be between 0 and 100',
  MDM_OPTIMA_FLOOR2: 'Optima Floor2',
  MDM_ENTER_OPTIMA_FLOOR2: 'Enter Optima Floor2',
  MDM_THE_OPTIMA_FLOOR2_MUST_BE_BETWEEN_0_AND_100: 'The Optima Floor2 must be between 0 and 100',
  MDM_OPTIMA_FLOOR2_IS_REQUIRED: 'The Optima Floor2 is required',
  MDM_MAX_UTILIZATION: 'Max Utilization',
  MDM_ENTER_MAX_UTILIZATION: 'Enter Max Utilization',
  MDM_MAX_UTILIZATION_MUST_BE_BETWEEN_0_AND_100: 'The Max Utilization must be between 0 and 100',
  MDM_MAX_UTILIZATION_IS_REQUIRED: 'The Max Utilization is required',
  MDM_OPTIMA_GROUP: 'Optima Group',
  MDM_ASC_MATERIAL_CATEGORIES: 'Associated Material Categories',
  MDM_ENTER_OPTIMA_GROUP: 'Enter Optima Group',
  MDM_ENTER_THE_DEDICATED_TRUCK_SOURCE: 'Enter the dedicated truck source',
  MDM_SOURCE_IS_REQUIRED: 'Source is required',
  MDM_ENTER_THE_DEPOT_REFERENCE_ID: 'Enter the depot reference id',
  MDM_DEPOT_REFERENCE_ID_IS_REQUIRED: 'Depot reference ID is required',
  MDM_TRANSPORTER: 'Transporter',
  MDM_ENTER_THE_TRANSPORTER_REFERENCE_ID: 'Enter the transporter reference id',
  MDM_TRANSPORTER_REFERENCE_ID_IS_REQUIRED: 'Transporter reference ID is required',
  MDM_VEHICLE_TYPE: 'Transport handling type',
  MDM_VEHICLE_TYPE_MODE: 'Mode',
  MDM_ENTER_THE_SHORT_FORM_OF_VEHICLE_NAME: 'Enter the short form of vehicle name',
  MDM_VEHICLE_TYPE_IS_REQUIRED: 'Vehicle type is required',
  MDM_MINIMUM_GUARANTEE: 'Minimum Guarantee Freight Cost',
  MDM_ENTER_THE_MINIMUM_GUARANTEE: 'Enter the minimum guarantee freight cost',
  MDM_MINIMUM_GUARANTEE_IS_REQUIRED: 'Minimum guarantee Freight Cost is required',
  MDM_NUMBER_OF_TRIPS: 'Number of Trips',
  MDM_ENTER_THE_NUMBER_OF_TRIPS: 'Enter the number of trips',
  MDM_NUMBER_OF_TRIPS_IS_REQUIRED: 'Number of trips is required',
  MDM_PER_KM_RATE: 'Additional Km Charge',
  MDM_ENTER_PER_KM_RATE: 'Enter additional km charge',
  MDM_PER_KM_RATE_IS_REQUIRED: 'Additional km charge is required',
  MDM_GUARANTEE_KM: 'Guarantee KM',
  MDM_ENTER_GUARANTEE_KM: 'Enter Guarantee KM',
  MDM_INPUT: 'Input',
  MDM_ENTER_INPUT: 'Enter Input',
  MDM_INPUT_ID_IS_REQUIRED: 'Input id is required',
  MDM_OUTPUT: 'Output',
  MDM_ENTER_OUTPUT: 'Enter Output',
  MDM_OUTPUT_ID_IS_REQUIRED: 'Output id is required',
  MDM_ENTER_VEHICLE_NAME: 'Enter Vehicle Name',
  MDM_VEHICLE_NAME_IS_REQUIRED: 'Vehicle name is required',
  MDM_CFT: 'CFT',
  MDM_ENTER_CFT: 'Enter CFT',
  MDM_CFT_IS_REQUIRED: 'CFT is required',
  MDM_KG: 'KG',
  MDM_ENTER_KG: 'Enter KG',
  MDM_KG_IS_REQUIRED: 'KG is required',
  MDM_WEIGHTAGE: 'WEIGHTAGE',
  MDM_ENTER_WEIGHTAGE: 'Enter WEIGHTAGE',
  MDM_EXCLUDE_SKU_CATEGORIES: 'EXCLUDE SKU CATEGORIES',
  MDM_ENTER_COMMA_SEPARATED_SKU_CATEGORIES: 'Enter comma separated sku categories',
  MDM_LENGTH_FACTOR: 'LENGTH FACTOR',
  MDM_ENTER_LENGTH_FACTOR: 'Enter Length factor',
  MDM_BREADTH_FACTOR: 'BREADTH FACTOR',
  MDM_ENTER_BREADTH_FACTOR: 'Enter breadth factor',
  MDM_HEIGHT_FACTOR: 'HEIGHT FACTOR',
  MDM_ENTER_HEIGHT_FACTOR: 'Enter height factor',
  MDM_ENTER_CARBON_EMISSION_FACTOR: 'Enter Carbon Emission Factor',
  MDM_BREADTH: 'BREADTH',
  MDM_ENTER_BREADTH: 'Enter Breadth',
  MDM_MAX_DISTANCE: 'Max distance',
  VEHICLE_TYPE_MODE: 'Mode',
  MDM_ENTER_MAX_DISTANCE: 'Enter Max distance',
  MDM_ENTER_VEHICLE_TYPE_MODE: 'Enter mode',
  MDM_UTILIZATION_CHECK_CATEGORY: 'Utilization Check Category',
  MDM_MOVEMENT: 'Movement',
  MDM_MIN_SLAB_RAGE: 'Min Slab Range',
  MAX_MAX_SLAB_RAGE: 'Max Slab Range',
  MDM_DROP_OFF_CHARGE: 'Drop Off Charge',
  MDM_DEPOT_REF_ID_SEARCH: 'Search by Depot reference Id',
  MDM_OPEN_ELIGIBLE: 'ELIGIBLE OPEN INDENT',
  MDM_SEAL_AVAILABLE: 'Seal Available',
  MDM_SOURCE_GATE_ID: 'Source | Gate ID',
  MDM_HUBS: 'Hubs | Hub Ref Ids',
  MDM_HUB_TYPE: 'Hub Type',
  MDM_CONFIRM_DISABLED_MESSAGE: 'All uploaded rows are invalid. Kindly discard this upload to proceed futher. ',
  MDM_REJECTION_CONFIRMATION_MESSAGE: 'Are you sure you want to Reject the upload of',
  MDM_REJECTION_MESSAGE_REQUEST: 'Please enter Rejection message',
  MDM_FORCE_DISCARD_BUTTON_CONFIRMATION: 'Clicking on this button will discard this bulk upload. \n This may result in partial upload',
  MDM_COUNT_DEFAULT_MESSAGE: 'No Pending Approvals Present',
  MDM_STATUS_APPROVALS_PENDING: 'Approvals Pending',
  MDM_EXCLUDED_MATERIAL_CATEGORIES: 'Excluded Categories',
  MDM_MATERIAL_CATEGORY: 'Material Category',
  MDM_NEW_MATERIAL_CATEGORY: 'New Material Category',
  MDM_MATERIAL_CATEGORY_CREATE_SUCCESS: 'New material category created successfully',
  MDM_MATERIAL_CATEGORY_UPDATE_SUCCESS: 'Material Category updated successfully',
  MDM_MATERIAL_SUB_CATEGORY: 'Sub Category',
  MDM_MATERIAL_ADD_SUB_CATEGORY: 'Add Sub Category',
  MDM_ENTER_MATERIAL_SUB_CATEGORY: 'Enter Sub Category',
  MDM_CARBON_EMISSION_FACTOR: 'Carbon Emission Factor',

  MDM_SOURCE_DEPOT: 'Source Depot',
  MDM_REDIRECTION_DEPOT: 'Redirection Depot',
  MDM_REDIRECTION_GATE: 'Gate',
  MDM_REDIRECTION_ASSOCIATE_BY: 'Associate By',
  MDM_REDIRECTION_CONDITION: 'Redirection Condition',
  MDM_REDIRECTION_ORDER_TYPE: 'Order Type',
  MDM_REDIRECTION_ASSOCIATED_MATERIAL: 'Associated Material',
  MDM_REDIRECTION_CATEGORY: 'Category',
  MDM_REDIRECTION_ASSOCIATED_LOCATIONS: 'Associated Locations',

  MDM_PRIMARY: 'Primary',
  MDM_SECONDARY: 'Secondary',
  MDM_VENDOR: 'Vendor',
  MDM_RETURN: 'Return',
  MDM_MOVEMENT_TYPE: 'Movement Type',
  MDM_INPUT_OUTPUT_SEARCH: 'Search by Input, Output',

  MDM_REP_NAME: 'Rep Name',
  MDM_REP_MOBILE: 'Rep Mobile',
  MDM_REP_EMAIL: 'Rep Email',
  MDM_OPTIMA_CATEGORY: 'Optima Category',
  MDM_SALES_NAME: 'Sales name',
  MDM_SALES_EMAIL: 'Sales email',
  MDM_SALES_PHONE_NO: 'Sales ph.no',
  MDM_UNLOADING_TIME: 'Unloading time',
  MDM_LOADING_TIME: 'Loading time',
  MDM_ACTIVE: 'Active',
  MDM_VIRTUAL_LOCATIONS: 'VIRTUAL LOCATIONS',
  MDM_ENABLE: 'ENABLE',
  MDM_DISABLE: 'DISABLE',
  MDM_ADD_VIRTUAL_LOCATION: 'Add Virtual Location',
  MDM_SNO: 'S.No',
  MDM_VIRTUAL_LOCATION: 'Virtual Location',
  MDM_ENTER_VIRTUAL_LOCATION: 'Enter Virtual Location',
  MDM_DELETE: 'Delete',

  MDM_TRANSPORTER_SEARCH: 'Search by Transporter Name/Ref id',
  MDM_NO_USER_ADDED: 'No Users Added',
  MDM_MATERIAL_CODE_SEARCH: 'Search by Material Code',
  MDM_ASSOCIATE_MATERIAL_BULK_UPLOAD: 'Associate Material Bulk Upload',
  MDM_USER_MATERIAL_ASSOCIATE_BULK_UPLOAD: 'User Material Bulk upload',
  MDM_ASSOCIATED: 'Associated',
  MDM_PARENT: 'Parent',
  MDM_CHILD: 'Child',
  MDM_FILTER_BY_TYPE: 'Filter By Type',
  MDM_SOURCE: 'Source',
  MDM_DESTINATION: 'Destination',
  MDM_PERCENTAGE: 'Percentage',
  MDM_FACTOR: 'Factor',
  MDM_THRESHOLD_TYPE: 'Threshold type',
  MDM_RATIO: 'Ratio',
  MDM_TRANS_REF_ID: 'Trans Ref Id',
  MDM_TRANSPORTER_NAME: 'Transporter Name',
  MDM_BUCC_SEARCH: 'Search by Bucc Code',
  MDM_TRUCK_TYPE_SEARCH: 'Search by Truck type',
  MDM_SHIPPER_SITE: 'Shipper Site',
  MDM_CUSTOMER_SITE: 'Customer Site',
  MDM_CO_MAKER_SITE: 'Co Maker Site',
  MDM_HUB: 'Hub',
  MDM_PINCODES: 'Pincodes',
  LEGAL_ENTITY_CODE: 'Legal Entity Code',
  COMPANY_NAME: 'Company Name',
  COMPANY_GSTIN: 'Company GSTIN',
  COMPANY_ADDRESS: 'Company Address',
  COMPANY_CITY: 'Company City',
  COMPANY_STATE: 'Company State',
  COMPANY_PINCODE: 'Company Pincode',
  FREIGHT_INVOICE_COMPANY_NAME: 'Freight Invoice Company Name',
  FREIGHT_INVOICE_COMPANY_GSTIN: 'Freight Invoice Company GSTIN',
  FREIGHT_INVOICE_COMPANY_ADDRESS: 'Freight Invoice Company Address',
  FREIGHT_INVOICE_COMPANY_CITY: 'Freight Invoice Company City',
  FREIGHT_INVOICE_COMPANY_STATE: 'Freight Invoice Company State',
  FREIGHT_INVOICE_COMPANY_PINCODE: 'Freight Invoice Company Pincode',
  LR_DOCUMENT_COMPANY_NAME: 'LR Document Company Name',
  LR_DOCUMENT_COMPANY_GSTIN: 'LR Document Company GSTIN',
  LR_DOCUMENT_COMPANY_ADDRESS: 'LR Document Company Address',
  LR_DOCUMENT_COMPANY_CITY: 'LR Document Company City',
  LR_DOCUMENT_COMPANY_STATE: 'LR Document Company State',
  LR_DOCUMENT_COMPANY_PINCODE: 'LR Document Company Pincode',

  MDM_DAY1: 'Day1',
  MDM_DAY2: 'Day2',
  MDM_DAY3: 'Day3',
  MDM_DAY4: 'Day4',
  MDM_DAY5: 'Day5',
  MDM_DAY6: 'Day6',

  MDM_LOADING_DETENTION: 'Loading Detention',
  MDM_UNLOADING_DETENTION: 'UnLoading Detention',
  MDM_TRANSIT_DELAY: 'Transit Delay',
  MDM_TRUCK_TYPE: 'Truck Type',
  MDM_VEHICLE: 'Vehicle',

  MDM_VEHICLE_UTILIZATION_CHECK: 'Vehicle utilization Check',
  MDM_VEHICLE_WEIGHTAGE: 'Vehicle Weightage',

  MDM_VEHICLE_NAME_SEARCH: 'Search by Vehicle Name',
  MDM_SEARCH_BY_DEPOT_NAME: 'Search by Depot Name',
  MDM_FUTURE: 'Future',

  MDM_DEPOT_NAME: 'Depot Name',
  MDM_UNITS: 'Units',
  MDM_LOADING_CHARGE: 'Loading Charge',
  MDM_UNLOADING_CHARGE: 'Unloading Charge',
  MDM_ODA_CHARGE: 'ODA Charge',
  MDM_UNIT: 'Unit',
  MDM_ACCEPTANCE: 'Acceptance',
  MDM_ASSIGNMENT: 'Assignment',
  MDM_ARRIVAL: 'Arrival',
  MDM_REJECTION: 'Rejection',
  MDM_GRACE_PERIOD: 'Grace Period',
  MDM_MAX_ARRIVAL_SLA_PERCENTAGE: 'Max Arrival SLA (%)',
  MDM_MASTER_REJECTIONS: 'Master Rejections',
  MDM_NO_REJECTIONS: 'No Rejections',
  MDM_ALL_TRANSACTIONS: 'All transactions',
  MDM_DOWNLOAD: 'Download',
  MDM_COUNT_REJECTED: '{count} rejected {exception_last}',
  MDM_TRANSPORTER_NAME_SEARCH: 'Search by Transporter Name',
  MDM_CITY_REF: 'City Ref',
  MDM_SOURCE_TYPE: 'Source type',
  MDM_CURRENT_BDR: 'CURRENT BFR',
  MDM_UPDATED_BDR: 'UPDATED BFR',
  MDM_MIN_BDR_THRESHOLD: 'MIN BFR THRESHOLD',
  MDM_FUEL_CHANGE: 'FUEL CHANGE (%)',
  MDM_FREIGHT_CHANGE: 'FREIGHT CHANGE (%)',
  MDM_MAX_BDR_FACTOR: 'MAX BFR FACTOR',
  MDM_DIESEL_COMPONENT_FACTOR: 'RATE FACTOR',
  MDM_EFFECT_FROM: 'EFFECT FROM',
  MDM_POINT: 'Point',
  MDM_BDR_UPDATE_CONFIRMATION: 'Are you sure you want to stop the fuel price update ?',
  MDM_PREVIOUS_BDR: 'PREVIOUS BFR',
  MDM_CDR: 'CFR',
  MDM_CHECK: 'CHECK',
  MDM_CONTRACT_TYPE: 'CONTRACT TYPE',
  MDM_NOTIFICATIONS_ENABLED: 'Notifications Enabled',
  MDM_COURIER_REF_ID: 'Courier Ref Id',

  MDM_MIN_SLAB: 'MIN SLAB',
  MDM_MAX_SLAB: 'MAX SLAB',
  MDM_CHANGE_FACTOR: 'CHANGE FACTOR (FRACTION)',
  MDM_PREVIOUS_MINIMUM_GUARANTEE:'PREVIOUS MINIMUM GUARANTEE',
  MDM_CURRENT_MINIMUM_GUARANTEE:'CURRENT MINIMUM GUARANTEE',
  MDM_PREVIOUS_PER_KM_RATE:'PREVIOUS PER KM RATE',
  MDM_CURRENT_PER_KM_RATE:'CURRENT PER KM RATE',
  MDM_FUEL_COMPONENT_FACTOR:'FUEL COMPONENT FACTOR',
  MDM_RCM: 'RCM',
  MDM_FCM: 'FCM',
  MDM_ENTER_VALUE_HERE: 'Enter Value here',
  MDM_BDR_CHARGE: 'BFR Charge',
  MDM_BDR_LABEL: 'BFR Label',
  MDM_VEHICLE_EXCLUDE: 'Vehicles Exclude',
  MDM_VEHICLE_NAME: 'Vehicle Name',
  MDM_VALID_FROM: 'Valid From',
  MDM_VALID_TO: 'valid To',
  MDM_RETURN_ROUND_TRIP: 'Return Round Trip',
  MDM_IS_ROUND_TRIP_ELIGIBLE: 'Is Round Trip Eligible',
  MDM_HILLY_REGION_ADDITION_PERCENTAGE: 'Hilly Region Addition %',
  MDM_MIN_KMS: 'Min Kms',
  MDM_ADDITIONAL_CHARGE_PERCENTAGE: 'Additional Charge %',
  MDM_INDENT_CANCELLATION_CHARGE: 'Indent Cancellation Charge',
  MDM_RUNNING_COUNT: 'Running Count',
  MDM_TRUCK_COUNT: 'Truck Count',
  MDM_IS_DEDICATED: 'Is Dedicated',
  MDM_IS_OWNED: 'Is Owned',
  MDM_DROP_POINT_CHARGES: 'Drop Point Charges',
  MDM_PICKUP_POINT_CHARGES: 'Pickup Point Charges',
  HILLY_REGION_CHARGE: 'Hilly Region Additional Charges',
  RETURN_FREIGHT_CHARGE: 'Return Freight Charge',
  MDM_RETURN_FREIGHT_RATE: 'Return Freight Rate',
  MDM_MINIMUM_ODA: 'Minimum Oda',
  MDM_ODA_UNIT: 'Oda Unit',
  MDM_ODA_RATE: 'Oda Rate',
  MDM_FIXED_RATE: 'Fixed Rate',
  MDM_TRIP_COUNT: 'Trip Count',
  MDM_ROUTE_EXCLUDE: 'Route Exclude',
  MDM_MULTIPLYING_FACTOR: 'Multiplying Factor',
  MDM_MINIMUM_RATE: 'Minimum Rate',
  MDM_RATE: 'Rate',
  MDM_FLAT_VARIABLE_CHARGE: 'Flat Variable Charge',
  MDM_DISTANCE: 'Distance',
  MDM_TRANSIT_DAYS: 'Transit Days',
  MDM_DETENTION_GROUP: 'Detention Group',
  MDM_CALCULATE: 'Calculate',
  MDM_ADDITIONAL_CHARGE_PERCENT: 'Additional Charge %',
  MDM_NORMAL_RATE: 'Normal Rate',
  MDM_HILLY_ROUTE_RATE: 'Hilly Route Rate',
  MDM_DESTINATION_CITY: 'Destination City',
  MDM_TOTAL_KMS: 'Total Kms',
  MDM_DESTINATION_STATE: 'Destination State',
  MDM_PER_KM_SLAB_RATE: 'Per KM Slab Rate',
  MDM_ADDITIONAL_CHARGE: 'Additional Charge',
  MDM_BASE_FREIGHT_COST: 'Base Freight Cost',
  MDM_TOTAL_COST: 'Total Cost',
  MDM_NO_EMPTY_FIELDS_ERROR_MSG: 'Fields cannot be empty',
  MDM_NO_PRODUCT_CATEGORY_AVAILABLE: 'No product category details are available',
  MDM_HISTORY: 'HISTORY',
  MDM_TIMELINE: 'TIMELINE',
  MDM_BDR_SLAB: 'SLAB',
  MDM_KM_SLAB_RATE: 'KM Slab Rate',
  MDM_PRODUCT_CATEGORY: 'PRODUCT CATEGORY',
  MDM_NO_KM_SLAB_AVAILABLE: 'No Km Slab details are available',
  MDM_NO_RECORDS_AVAILABLE: 'No Records Available',
  MDM_FREIGHT_RATE: 'Freight Rate',
  MDM_KM_SLAB: 'Km Slab',
  MDM_UPDATED_ON: 'Updated On',
  MDM_FREIGHT_RATE_PER_CASE: 'Freight Rate (Per Case)',
  MDM_VEHICLE_NUMBER_SEARCH: 'Search by vehicle number',
  MDM_VEHICLE_NUMBER: 'Vehicle Number',
  MDM_DRIVER_MOBILE_NO: 'Driver Mobile No',
  MDM_REASON: 'Reason',
  MDM_INDENT_ID: 'Indent ID',
  MDM_DRIVER_NAME_SEARCH: 'Search by driver number',
  MDM_DRIVER_NUMBER: 'Driver Number',
  MDM_DRIVER_NAME: 'Driver Name',
  MDM_SOURCE_SEARCH_PLACEHOLDER: 'Search by Source',
  MDM_VIA_ROUTES: 'Via Routes',
  MDM_FREIGHT_RATE_PER_TRIP: 'Freight Rate (Per Trip)',
  MDM_TRANSPORTER_REF_ID: 'Transporter Ref ID',
  MDM_DEPOT_REF_ID: 'Depot Ref ID',
  MDM_PO_NUMBER_SEARCH: 'Search by PO number',
  MDM_ADD_RECORD: 'Record Added!',
  MDM_UPDATE_RECORD: 'Record Updated!',
  MDM_SEARCH_BY_MATERIAL_CATEGORY_NAME: 'Search by Material Category Name',
  MDM_SHOAGE_UNIT: 'Shortage Unit',
  MDM_UPDATED_AT: 'Updated Date',
  MDM_SEARCH_BY_SOURCE: 'Search by Source',
  MDM_NO: 'NO',
  INDENT_NO_RECORDS: 'No Indents Found',
  MDM_BACKLIST_HISTORY: 'BLACKLIST HISTORY',
  MDM_DRIVER: 'Driver',
  MDM_AVAILABILITY: 'Availability',
  MDM_FLEET_TYPE: 'Fleet Type',
  MDM_VEHICLE_DETAILS: 'Vehicle Details',
  MDM_FILE: 'File',
  MDM_UPLOADED_BY: 'Uploaded By',
  MDM_ACTION_BY: 'Action By',
  MDM_DETAILS: 'Details',
  MDM_VEHICLE_MODEL: 'Vehicle Model',
  MDM_CHASIS_NUMBER: 'Chasis Number',
  MDM_DEPOT_AVAILABILITY: 'Depot Availability',
  MDM_ADD_DEPOT: 'Add Depot',
  MDM_TARE_WEIGHT: 'Tare Weight',
  MDM_FILLED_WEIGHT: 'Filled Weight',
  MDM_GROSS_WEIGHT: 'Gross Weight',
  MDM_UOM: 'Uom',
  MDM_USER_PERMISSIONS: 'User Permissions',
  MDM_VEHICLE_DETAIL: 'Vehicle Detail',
  MDM_SURGE_THRESHOLD: 'Surge Threshold',
  MDM_DEPOT_SETTING: 'Depot Setting',
  MDM_ROUTE_NAME: 'Route',
  MDM_TRUCK_IN: 'Truck In',
  MDM_TRUCK_OUT: 'Truck Out',
  MDM_REACH: 'Reach',
  MDM_MATERIAL_INVOICE: 'Material Invoice',
  MDM_SHIPMENT_NUMBER: 'Shipment Number',
  MDM_NUMBER_TRUCK: 'Number of Trucks',
  MDM_BASE_FUEL_RATE: 'Base Fuel Rate',
  MDM_SELECTED_USERS: 'Selected users',
  MDM_RATE_TYPE: 'RATE TYPE',
  MDM_DEPOT_TO_DESTINATION: 'Depot To Destination',
  MDM_SOURCE_TO_DESTINATION: 'Source To Destination',
  MDM_SOURCE_TO_DEPOT: 'Source To Depot',
  MDM_SOURCE_PINCODE: 'Source PINCODE',
  MDM_ENTER_PINCODE: 'Enter Pincode',
  MDM_SOURCE_DEPOT: 'Source Depot',
  MDM_SELECT_DEPOT: 'Select Depot',
  MDM_DESTINATION_LOCATION: 'Destination Location',
  MDM_DESTINATION_PINCODE: 'Destination Pincode',
  MDM_SELECT_TRANSPORTER: 'Select Transporter',
  MDM_TOTAL_WEIGHT_KG: 'Total Weight (KG)',
  MDM_SOURCE_CITY: 'Source City',
  MDM_SOURCE_STATE: 'Source State',
  MDM_RATE_INR: 'Rate (INR)',
  MDM_ADDITIONAL_CHARGE_INR: 'Additional Charge(INR)',
  MDM_BASE_FREIGHT_COST_INR: 'Base Freight Cost(INR)',
  MDM_TOTAL_COST_INR: 'Total Cost (INR)',
  MDM_CHARGE_ARE_BASIC_FREIGHT_AMOUNT_IN_SINGLE_PICKUP_AND_DELVERY: 'Above Charges are only absolute Basic Freight amount considering single pick up point & delivery point.',
  MDM_DOWNLOAD_ALL: 'Download all',
  MDM_OTHER_CHARGES_HERE: 'other charges here',
  MDM_RATE_MATRIX: 'Rate Matrix',
  MDM_PER_KM: 'PER KM',
  MDM_PER_KG: 'PER KG',
  MDM_PER_TON: 'PER TON',
  MDM_SEARCH_BY_SOURCE_OR_DESATINATION: 'Search by Source or Destination',
  MDM_ENTER_NUMBER_OF_TRUCKS: 'Enter Number of Trucks',
  MDM_ENTER_VOLUME: 'Enter Volume',
  MDM_UNLOADING_THROUGHPUT: 'UNLOADING THROUGHPUT',
  MDM_DISPATCH_THROUGHPUT: 'DISPATCH THROUGHPUT',
  MDM_ADD_GATE: 'Add Gate',
  MDM_CLICK_HERE_TO_ADD_GATE: 'Click here to add a gate',
  MDM_NO_GATES: 'No Gates',
  MDM_VIRTUAL: 'Virtual',
  MDM_SEARCH_USER_TO_ADD: 'Search user to add',
  MDM_USERS_FOR_VIRTUAL_GATE: 'No Users For Virtual Gate',
  MDM_CLICK_HERE_TO_ADD_DOCK: 'Click here to add a dock',
  MDM_NO_DOCKS: 'No Docks',
  MDM_ENTER_REF_ID: 'Enter Reference Id',
  MDM_ENTER_DOCK_NAME: 'Enter Dock Name',
  MDM_SLABS: 'Slabs',
  MDM_CONTRACTS: 'Contracts',
  MDM_ROUTE_CONTRACT: 'Route Contract',
  MDM_DELETE_CONTRACTS: 'Delete Contract',
  MDM_MOVEMENT_RATES: 'MOVEMENT RATES',
  MDM_VIA_ROUTES: 'Via Routes',
  MDM_DELETE_FUTURE_CONTRACT_COMFORMATION_MESSAGE: 'Are you sure you want to delete future contract valid',
  MDM_SELECT_DESTINATION_TO_EXCLUDE_ROUTES: 'Please Select destinations to exclude routes!',
  MDM_SETTINGS: 'Settings',
  MDM_ROUTE_EXCLUSION: 'Route Exclusion',
  MDM_ADD_ROUTE_EXCLUSION: 'Add Route Exclusion',
  MDM_SOURCES: 'Sources',
  MDM_DESTINATIONS: 'Destinations',
  MDM_DEPOT_COMBINE_DELIVERY_OTHER_GATES_MSG: 'When turned on, Pando will be allowed to create indents that will combine deliveries earmarked for other depots/gates. This helps attain better truck utilization.',
  MDM_DEPOT_DE_COUPLE_DELIVERIES_MSG: 'When turned on, every delivery earmarked to this depot/gate will be created as separate indents.',
  MDM_CONSIGNEE_COMBINE_DELIVERY_OTHER_CONSIGNEES_MSG: 'When turned on, Pando will be allowed to create indents that will combine deliveries earmarked for other consignees. Shipper enjoys better truck utilization when this option is turned on.',
  MDM_CONSIGNEE_DE_COUPLE_DELIVERIES_MSG: 'When turned on, every delivery earmarked to this consignee will be created as separate indents.',
  MDM_CONSIGNEE_LOGISTICS_REPRESENTATIVE_MSG: 'The representative from the Consignee who will be in charge of receiving the consignment and signing off on EPOD.',
  MDM_VEHICLE_STATUS: 'Vehicle Status',
  MDM_CONSIGNEE_NAME: 'Consignee Name',
  MDM_LOGISTICS_SPOC_EMAIL: 'Logistics Spoc - Email ID',
  MDM_LOGISTICS_SPOC_MOBILE: 'Logistics Spoc - Mobile Number',
  MDM_LOGISTICS_REP:'Logistics Representative',
  MDM_LOGISTICS_REP_MOBILE:'Representative Mobile',
  MDM_LOGISTICS_REP_EMAIL:'Representative Email',
  MDM_EPOD_GROUP: 'EPOD Group',
  MDM_COMBINE_DELIVERY_WITH_OTHER_CONSIGNEE: 'Combine delivery with other consignees',
  MDM_DE_COUPLE_DELIVERY: 'De-couple Deliveries',
  MDM_CUSTOMER_TYPE: 'Customer Type',

  MDM_PO_NUMBER: 'PO Number',
  MDM_PO_LINE_ITEM_NUMBER: 'PO Line Item Number',
  MDM_ACCOUNT_ASSIGNMENT_NUMBER: 'Account Assignment Number',
  MDM_NET_VALUE: 'Net Value',
  MDM_PO_TRANSPORTER_REF_ID: 'Transporter Ref Id',
  MDM_BALANCE_VALUE: 'Balance Value',
  MDM_PO_STATUS: 'Status',
  MDM_PURCHASE_ORDER_DETAILS: 'Purchase Order Details',
  MDM_UTILIZATION_REPORT: 'Utilization Report',
  MDM_ALL_DEPOTS : 'All Depots',
  MDM_AUTO_EXTEND_LR_SERIES: 'Auto Extend LR Series',
  MDM_UPDATE_SHORTAGES_AND_DAMAGES_CONFIRMATION_MESSAGE: 'Please make sure all the entered values are accurate and complete',

  // Optima
  OPTIMA: 'Optima',
  OPTIMA_REFRESH: 'Refresh',
  OPTIMA_DN_PROCESSED: 'DN Processed',
  OPTIMA_REJECTION: 'Rejection',
  OPTIMA_COUNT: 'Count',
  OPTIMA_YES: 'Yes',
  OPTIMA_NO: 'No',
  OPTIMA_SAVE: 'Save',
  OPTIMA_ADD: 'Add',
  OPTIMA_ADD_NEW: 'Add New',
  OPTIMA_ADD_SPLIT: 'Add Split',
  OPTIMA_REMOVE: 'Remove',
  OPTIMA_CANCEL: 'Cancel',
  OPTIMA_DELETE: 'Delete',
  OPTIMA_DEPOT: 'Depot',
  OPTIMA_DEPOTS: 'Depots',
  OPTIMA_MOVEMENT: 'Movement',
  OPTIMA_VISUALIZE: 'Visualize',
  OPTIMA_CFT: 'cft',
  OPTIMA_KGS: 'kgs',
  OPTIMA_WT: 'WT | WT%',
  OPTIMA_WT_HEADER: 'WT',
  OPTIMA_VOL: 'Vol (CFT)|Vol%',
  OPTIMA_VL: 'VL',
  OPTIMA_QTY: 'QTY',
  OPTIMA_NOS: 'nos',
  OPTIMA_WEIGHT: 'Weight',
  OPTIMA_VOLUME: 'Volume',
  OPTIMA_WEIGHT_KG: 'Weight(KG)',
  OPTIMA_VOLUME_CFT: 'Volume (CFT)',
  OPTIMA_PERCENTAGE_SYMBOL: '(%)',
  OPTIMA_WEIGHT_VOLUME: 'Weight and Volume',
  OPTIMA_DOWNLOAD: 'Download',
  OPTIMA_HOUR: 'Hour',
  OPTIMA_MINUTE: 'Minute',
  OPTIME_TIME: 'Time',
  OPTIMA_UPLOAD: 'Upload',
  OPTIMA_MATERIAL_UPLOAD: 'Material Upload',
  OPTIMA_APPLY_ALL: 'Apply to all',
  OPTIMA_CONFIRMATION: 'Confirmation',
  OPTIMA_CONFIRM: 'Confirm',
  OPTIMA_SUBMIT: 'Submit',
  OPTIMA_VALID: 'VALID',
  OPTIMA_CONSIGNEES: 'Consignees',
  OPTIMA_CONSIGNEE: 'Consignee',
  OPTIMA_CONSIGNEE_NAME: 'Consignee Name',
  OPTIMA_CONSIGNEE_REF_ID: 'Consignee Ref Id',
  OPTIMA_SHIP_TO_NAME: 'Ship-To Name(s)',
  OPTIMA_SHIP_TO_REF_ID: 'Ship-To Ref-Id(s)',
  OPTIMA_SOLD_TO_NAMES: 'Sold-To Name(s)',
  OPTIMA_SHIP_TO_CITY: 'Ship-To City(s)',
  OPTIMA_SOLD_TO_REF_IDS: 'Sold-To Ref Id(s)',
  OPTIMA_PICKUP_NAMES: 'Pickup Name(s)',
  OPTIMA_PICKUP_REF_IDS: 'Pickup Ref Id(s)',
  OPTIMA_DELIVERY_NUMBERS: 'Delivery Number(s)',
  OPTIMA_MATERIAL_CODES: 'Material Code(s)',
  OPTIMA_TOTAL_WEIGHT: 'Total Weight',
  OPTIMA_TOTAL_VOLUME: 'Total Volume',
  OPTIMA_TOTAL_QUANTITY: 'Total Quantity',
  OPTIMA_MATERIAL_CATEGORY: 'Material Category',
  OPTIMA_REMARKS: 'Remarks',
  OPTIMA_CONSIGNEE_DETAILS: 'CONSIGNEE DETAILS',
  OPTIMA_MATERIAL: 'Material',
  OPTIMA_MATERIAL_CODE: 'Materials Code',
  OPTIMA_MATERIALS: 'Materials',
  OPTIMA_NOT_AVAILABLE: 'Not available',
  OPTIMA_NOT_ADD_TO_INVOICE: 'Don’t add to Invoice',
  OPTIMA_REVERT: 'Revert',
  OPTIMA_RETAIN: 'Retain',
  OPTIMA_PENDING: 'Pending',
  OPTIMA_COMPLETED: 'Completed',
  OPTIMA_HOLD: 'Hold',
  OPTIMA_SOURCE: 'Source',
  OPTIMA_SOURCE_ERP: 'ERP',
  OPTIMA_SOURCE_UPLOAD: 'UPLOAD',
  OPTIMA_OUTPUT: 'Output',
  OPTIMA_WEIGHT: 'Wt',
  OPTIMA_VOLUME: 'Vl',
  OPTIMA_QUANTITY: 'Qt',
  OPTIMA_DELIVERY_NO: 'Delivery No',
  OPTIMA_PRE_OPTIMA: 'Pre Optima',
  OPTIMA_POST_OPTIMA: 'Post Optima',
  OPTIMA_ERP: 'Erp',
  OPTIMA_FILTER: 'Filter',
  OPTIMA_CREATED_AT: 'Created At',
  OPTIMA_UPDATED_AT: 'Updated At',
  OPTIMA_OPTIMA_REJECTION: 'Optima Rejection',

  // Optima Settings
  OPTIMA_SETTINGS: 'OPTIMA SETTINGS',
  OPTIMA_CONSTRAINTS: 'OPTIMA CONSTRAINTS',
  OPTIMA_WILL_BE_DISCARDED: 'Will be discarded',
  OPTIMA_ACTION_CANNOT_UNDONE: 'This action cannot be undone. Proceed?',
  OPTIMA_ROUTE_SETTINGS: 'ROUTE SETTINGS',
  OPTIMA_PICK_UPS: 'Pickup ID (S)',
  OPTIMA_PICK_UP_NAME: 'Pickup Name (S)',
  OPTIMA_PICK_UPS_DROP_OFFS: 'PICK UPS AND DROP OFFS',
  OPTIMA_MAX_PICK_UPS: 'Max Pick ups',
  OPTIMA_MAX_DROP_OFFS: 'Max Drop offs',
  OPTIMA_DISTANCE_LIMIT: 'Distance Limit',
  OPTIMA_CS_SETTINGS: 'CS Settings',
  OPTIMA_SPLIT_FACTOR: 'Split Factor',
  OPTIMA_MAX_SPLITS: 'Max Splits',
  OPTIMA_ALGORITHM_MODE: 'Algorithm Mode',
  OPTIMA_ANGLE: 'Angle',
  Optima_TYPE: 'Optima Type',
  OPTIMA_MODE: ' Mode',
  OPTIMA_LIMITED_TRUCK_COUNT: 'Limited truck count',
  OPTIMA_PTL_DELIVERIES: 'PTL Deliveries',
  OPTIMA_USE_MATERIAL_FRACTIONAL_QUANTITY: 'Use Material fractional quantity',
  FAIR_SHARE_SLAB: 'Fair Share Slab (0.1 - 1)',
  SKU_ADD_PERCENTAGE: 'SKU Add Percentage (0.1 - 1)',
  OPTIMA_HYBRID_SPLIT: 'HYBRID SPLIT',
  OPTIMA_ENABLE: 'ENABLE',
  OPTIMA_TELESCOPIC_THRESHOLD: 'Telescopic Threshold',
  OPTIMA_CITY_WISE_DROP_OFFS: 'CITY-WISE DROP OFFS',
  OPTIMA_PICKUP_THRESHOLD: 'Pickup Threshold',
  OPTIMA_DROP_THRESHOLD: 'Drop Threshold',
  OPTIMA_FLOOR: 'Floor',
  OPTIMA_ENABLE_FLOOR2: 'Enable Floor 2',
  OPTIMA_EXISTING_INDENT_TOPUP_CUSTOMERS: 'Indent Topup Customers',
  GROUP_BY_CLUSTER: 'Enable Group By Cluster',
  GROUP_BY_ROUTE_CLUSTER: 'Is group by route cluster',
  GROUP_BY_CONSIGNEE_CLUSTER: 'Is group by consignee cluster',
  DELIVERY_NUMBER_RESTRICTIONS: 'Delivery number restrictions',
  DAYS_TO_IGNORE_INDENTED_DELIVERY: 'Days to ignore indented delivery',
  DO_NOT_RESTRICT_CANCELLED: 'Do not restrict cancelled',
  INDENTS_DELIVERY: 'Indents delivery',
  OPEN_ELGIBLE_VEHICLES_NEEDED: 'Open eligible vehicles needed',
  CAN_DOWNGRADE: 'Can downgrade',
  LAST_TRUCK_UPGRADE: 'Last truck upgrade',
  AGEING_DAYS: 'Ageing days',
  DONOT_SPLIT_DELIVERY: 'Do not split delivery',
  UTILIZATION_PERCENTAGE: 'Utilization percentage',
  ALLOW_PARTIAL_DELIVERY: 'Allow Partial Delivery',
  OPTIMA_LAST_DROPOFF_THRESHOLD: 'Last Dropoff Threshold',
  OPTIMA_JOB_RUN_TIME: 'Job Run Time',
  OPTIMA_MATERIAL_DETAILS: 'material Details',
  OPTIMA_FLEET_TITLE: 'Autorun Time with Fleet eligibility',
  OPTIMA_FLEET_CUTOFF: 'FLEET ELIGIBILITY WITH CUTOFF TIME',
  OPTIMA_FLEET_TYPE: 'Fleet Type',
  OPTIMA_CUTOFF_TIME: 'CUT-OFF',
  OPTIMA_PRIORITY_CONSTRAINTS: 'PRIORITY CONSTRAINTS',
  OPTIMA_FIELD_BASED_PRIORITY: 'FIELD BASED PRIORITY',
  OPTIMA_PRIORITY: 'Priority',
  OPTIMA_ORDER_CREATION: 'Order Creation',
  OPTIMA_ORDER_TYPE: 'Order Type',
  OPTIMA_CATEGORY_PRIORITY: 'Category Priority',
  OPTIMA_ADD_NEW_PRIORITY: 'Add New Priority',
  OPTIMA_ORDER_TYPE_RULES: 'Order Type Rules',
  OPTIMA_SHIPMENT_MODE: 'Shipment Mode',
  OPTIMA_ADD_NEW_RULE: 'Add New Rule',

  OPTIMA_CUSTOM_PARAMS: 'Custom Params',
  CUSTOM_PARAM_NAME: 'Name',
  CUSTOM_PARAM_DESCRIPTION: 'Description',
  CUSTOM_PARAM_VALUE: 'Value',

  OPTIMA_VEHICLES: 'Vehicles',
  OPTIMA_VEHICLE: 'Vehicle',
  OPTIMA_FITMENT: 'FITMENT',
  OPTIMA_CONSTRANING_FACTOR: 'CONSTRANING FACTOR',
  OPTIMA_TRUCK_WISE_CONSTRANING_FACTOR: 'TRUCK-WISE CONSTRANING FACTOR',
  OPTIMA_TRUCK_TYPE: 'Truck Type',
  OPTIMA_NO_RECORDS: 'No records',
  OPTIMA_FTL_CERTIFICATION: 'FTL CERTIFICATION',
  OPTIMA_FTL_CERTIFY: 'FTL CERTIFY',

  OPTIMA_MATERIAL_PRIORITY: 'Material Priority',
  OPTIMA_ORDER_CATEGORY: 'ORDER OF CATEGORY',

  OPTIMA_DOCKS: 'DOCKS',
  OPTIMA_NO_OF_DOCKS: 'No Of Docks',

  OPTIMA_JOB_STATUS: 'Job Status',
  OPTIMA_CURRENT_JOB: 'Current Job',
  OPTIMA_VALID_MATERIALS: 'Valid Materials',
  OPTIMA_INVALID_MATERIALS: 'InValid Materials',
  OPTIMA_EXPORT_INDENTS: 'Export Indents',
  OPTIMA_PTL_EXPORT_INDENTS: 'PTL Export Indents',

  OPTIMA_DELIVERY_PICKLIST: 'Delivery Picklist',
  OPTIMA_OPTIMIZE: 'Optimize',
  MOVE_TO_PENDING: 'Move To Pending',
  OPTIMA_PENDING_DELIVERIES_OPTIMIZED: 'All pending deliveries will be optimized',
  OPTIMA_PULL_PICKLIST: 'Pull Picklist',
  OPTIMA_PULL_PICKLIST_TIME: 'Pull Picklist Time',
  OPTIMA_REQUEST_PULL_DELIVERY_PICKLIST: 'Request to pull delivery picklist from ERP',
  OPTIMA_STATUS: 'Status',
  OPTIMA_DIVISION: 'Division',
  OPTIMA_DELIVERY_NO: 'Delivery no',
  OPTIMA_PACKAGE_ID: 'Package Id',
  OPTIMA_DELIVERY_NUMBER: 'Delivery number',
  OPTIMA_RECEIVED: 'Received',
  OPTIMA_RECEIVED_DATE: 'Received Date',
  OPTIMA_PROCESSED: 'Processed',
  OPTIMA_PROCESSED_DATE: 'Processed Date',

  OPTIMA_AUTO_RUN: 'Auto Run',
  OPTIMA_MAX_RUNS_PER_DAY: 'Max runs per day',
  OPTIMA_ENABLE_AUTO_INDENT: 'Enable',
  OPTIMA_DISABLE_AUTO_INDENT: 'Disable',

  OPTIMA_VENDOR_MATERIAL_UPLOAD: 'Vendor Material Upload Across Depots',
  OPTIMA_SAMPLE_FORMAT: 'Sample format',
  OPTIMA_MATERIAL_UPLOAD_STATUS: 'Material Upload Status',

  OPTIMA_OPTIMISATION_CHECKS: 'OPTIMISATION CHECKS',
  OPTIMA_MAXIMUM_PICKUPS: 'MAXIMUM PICKUPS',
  OPTIMA_MAXIMUM_DROPS: 'MAXIMUM DROPS',
  OPTIMA_EXTRA_DROP_CHARGE: 'Extra drop Charge',
  OPTIMA_CONSTRAINING_FACTOR: 'Constraining factor',
  OPTIMA_COMBINE_TYPE: 'COMBINE TYPE',

  OPTIMA_DISPATCH_SCHEDULE: 'Dispatch Schedule',
  OPTIMA_CONSOLIDATE_TITLE: 'CONSOLIDATE SALES ORDERS',
  OPTIMA_CONSOLIDATE_SO_STO: 'CONSOLIDATE PRIMARY AND SECONDARY',
  OPTIMA_TRANSSHIPMENT_THRESHOLD_DETAILS: 'TRANS-SHIPMENT DETAILS',
  OPTIMA_TRANSSHIPMENT_WEIGHT_THRESHOLD: 'WEIGHT THRESHOLD (KG)',
  OPTIMA_TRANSSHIPMENT_VOLUME_THRESHOLD: 'VOLUME THRESHOLD (CFT)',
  OPTIMA_SALES_ORDER_THRESHOLD_DETAILS: 'SECONDARY DISPATCH DETAILS',
  OPTIMA_SALES_ORDER_WEIGHT_THRESHOLD: 'UTILIZATION THRESHOLD - KG(%)',
  OPTIMA_SALES_ORDER_VOLUME_THRESHOLD: 'UTILIZATION THRESHOLD - CFT(%)',
  OPTIMA_CONSOLIDATE_SO_STO_WARNING: 'settings is disabled due to Consolidation Primary & Secondary under Primary movement',
  OPTIMA_FTL_THRESHOLD: 'Ftl Threshold',
  OPTIMA_PTL_THRESHOLD: 'Ptl Threshold',
  OPTIMA_ALLOW_NON_CONTRACTED: 'Allow Non-Contracted',
  LINE_ITEM_LEVEL_EXECUTION: 'Line Item level Execution',
  CAPACITY_VALUES_NEED_CEIL: 'Capacity values to be ceiled',


  // Summary
  OPTIMA_CHANGES_SCREEN_NOT_SAVED: 'The changes made on this screen will not be saved.',
  OPTIMA_SAVE_CHANGES_CLICK_ON_RE_OPTIMIZE: 'to save changes click on re-optimize',
  OPTIMA_GO_BACK: 'Go back',
  OPTIMA_RE_OPTIMIZE_PROMPT: 'Are you sure you want re-optimize with the following changes',

  OPTIMA_DELIVERY_TYPE: 'Delivery Type',
  OPTIMA_FTL: 'FTL',
  OPTIMA_PTL: 'PTL',
  OPTIMA_TRANSPORTER: 'Transporter',
  OPTIMA_VEHICLE_TYPE: 'Vehicle Type',
  OPTIMA_VEHICLE_NUMBER: 'Vehicle No',
  OPTIMA_VEHICLE_DETAILS: 'Vehicle Name',
  OPTIMA_UTILISATION: 'Utilisation',
  OPTIMA_CAPACITY: 'Capacity',
  OPTIMA_DETAILS: 'Details',

  OPTIMA_LOADER: 'Loader',
  OPTIMA_PAID_BY: 'Paid By',
  OPTIMA_DO_NOT_ADD_TO_INVOICE: 'Do not add to invoice',

  OPTIMA_SPLIT: 'Split',
  OPTIMA_COMBINE: 'Combine',
  OPTIMA_SUMMARY: 'SUMMARY',
  OPTIMA_REJECTED_MATERIALS_LIST: 'REJECTED MATERIALS LIST',
  OPTIMAQ_VALID_LIST: 'VALID LIST',
  OPTIMA_INVALID_LIST: 'INVALID LIST',
  OPTIMA_SESSION: 'SESSION',
  OPTIMA_DISCARD: 'DISCARD',
  OPTIMA_DISCARD_ALL: 'Discard All',
  OPTIMA_EXPORT: 'EXPORT',
  OPTIMA_INDENT: 'Indent',
  OPTIMA_INDENTS: 'Indents',
  OPTIMA_COMBINATION_PROMPT: 'Are you sure you want to combine ?',
  OPTIMA_CONTRACT_NOT_AVAILABLE: 'Contracts not available',
  OPTIMA_SPLIT_PROMPT: 'Are you sure you want to split ?',
  OPTIMA_SPLIT_LOADING_PROMPT: 'Please wait. We are Splitting',
  OPTIMA_MATERIALS_MOVED: 'All materials have been moved!',
  OPTIMA_NO_MATERIALS_ADDED: 'If no materials are added',
  OPTIMA_INDENT_DISCARDED: 'Indent will be discarded at "SAVE"',
  OPTIMA_END_BY: 'End By',
  OPTIMA_TOTAL_DISTANCE: 'Total Distance',
  OPTIMA_DISCARD_ALL_DELIVERY_MSG: 'Do you want to discard all delivery ({optimaRejectionslength}) rejection details?',
  OPTIMA_TOTAL_INDENT_COUNT_MSG: 'Total Indent(s) count is {optimaConsigneeslength}',
  OPTIMA_MATERIALS_MISSING_MSG: 'Materials missing for {optimaEmptyOrdersCount} indent(s) will be discarded',
  OPTIMA_DELIVERIES_ARE_NOT_CONVERTED_MSG: 'Deliveries that are not converted to indents ({indentcount}) will be discarded.',
  OPTIMA_CONSIGNEES_DELIVERY_MSG: '1. Move {ConsigneesDeliverylength} consignees to on hold',
  OPTIMA_NOT_COMBINE_MSG: '2. Do not combine {CombineConisgneelength} consignees',
  OPTIMA_AUTO_INDENT: 'Optima auto indent',
  OPTIMA_ENABLE_INDENT: 'Auto indenting',
  OPTIMA_ORIGINAL: 'Original',
  OPTIMA_ORIGINAL_INDENTS: 'Original Indents',
  OPTIMA_LOADING: 'Loading',
  OPTIMA_MOVE: 'Move',
  OPTIMA_UTILIZATION: 'Utilization',
  OPTIMA_DISPATCH_DO_NOT_CHOOSE_VENDOR: 'Dispatch Do Not Choose Vendor',
  OPTIMA_GEOHASH_PRECISION: 'Optima Geohash Precision',
  SEPARATE_OPTIMA_JOB_CONSIGNEE_CLUSTER: 'Seperate Optima Job Consignee Cluster',
  SEPARATE_OPTIMA_JOB_ROUTE_CLUSTER: 'Seperate Optima Job Route Cluster',

  OPTIMA_SOMETHING_WENT_WRONG: 'Something went wrong',
  OPTIMA_DELIVERIES_MOVED: 'All deliveries have been moved!',

  OPTIMA_DELIVERY_STATUS: 'Delivery Status',
  OPTIMA_DELIVERY_STATUS_NAME: 'Name',
  OPTIMA_DELIVERY_STATUS_VALUE: 'value',
  OPTIMA_CALCULATE_MATERIAL_PRIORITY: 'Calculate Material Priority',
  OPTIMA_CREATE_FITMENT_REJECTION_AS_OPEN: 'Create rejection as Open',
  OPTIMA_FTL_THRESHOLD: 'Ftl Threshold',
  OPTIMA_ALLOW_NON_CONTRACTED: 'Allow Non-Contracted',

  // Filter and search
  S_OPTIMA_DELIVERY_NUMBER: 'Delivery number',
  S_OPTIMA_DELIVERY_CONSIGNEE_REF_ID: 'Consignee ref Id',
  S_OPTIMA_DELIVERY_TRANSPORTER_REF_ID: 'Transporter ref Id',
  S_OPTIMA_MATERIAL_CODE: 'Material code',
  S_OPTIMA_DESTINATION_CITY: 'Destination city',
  S_OPTIMA_MATERIAL_CATEGORY: 'Category Priority',
  S_OPTIMA_CREATED_AT: 'Delivery created Date',
  S_OPTIMA_VEHICLE_MODE: 'Vehicle mode',
  S_OPTIMA_TRUCK_TYPE: 'Vehicle name',
  OPTIMA_VEHICLE_REQUIREMENT_DATE: 'Material requirement Date Time',
  OPTIMA_COST: 'Cost',
  OPTIMA_INVOICE_AMOUNT: 'Invoice Amount',
  OPTIMA_MRP: 'MRP',
  OPTIMA_FREIGHT_BY_SALES_PERCENT: 'Freight / Sales %',
  OPTIMA_FREIGHT_BY_MRP_PERCENT: 'Freight / MRP %',
  OPTIMA_EARLIEST_TRUCK_TIME: 'Earliest Truck-in Time',
  S_OPTIMA_CONSIGNEE: 'Consignee',
  OPTIMA_BIN_COUNT: 'Bin Count',
  OPTIMA_PALLET_COUNT: 'Pallet Count',
  OPTIMA_BIN_PALLET_RATIO: 'Bin pallet ratio',
  OPTIMA_BOX_COUNT: 'Box count',
  OPTIMA_TROLLEY_COUNT: 'Trolley count',
  OPTIMA_BOX_TROLLEY_RATIO: 'Box trolley ratio',

  // Label
  OPTIMA_PICKUP_ID: 'Pickup Ref Id (S)',
  OPTIMA_SHIP_TO_REF_ID: 'Ship to ref id',
  OPTIMA_SOLD_TO_REF_ID: 'SOLD to ref id',
  OPTIMA_WT_KG: 'Wt(KG)| Wt%',
  OPTIMA_VL_CFT: 'VL(cft)',
  OPTIMA_QT_NOS: 'qt(nos)',
  OPTIMA_STAGE: 'stage',
  OPTIMA_CODE: 'Code',
  OPTIMA_MOVE_QTY: 'Move Qty',
  OPTIMA_LOCATION: 'Location',
  OPTIMA_DISTANCE: 'Distance',
  OPTIMA_REACH_BY: 'Reach By',
  OPTIMA_RELEASE_BY: 'Release By',
  OPTIMA_COMMENTS: 'Comments (Min 15 Characters)',
  OPTIMA_NOT_COMBINE: 'Dnt Combine',
  OPTIMA_DELIVERY_NUMBERS_HOLD: 'DELIVERY NUMBERs (check to hold)',
  OPTIMA_FILTER_MATERIALS: 'Material',
  OPTIMA_FILTER_ORIGINAL: 'Original',
  OPTIMA_FILTER_TOP_UP: 'Top up',
  OPTIMA_UNDERUTILIZED_INDENT: 'Under Utilized',
  OPTIMA_NON_UNDERUTILIZED_INDENT: 'Non-Under Utilized',
  OPTIMA_DELIVERY: 'Delivery',
  OPTIMA_INTERSPERSED_MOVEMENT: 'Interspersed Movement',
  OPTIMA_MOVE_TO_PENDING: 'Move to pending',
  OPTIMA_PICKLIST_REJECTIONS: 'Picklist Rejection',
  OPTIMA_PICKLIST: 'Picklist',

  // Optima Header
  OPTIMA_S_NO: 'SI.No',
  OPTIMA_RE_OPTIMIZE: 'Re-Optimize',
  OPTIMA_REF_ID: 'Ship-to Ref Id (S)',
  OPTIMA_CITY: 'Drop-off City',
  OPTIMA_NAME: 'Name',
  OPTIMA_DROP_OFF_NAME: 'Ship-to Name (S)',
  OPTIMA_SOLD_TO_NAME: 'Sold-to Name (S)',
  OPTIMA_SOLD_TO_REF: 'Sold-to Ref Id (S)',
  OPTIMA_PICKUP_REF_ID: 'Pickup Ref Id (S)',
  OPTIMA_PICKUP_NAMES: 'Pickup Name (S)',
  OPTIMA_QUANTITY: 'Quantity',
  OPTIMA_REASON: 'Reason',
  OPTIMA_BUN: 'Bun',
  OPTIMA_SALE_DOC: 'SALE DOC',
  OPTIMA_SHIP_TO: 'Ship To',
  OPTIMA_SOLD_TO: 'Sold To',
  OPTIMA_DROP_OFF: 'Drop Off',
  OPTIMA_ROUTE: 'ROUTE',
  OPTIMA_SHIPPED_TO: 'Shipped To',
  OPTIMA_UNLOADERS: 'Unloaders',
  OPTIMA_DEPOT_NAME_REF_ID: 'Depot name & Ref id',
  OPTIMA_DEPOT_CITY: 'Depot city',
  OPTIMA_ADD_MATERIALS: 'Add Materials',

  // Placeholder
  OPTIMA_SELECT: 'Select',
  OPTIMA_SELECT_TRUCK_TYPE: 'Select Truck Type',
  OPTIMA_SELECT_TRANSPORTER: 'Select Transporter',
  OPTIMA_SELECT_VEHICLE: 'Select Vehicle',
  OPTIMA_SELECT_DEPOT: 'Select Depot',
  OPTIMA_SEARCH_DELIVERY_NUMBER: 'Search for Delivery Number',
  OPTIMA_SEARCH_CONSIGNEE_DETAILS: 'Search by Consignee details',
  OPTIMA_AMOUNT: 'Amount',
  OPTIMA_TIMES: 'x times',
  OPTIMA_ADD_MATERIAL_CATEGORY: '+ Add Material Category',
  OPTIMA_ENTER_WEIGHT_THRESHOLD: 'Enter weight threshold',
  OPTIMA_ENTER_VOLUME_THRESHOLD: 'Enter volume threshold',

  // Optima Edit Page
  OPTIMA_EDIT_ORDER: 'EDIT ORDER',
  OPTIMA_UPDATE: 'Update',
  OPTIMA_ENABLE_OPEN: 'Switch to Open',
  OPTIMA_TOPUP_ORDER: 'Topup Order',
  OPTIMA_ENABLE_RFQ: 'Enable RFQ',
  OPTIMA_EDIT: 'Edit',
  OPTIMA_FREIGHT_RATE: 'Freight Rate',
  OPTIMA_MINIMUM_RATE: 'Minimum Rate',
  OPTIMA_STN: 'STN',
  OPTIMA_DELIVERY_DATE: 'Delivery Date',
  OPTIMA_MATERIAL_CATEGORY: 'Material Category',
  OPTIMA_VIRTUAL_SOLD_TO: 'Virtual Sold To',
  OPTIMA_VIRTUAL_SHIP_TO: 'Virtual Ship To',
  OPTIMA_VIRTUAL_PICK_UP: 'Virtual Pick up',
  OPTIMA_TRANSIT_DAYS: 'Transit Days',

  OPTIMA_FETCH_ETA: 'Fetch ETA',
  OPTIMA_SELECT_DATE_AND_TIME: 'Select date and time',
  OPTIMA_SELECT_DATE: 'Select date',

  OPTIMA_INVOICE_NUMBER: 'Invoice number',
  OPTIMA_INVOICE_VALUE: 'Invoice value',
  OPTIMA_MOVEMENT_TYPE: 'Movement Type',
  OPTIMA_PICKUP_DROPOFF: 'Pickup & Dropoff',
  OPTIMA_CREATE: 'Create',
  OPTIMA_DELIVERY_ORDER: 'Delivery order',
  OPTIMA_NEW: 'New',
  OPTIMA_DELETE_SOURCE: 'Delete source',
  OPTIMA_SELECT_GATE: 'Select Gate',
  OPTIMA_ADD_SOURCE_LOCATION: 'Add Source location',
  OPTIMA_CLICK_HERE_TO_ADD: 'Click here to add',
  OPTIMA_GATE: 'gate',
  OPTIMA_EDIT_DROPOFF: 'Edit Drop-off',
  OPTIMA_SELECT_SOURCE: 'Select Source',
  OPTIMA_CITY_LABEL: 'city',
  OPTIMA_SELECT_DROPOFF_GATE: 'Select Drop-off(s) for Gate 1',
  OPTIMA_NO_DATA: 'No data',
  OPTIMA_MATERIAL_CODE: 'Enter Material Code',
  OPTIMA_MATERIAL_NAME: 'Material Name',
  OPTIMA_ENTER_MATERIAL_NAME: 'Enter Material Name',
  OPTIMA_ENTER_MATERIAL_CATEGORY: 'Enter Material Category',
  OPTIMA_ENTER_QUANTITY: 'Enter Quantity',
  OPTIMA_UOM: 'UOM',
  OPTIMA_ENTER_UOM: 'Enter UOM',
  OPTIMA_ENTER_WEIGHT_KG: 'Enter Weight (KG)',
  OPTIMA_ENTER_VOLUME_CFT: 'Enter Volume (CFT)',
  OPTIMA_ENTER_REMARKS: 'Enter Remarks',
  OPTIMA_SELECT_MATERIAL: 'Select Materials',
  OPTIMA_SEARCH_BY_MATERIAL_NAME_CODE: 'Search by Material Name, Code',
  OPTIMA_MATERIAL_TOPUP_SUCCESS: 'Material topup success.',
  OPTIMA_FAILED_TO_TOPUP: 'Check the materials. Failed to do Topup.',
  OPTIMA_PARTIAL_TOPUP: 'Partial topup done.',
  OPTIMA_UNABLE_TOPUP_MATERIAL: 'Unable to topup selected materials',
  OPTIMA_ADD_TO_EXISTING_INDENT: 'Add to Existing Indent',
  OPTIMA_SELECT_INDENT: 'SELECT INDENT',
  OPTIMA_CLEAR_ALL: 'Clear All',
  OPTIMA_APPLY: 'Apply',
  OPTIMA_INDENT_ID: 'Indent ID',
  OPTIMA_SEARCH: 'Search',
  OPTIMA_SOURCE_CITY: 'Source City',
  OPTIMA_DESTINATION_CITY: 'Destination City',
  OPTIMA_VENDOR: 'Vendor',
  OPTIMA_CLEAR_ALL: 'clear all',
  OPTIMA_NO_INDENT_FOUND: 'No indents found',
  OPTIMA_CREATED: 'Created',
  OPTIMA_DISPATCHED: 'Dispatched',
  OPTIMA_KG: 'KG',
  OPTIMA_CFT_UPPERCASE: 'CFT',
  OPTIMA_TOPUP_CONFIRM_MESSAGE : 'Are you sure you want to top up the selected deliveries with indent',
  OPTIMA_INPUT_LISTING_VEHICLE_REQUIREMENT_DATE: 'Vehicle Requirement Date',
  OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE_MAPPING: 'Material Category Vehicle Type Mapping',
  OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE: 'Material Category Vehicle Type',
  
    //optima diagnostics page
  OPTIMA_RUN_NUMBER: 'Run Number',
  OPTIMA_RUN_ID: 'Run Id',
  OPTIMA_CREATED_AT: 'Created At',
  OPTIMA_UPDATED_AT: 'Updated At',
  OPTIMA_SERIAL_NO: 'Serial No',
  OPTIMA_JOB_ID: 'Job Id',
  OPTIMA_JOB_REJECTION_URL: 'Job Rejection URL',
  OPTIMA_JOB_SUMMARY_URL: 'Job Summary URL',
  OPTIMA_JOB_MATERIAL_URL: 'Job Material URL',
  OPTIMA_DATE: 'Date',
  OPTIMA_RUN_REPORT: 'Run Report Excel URL',
  OPTIMA_DATA_VIA: 'Data via',
  OPTIMA_SELECT_DATA_VIA: 'Select Data Via',
  OPTIMA_ENTER_STN: 'Enter STN',
  OPTIMA_REUSE_PRE_OPTIMA_REJECTIONS: 'Reuse pre-optima rejections',
  OPTIMA_REUSE_POST_OPTIMA_REJECTIONS: 'Reuse post-optima rejections',
  OPTIMA_DIAGNOSTICS_RUNNING: 'Diagnostics running',
  OPTIMA_VALIDATING_YOUR_INPUT: 'Validating your input',
  OPTIMA_FAILED_TO_RUN_DIAGNOSTICS: 'Failed to run diagnostics',
  OPTIMA_DIAGNOSTICS_COMPLETED_SUCCESSFULLY: 'Diagnostics completed successfully',
  OPTIMA_ERP: 'ERP',
  OPTIMA_DIAGNOSTICS_RUN: 'Diagnostics Run',
  OPTIMA_DIAGNOSTICS_REPORT: 'Diagnostics Report',
  OPTIMA_FETCHING_YOUR_REPORTS: 'Fetching your reports',
  OPTIMA_COPIED_TO_CLIPBOARD: 'Copied to clipboard',
  OPTIMA_FAILED_TO_COPY: 'Failed to copy',

  DATE_ROLL_ADMIN_HEADING: 'DATE ROLL SETTINGS',
  DATE_ROLL_TABLE_S_NO: 'S. No',
  DATE_ROLL_TABLE_CARRIER: 'Carriers',
  DATE_ROLL_TABLE_DEPOT_PLACEHOLDER: 'Select',
  DATE_ROLL_TABLE_DEPOT_TABLE_HEADER: 'Add new',
  DATE_ROLL_TABLE_CUTOFFTIME: 'Cut-off-Time',
  DATE_ROLL_TABLE_NO_OF_DAYS: 'No of Days',
  DATE_ROLL_TABLE_SCHEDULE_DAYS: 'Schedule Days',
  DATE_ROLL_TABLE_UPDATED_BY: 'Updated By',
  DATE_ROLL_TABLE_NO_DATA: 'No data found!',
  DATE_ROLL_TABLE_EDIT: 'EDIT',
  DATE_ROLL_TABLE_DELETE: 'DELETE',
  DATE_ROLL_TABLE_UPDATE_HEADER: 'Update Date Roll',
  DATE_ROLL_TABLE_ADD_HEADER: 'Add New Date Roll',
  DATE_ROLL_TABLE_CANCEL: 'Cancel',
  DATE_ROLL_TABLE_UPDATE: 'Update',
  DATE_ROLL_TABLE_ADD: 'Add',
  DATE_ROLL_TABLE_SELECT_OPTION: 'Select options',
  DATE_ROLL_TABLE_SELECT_CUTTOFF: 'Select Cut-off Time',
  DATE_ROLL_TABLE_SELECT_LABEL_NUMBER: 'Number of Days',
  DATE_ROLL_TABLE_SELECT_NUMBER: 'Choose Number of Days',
  DATE_ROLL_TABLE_SELECT_DEPOT: 'Select Depots',
  DATE_ROLL_TABLE_APPLY_DEPOT: 'Apply Settings to Depot(s)',
  DATE_ROLL_UPDATE_SUCCESS: 'Date roll updated successfully',
  DATE_ROLL_ADDED_SUCCESS: 'Date roll added successfully',
  DATE_ROLL_CONFIRM_BODY: 'Are you sure want to delete the selected rule ?',
  DATE_ROLL_CONFIRM_HEADER: 'Delete Rule.',
  DATE_ROLL_DEACTIVATE_CONFIRM_HEADER: 'Deactivate rule.',
  DATE_ROLL_DEACTIVATE_CONFIRM_BODY: 'Are you sure want to deactivate the selected rule ?',
  DATE_ROLL_ACTIVATE_CONFIRM_HEADER: 'Activate rule.',
  DATE_ROLL_ACTIVATE_CONFIRM_BODY: 'Are you sure want to activate the selected rule ?',
  DATE_ROLL_ACTIVATE: 'Activate',
  DATE_ROLL_DEACTIVATE: 'Deactivate',
  DATE_ROLL_STATUS: 'Status',

  // Admin Page
  ADMIN_MINIMUM_WEIGHT_IN_PERCENTAGE: 'Minimum Weight (%)',
  ADMIN_MAXIMUM_WEIGHT_IN_PERCENTAGE: 'Maximum Weight (%)',
  ADMIN_MINIMUM_VOLUME_IN_PERCENTAGE: 'Minimum Volume (%)',
  ADMIN_MAXIMUM_VOLUME_IN_PERCENTAGE: 'Maximum Volume (%)',
  ADMIN_MINIMUM_WEIGHT: 'Minimum Weight',
  ADMIN_MAXIMUM_WEIGHT: 'Maximum Weight',
  ADMIN_MINIMUM_VOLUME: 'Minimum Volume',
  ADMIN_MAXIMUM_VOLUME: 'Maximum Volume',
  ADMIN_VEHICLE_UTILISATION_BASED_ON: 'Vehicle Utilisation Based On',
  ADMIN_MOVEMENT: 'Movement',
  ADMIN_VEHICLE_TYPE: 'Vehicle Type',
  ADMIN_SAVE: 'SAVE',
  ADMIN_VEHICLE_UTILISATION: 'Vehicle Utilisation',
  ADMIN_DEPOT_SELECT: 'DEPOT',
  ADMIN_LOADING_DETENTION: 'Loading Detention',
  ADMIN_UNLOADING_DETENTION: 'UnLoading Detention',
  ADMIN_DETENTION_ENABLE_PROMPT: 'Enable at',
  ADMIN_CLIENT: 'Client',
  ADMIN_DEPOT: 'DEPOT',
  ADMIN_DETENTION_NOT_SET_AT_DEPOT: 'If detention not set at depot',
  ADMIN_GO_BACK_TO_CLIENT_SETTINGS: 'Fall-back to client settings',
  ADMIN_ADD_LEGAL_ENTITY: 'Add Legal Entity',
  ADMIN_DELETE_LEGAL_ENTITY_PROMPT: 'Are you sure you want to delete Legal entity',
  ADMIN_LEGAL_ENTITY: 'Legal Entity',

  TRAFFIC_VALIDATION_HEADING: 'TRAFFIC VALIDATION SETTINGS',
  TRAFFIC_PANEL: 'TRAFFIC',
  LOCATION_MILESTONE_UPLOAD: 'Location Milestone Upload',
  PACKING_NOTES: 'PACKING NOTES',

  INDENT_RESHIP_INDENT: 'Re-Ship Cartons',
  INDENT_RESHIP_PROMPT: 'Are you sure you want to re-ship all selected cartons? Add reason for re-shipping if sure.',
  INDENT_RESHIP_CANCEL: 'Cancel',
  INDENT_RESHIP_SUCCESS: 'Re-Ship',
  INDENT_RESHIP_REASON: 'Reason',
  INDENT_RESHIP_PLACEHOLDER: 'Add Reason',

  INDENT_RESHIPPED: 'RE-SHIPPED',
  INDENT_RESHIPPED_STATUS: 'Re Ship',
  INDENT_RESHIP_PROCESSING: 'ReShip \n Processing',
  INDENT_RESHIP_ERROR: 'ReShip Error',

  PROFILE_ADD_NEW: 'ADD NEW',
  PROFILE_DEACTIVATE: 'DEACTIVATE',
  PROFILE_SAVE: 'SAVE',
  PROFILE_LORRY_RECEIPT_ALLOCATION: 'LORRY RECEIPT ALLOCATION',
  PROFILE_EDIT: 'EDIT',
  CURRENT_LR_SERIES: 'Current LR Series',
  PREVIOUS_LR_SERIES: 'Previous LR Series',
  NEXT_LR_SERIES: 'Next LR Series',

  MDM_DESTINATION_CHARGES_HEADING: 'DESTINATION CHARGES',
  MDM_DESTINATION_CHARGES_DETAILS: 'DETAILS',
  MDM_DESTINATION_CHARGE_SOURCE: 'Source',
  MDM_DESTINATION_TYPE: 'Destination Type',
  MDM_DESTINATION_CHARGE_DESTINATION: 'Destination',
  MDM_DESTINATION_CHARGE_MOVEMENT: 'Movement',
  MDM_DESTINATION_CHARGE_TRANSPORTER_REF_ID: 'Transporter Ref Id',
  MDM_DESTINATION_CHARGE_VEHICLE_TYPE: 'Vehicle Type',
  MDM_DESTINATION_CHARGE_UNIT: 'Charge Unit',
  MDM_DESTINATION_CHARGE_CODE: 'Charge Code',
  MDM_DESTINATION_CHARGE_MIN_CHARGE: 'Min Charge',
  MDM_DESTINATION_CHARGE_MAX_CHARGE: 'Max Charge',
  MDM_DESTINATION_SLAB_UNIT: 'Slab Unit',
  MDM_DESTINATION_CHARGE: 'Charge',
  MDM_DESTINATION_SLAB_MIN: 'Slab Min',
  MDM_DESTINATION_SLAB_MAX: 'Slab Max',
  MDM_DESTINATION_REMARKS: 'Remarks',

  MDM_SOURCE_CHARGES: 'SOURCE CHARGES',
  MDM_SOURCE_CHARGES_DETAILS: 'DETAILS',
  MDM_SOURCE_CHARGE_SOURCE: 'Source',
  MDM_SOURCE_CHARGE_SOURCE_TYPE: 'Source Type',
  MDM_SOURCE_CHARGE_MOVEMENT: 'Movement',
  MDM_SOURCE_CHARGE_TRANSPORTER_REF_ID: 'Transporter Ref Id',
  MDM_SOURCE_CHARGE_VEHICLE_TYPE: 'Vehicle Type',
  MDM_SOURCE_CHARGE_UNIT: 'Charge Unit',
  MDM_SOURCE_CHARGE_CODE: 'Charge Code',
  MDM_SOURCE_CHARGE_MIN_CHARGE: 'Min Charge',
  MDM_SOURCE_CHARGE_MAX_CHARGE: 'Max Charge',
  MDM_SOURCE_SLAB_UNIT: 'Slab Unit',
  MDM_SOURCE_CHARGE: 'Charge',
  MDM_SOURCE_SLAB_MIN: 'Slab Min',
  MDM_SOURCE_SLAB_MAX: 'Slab Max',

  MDM_TRANSPORTATION_SKU: 'SKU',
  MDM_TRANSPORTATION_MODE: 'Transporter Mode',
  MDM_TRANSPORTATION_MAX_QTY: 'Max Qty',
  MDM_TRANSPORTATION_CATEGORY: 'Category',
  MDM_TRANSPORTATION_PKG_DETAIL: 'Pkg Detail',
  MDM_TRANSPORTATION_VOL: 'Vol',
  MDM_TRANSPORTATION_UNIT_OF_MEASURE: 'Unit Of Measure',
  MDM_TRANSPORTATION_SERVICE_CODE: 'Service Code',
  MDM_TRANSPORTATION_CONTENT_ID: 'Content ID',
  MDM_TRANSPORTATION_INNER_QUANTITY: 'Inner Quantity',

  MDM_TRANSPORTER_REFEREMCE_ID: 'Reference Id',
  MDM_DISCOUNT_PER: 'Discount(%)',
  MDM_CREDIT_PERIOD: 'Credit Period',
  MDM_MSME: 'MSME',
  MDM_GSTIN: 'GSTIN',

  MDM_USER_NAME: 'User Name',
  MDM_EMAIL_ID: 'EMAIL ID',
  MDM_INBOUND: 'INBOUND',
  MDM_OUTBOUND: 'OUTBOUND',
  MDM_BOTH: 'BOTH',
  MDM_DEPOT_PERMISSION: 'DEPOT PERMISSION',
  MDM_TRANSPORTER_ASSOCIATED_DEPOTS: 'ASSOCIATED DEPOTS',

  MDM_PROGRAM_ID: 'Program ID',
  MDM_DAYS_EARLY: 'Days Early',
  MDM_DISCOUNT_RATE: 'Discount Rate (%)',

  MDM_AVAILABILITY_IN: 'Vehicle available In',

  MDM_NEW_CONSIGNEE: 'New Consignee',
  MDM_CONSIGNEE_CREATE_SUCCESS: 'Consignee Created Successfully',
  MDM_CONSIGNEE_UPDATE_SUCCESS: 'Consignee Updated Successfully',
  MDM_CONSIGNEE_USER_CREATE_SUCCESS: 'Consignee Secondary User Created Successfully',
  MDM_CONSIGNEE_COORDINATES_UPDATE_SUCCESS : 'Consignee Coordinates Updated Successfully',
  MDM_NEW_BUCC: 'New Bucc',
  MDM_BUCC_CREATE_SUCCESS: 'Cost Center Created Successfully',
  MDM_BUCC_UPDATE_SUCCESS: 'Cost Center Updated Successfully',
  MDM_SELECT_DEPOT_USER: 'Please select depot user',
  MDM_VEHICLE_DETAIL_UPDATE_SUCCESS: 'Vehicle Details Updated Successfully',
  MDM_CANNOT_LOAD_LIST: 'Cannot load vehicles list',
  MDM_CANNOT_LOAD_FREIGHT_LIST: 'Cannot load Freight Forwarders list',
  DEPOT_UNSAVED_CHANGES_PROMPT: 'Are you sure you want to switch tab?',
  DEPOT_UNSAVED_CHANGES: 'Unsaved changes',


  ADMIN_IS_DEFAULT_CATEGORY: 'Is Default Category',
  ADMIN_TAX_SUPPORT: 'Tax Support',
  ADMIN_APPLY_DEDUCTIONS: 'Apply Deductions',
  ADMIN_DISPLAY_DEDUCTIONS: 'Display Deductions',
  ADMIN_SHOW_INVOICE_PREVIEW: 'Show Invoice Preview',
  ADMIN_SHOW_MAIN_INVOICE_ANNEXURE: 'Show Mail Invoice Annexure',
  ADMIN_OPTIONS_SELECTED: 'options selected',
  ADMIN_DATE_RANGE: 'Date Range',
  ADMIN_ADD: 'ADD',
  ADMIN_ADD_NEW: 'Add New',
  ADMIN_CANCEL: 'Cancel',
  ADMIN_CONFIRM: 'Confirm',
  ADMIN_UPDATE: 'Update',
  ADMIN_BID_EXPIRY_EXTEND: 'AUTO EXTEND BID EXPIRY',
  ADMIN_BID_EXPIRY_EXTEND_BY: 'EXTEND BID EXPIRY BY',
  ADMIN_BID_EXPIRY_CUT_OFF: 'BID EXPIRY CUT OFF',
  ADMIN_NUMBER_OF_EXTENSIONS: 'NUMBER OF EXTENSIONS',
  AUTO_EXTEND_BID_EXPIRY: 'Auto Extend Bid Expiry',
  AUTO_EXTEND_BID_EXPIRY_TIMELINE: 'Bid expiry extended from {from} to {to}',

  ADMIN_SLAB_NAME: 'SLAB NAME',
  ADMIN_TRANSPORTER: 'Transporter',
  ADMIN_BIDS_SLOT_SETTING: ' Bids Slot Settings',
  ADMIN_BID_SLOT: 'BID SLOT',
  ADMIN_HOURS: 'Hours',
  ADMIN_MINUTES: 'Minutes',
  ADMIN_BUSINESS_HOURS: 'Business Hours',
  ADMIN_CONFIRMATION: 'Confirmation',
  ADMIN_CENTRAL_HEAD_OFFICE: 'CENTRAL HEAD OFFICE',
  ADMIN_HEAD_OFFICE_NAME: 'Head Office Name',
  ADMIN_CENTRAL_HO_DELETE_PROMPT: 'Are you sure you want to delete this Central HO?',
  ADMIN_FCM_CENTRAL_HO_DETAILS: 'FCM Central HO Details',
  ADMIN_FCM_ADDRESS: 'FCM Address',
  ADMIN_ADDRESS: 'Address',
  ADMIN_CITY: 'City',
  ADMIN_STATE: 'State',
  ADMIN_PINCODE: 'PINCODE',
  ADMIN_GSTIN: 'GSTIN',
  ADMIN_RCM_CENTRAL_HO_DETAILS: 'RCM Central HO Details',
  ADMIN_RCM_ADDRESS: 'RCM Address',
  ADMIN_CLIENT_TOKEN: ' Client Token',
  ADMIN_DETENTION_SETTINGS: 'DETENTION SETTINGS',
  ADMIN_HOLIDAY: 'Holiday',
  ADMIN_INCLUDE: 'Include',
  ADMIN_DAYS: 'Days',
  ADMIN_THRESHOLD: 'THRESHOLD',
  ADMIN_ENTER_HEAD_OFFICE_NAME: 'Enter Head Office Name',
  ADMIN_ENTER_ADDRESS: 'Enter Address',
  ADMIN_ENTER_CITY: 'Enter City',
  ADMIN_SELECT: 'Select',
  ADMIN_ENTER_PINCODE: 'Enter Pincode',
  ADMIN_ENTER_GSTIN_NUMBER: 'Enter GSTIN Number',
  ADMIN_SELECT_THRESHOLD_TIME: 'Select Threshold time',
  ADMIN_SELECT_START_TIME: 'Select Start time',
  ADMIN_ENTER: 'Enter',
  ADMIN_DOCUMENT_CODE: 'Document Code',
  ADMIN_DOCUMENT_NAME: 'Document Name',
  ADMIN_PRINTER_TYPE: 'Printer Type',
  ADMIN_PRINT_LEVEL: 'Print Level',
  ADMIN_DEFAULT_COPIES: 'Default Copies',
  ADMIN_SIGNATURE_IMAGE: 'Signature Image',
  ADMIN_AUTO_PRINT: 'Auto Print',
  ADMIN_STAGE_AUTO_PRINT: 'Stage Of Auto Print',
  ADMIN_NO_OF_COPIES_AUTO_PRINT: 'No Of Copies Auto Print',
  ADMIN_DOCUMENT_CODE_SHOULD_UNIQUE_ERR: 'Document code should be unique for each config',
  ADMIN_ADD_LOWER_LIMIT_VALUE: 'Add Lower Limit Value',
  ADMIN_ADD_PROCESSING_TIME: 'Add Processing Time',
  DETENTION_FROM_REPORTED_AT: 'Detention starts from Reported-at',
  DETENTION_FROM_TRUCK_IN: 'Detention starts from Truck - In',
  DONT_CONSIDER_HOLIDAY: 'Don\'t Consider holiday if vehicle reached before threshold',

  ADMIN_MASTER_CUSTOM_FIELDS: 'Master Custom fields',
  ADMIN_ADD_CUSTOM_FIELDS: 'Add Custom fields',
  ADMIN_DOCUMENT_SETTINGS: 'Document Settings',
  ADMIN_DOCUMENT_AVAILABLE: 'Documents Available',
  ADMIN_AUTHORISED_SIGNATORY: 'Authorised Signatory',
  ADMIN_NO_DATA_FOUND: 'No data found!',

  ADMIN_DYNAMIC_DISCOUNTING_SETTINGS: 'Dynamic Discounting Settings',
  ADMIN_INVOICE_LOWER_LIMIT: 'INVOICE LOWER LIMIT (INCLUSIVE)',
  ADMIN_PROCESSING_TIME_DAYS: 'PROCESSING TIME (IN DAYS)',
  ADMIN_FIXED_DEBIT: 'Fixed Debit',
  ADMIN_AMOUNT: 'Amount',

  ADMIN_GATE_PASS: 'Gate Pass',
  GENERATE_GATE_PASS: 'Generate Gate Pass',

  ADMIN_FREIGHT_BILL_POSTING: 'Freight Bill Posting',
  EXCLUDE_FREIGHT_BILL_POSTING: 'Exclude Freight Bill Posting',

  ADMIN_UPDATE_SUCCESSFUL: 'Update successful',
  ADMIN_UPDATE_FAILED: 'Update failed',
  ADMIN_UPDATE_FREIGHT_CONFIG: ' Update Freight Configurations',
  ADMIN_ADD_CATEGORY: 'ADD CATEGORY',
  ADMIN_VIEW_INTEGRATION: 'VIEW INTEGRATION',
  ADMIN_ENABLE_FREIGHT_BILL: 'Enable Freight Bill',

  ADMIN_NAME: 'Name',
  ADMIN_NUMBER: 'Number',
  ADMIN_SHORT_CODE: 'Short Code',
  ADMIN_CHARGES: 'Charges',
  ADMIN_DEPOTS: 'Depots',
  ADMIN_VIEW_INTEGRATION_CONFIG: 'View Integration Config',
  ADMIN_ENTER_DIFFERENTIAL_COST_THRESHOLD: 'Enter Differential cost threshold',
  ADMIN_ENTER_TOTAL_FREIGHT_CHARGE_THRESHOLD: 'Enter total freight charge threshold',
  ADMIN_DATE_RANGE_DAILY: 'Date Range (Is Daily)',
  ADMIN_BASE_URL: 'Base URL',
  ADMIN_AUTH_TYPE: 'Auth Type',
  ADMIN_AUTH: 'Auth',
  ADMIN_CERTIFICATE_DETAILS: 'Certificate Details',
  ADMIN_PRIVATE_KEY_PATH: 'Private Key Path',
  ADMIN_CLIENT_SIGNED_CERTIFICATE_PATH: 'Client Signed Certificate Path',
  ADMIN_PASS_PHRASE: 'Pass Phrase',
  ADMIN_END_POINTS: 'End Points',
  ADMIN_FREIGHT_BILL_POSTING: 'Freight Bill Posting',
  ADMIN_FREIGHT_CHARGES_SETTINGS: 'FREIGHT CHARGES SETTTINGS',
  ADMIN_FREIGHT_CHARGES_THRESHOLD: 'Freight charges Threshold',
  ADMIN_DIFFERENTIAL_COST_THRESHOLD: 'Differential Cost Threshold',
  ADMIN_TOTAAL_FREIGHT_THRESHOLD: 'Total Freight Charge Threshold',
  ADMIN_FREIGHT_CHARGES_THRESHOLD_ERR: 'Differential cost threshold should be lesser than Total freight charge threshold',
  ADMIN_HOOKS: 'Hooks',
  ADMIN_INSPECTION: 'INSPECTION',
  ADMIN_INSURANCE_THRESHOLD: 'Insurance Threshold',
  ADMIN_SLAB_TYPE: 'Slab Type',
  ADMIN_NO_OF_TRANSPORTER: 'No Of Transporter',
  ADMIN_XXXX: 'XXXX',
  ADMIN_NOTE: 'Note',
  ADMIN_LR_NUMBER_NOTE: 'If short code is not entered, the LR Number will be generated with the default YYZZ short code',
  ADMIN_AUTO_GENERATE_LR_TEXT: 'TRS548866/CLN/',
  ADMIN_AUTO_GENERATE_TEXT: ' TRS548866/',
  ADMIN_AUTO_GENERATE_LR_SHORT_CODE: '/1063',
  ADMIN_AUTO_GENERATE_TEXT_SHORT_CODE: '/BLR/1063',
  ADMIN_CUSTOM_FIELDS: 'Custom Fields',
  ADMIN_ADD_ITEM: '+ Add Item',
  ADMIN_CHOOSE_MATERIAL_HEADER_COMBINATIONS: 'Choose material header combinations',
  ADMIN_SELECT_DATE: 'Select Date',
  ADMIN_ADD_REASON: 'Add Reason',
  ADMIN_HH_MM: 'HH:MM',
  ADMIN_HH_MM_SS: 'HH:MM:SS',
  ADMIN_ENTER_SLAB_NAME: 'Enter slab name',
  ADMIN_SEARCH_BY_TRANSPORTER_REF_ID: 'Search by Transporter Ref ID',
  ADMIN_VALUE: 'value',
  ADMIN_DEDUCTIBLE_AMOUNT: 'Deductible amount can"t be',
  ADMIN_EMPTY_SHOULD_BE_LESS_TEXT: 'empty, should be less than',
  ADMIN_PENALTY_NAME: 'Penalty Name',
  ADMIN_ENTER_PENALTY_NAME: 'Enter Penalty Name',
  ADMIN_VALUE_TYPE: 'Value Type',
  ADMIN_ENTER_VALUE: 'Enter Value',
  ADMIN_TRANSPORTER_NAME_REF_ID: 'Transporter Name & Ref ID',
  ADMIN_TRANSPORTER_SETTINGS: 'Transporter Setting',

  ADMIN_SLAB_SETTINGS: 'SLAB Settings',
  ADMIN_SLAB_ADD: 'ADD SLAB',
  ADMIN_EDIT: 'Edit',
  ADMIN_DELETE: 'Delete',
  ADMIN_LR_NUMBER: 'LR number',
  ADMIN_AUTO_GENERATE_LR: 'Auto generate LR number',
  ADMIN_CUSTOM_SHORT_CODE: 'Enter Custom Short code',
  ADMIN_SLA_SETTINGS: 'SLA Settings',
  ADMIN_SLA_NUMBER_OF_HOURS: 'Number of hours',
  ADMIN_SLA_NUMBER_OF_MINUTES: 'Number of Minutes',
  ADMIN_TIME: 'TIME',
  ADMIN_SLOTS: 'SLOTS',
  ADMIN_SLOT: 'SLOT',
  ADMIN_ADD_SLOT: 'ADD SLOT',
  ADMIN_START_TIME: 'START TIME',
  ADMIN_END_TIME: 'END TIME',
  ADMIN_LOADING: 'Loading.....',
  ADMIN_TRANSIT_PENALTY: 'TRANSIT PENALTY',
  ADMIN_CONFIGURATION: 'Configuration',
  ADMIN_PENALTY_RULE_ADDITION: 'Penalty Rules Addition',
  ADMIN_ADD_RULES: 'ADD Rules',
  ADMIN_WALLET_SETTINGS: 'Wallet Settings',
  ADMIN_AUTO_APPROVAL: 'Auto Approval',
  ADMIN_NO_OF_DAYS: 'No of Days',
  ADMIN_WALLET_VIEW_ENTRIES: 'Can View Wallet Entries',
  ADMIN_WALLET_UPDATE_CONFIG: 'Update Wallet Configurations',
  ADMIN_WALLET_APPROVAL_REQ: 'Approval Required',
  ADMIN_WALLET_MATERIAL_LEVEL: 'Material Level SDLC',
  ADMIN_WALLET_MAIL_NOTIFY: 'Mail Notifications',
  ADMIN_WALLET_GENERATED: 'Generated',
  ADMIN_WALLET_AUTO_APPROVAL_DELAY: 'Auto Approval Delay Days',
  ADMIN_WALLET_APPROVAl_ROLES_BASED_ON_REASON: 'Approver Roles Based On Reason',
  ADMIN_WALLET_REASON: 'Reason',
  ADMIN_WALLET_SOURCE_APPROVER_ROLES: 'Source Approver Roles',
  ADMIN_WALLET_DESTINATION_APPROVER_ROLES: 'Destination Approver Roles',
  ADMIN_WALLET_REASON_LEVEL_CONFIG: 'Reason level configuration',
  ADMIN_WALLET_VIEW_SLIDER: 'View Wallet Slider',
  ADMIN_WALLET_INDISPUTABLE_ENABLED: 'Indisputable Enabled',
  ADMIN_MATRICS: 'Metrics',
  ADMIN_DEFAULT: 'Default',
  ADMIN_ADD_NON_WORKING_DAYS: 'Add Non Working Days',
  ADMIN_NON_WORKING_WEEKLY_HOLIDAY: 'Weekly Holiday',
  ADMIN_NON_WORKING_DEPOT_DAYS: 'Depot Non Working Days',
  ADMIN_NON_WORKING_DAY: 'Non Working Day',
  ADMIN_NON_WORKING_DAYS: 'Non Working Days',
  ADMIN_NOTIFICATION: 'Notifications',
  ADMIN_EMAIL: 'EMAIL',
  ADMIN_SMS: 'SMS',
  ADMIN_VEHICLE_ASSIG: 'Vehicle Assignment',
  ADMIN_VEHICLE_REPORT: 'Vehicle reported',
  ADMIN_NOTIFY_TEXT: 'Indent status of the day ( Total indents | Accepted | Assigned)',
  ADMIN_TRANSPORTER_NOTIFY: 'TRANSPORTER NOTIFICATIONS',
  ADMIN_ADD_HOC_INDENT: 'Ad-hoc Indent',
  ADMIN_SLA_BREACH_NOTIFY: 'SLA breach warning for Indent acceptance',
  ADMIN_SLA_BREACH_ARRAIVAL: 'SLA breach : Vehicle arrival',
  ADMIN_NEW_SLAB: 'New Slab',
  ADMIN_OPEN_INDENTS: 'Open Indents',
  ADMIN_OPEN_INDENTS_CHARGES: 'CHARGES',
  ADMIN_RFQ_EXPIRY: 'RFQ Expiry',
  ADMIN_SHORTAGE_DAMAGE: 'Shortage/Damage',
  ADMIN_CALCULATIONS: 'CALCULATIONS',
  ADMIN_MATERIAL_HEADERS: 'Material Headers',
  ADMIN_MATERIAL_HEADER_UPDATE: 'Material Update Combination',
  ADMIN_MATERIAL_HEADER_FILED_EXIST_ERR: 'Field already exist',
  ADMIN_DEDUCTIBLE: 'Deductible',
  ADMIN_CHARGE_TYPE: 'Charge Type',
  ADMIN_SEARCH_BY_REF_ID: 'Search by Ref ID',
  ADMIN_APPLY_ALL: 'Apply to all',
  ADMIN_CHECK_ALL: 'Check all',
  ADMIN_DEPOT: 'Depot',
  ADMIN_INVOICE_FIELD_SETTINGS: 'Invoice Field Settings',
  ADMIN_ADD_FIELD: 'Add Field',
  ADMIN_DELETE_FIELD: 'Delete Field',
  ADMIN_DELETE_CONFORMATION_MESSAGE: 'Are you sure you want to delete custom field',
  ADMIN_ENTER_FIELD_NAME: 'Enter Field Name',
  ADMIN_SELECT_TYPE: 'Select Type',
  ADMIN_VISIBLE_TO_TRANSPORTER: 'Visible to Transporter',
  ADMIN_FIELD_TYPE: 'Field Type',
  ADMIN_FIELD_LABEL: 'Field label',
  ADMIN_MANDATORY: 'Mandatory',
  ADMIN_FIELD_NAME: 'Field Name',
  ADMIN_CARRIER: 'Carrier',
  ADMIN_DESCRIPTION: 'description',
  ADMIN_CUT_OFF_TIME: 'Cut-off Time',
  ADMIN_SCHEDULE: 'Schedule',
  ADMIN_ENTER_TAG_NAME: 'Enter Tag Name',
  ADMIN_COST: 'cost',
  ADMIN_PERCENTAGE : 'percentage',
  ADMIN_NEW_RULE: 'New Rule',
  ADMIN_ENABLED: 'Enabled',
  ADMIN_DISABLED: 'Disabled',

  // Approvals settings
  ADMIN_APPROVAL_SETTINGS: 'Approval Settings',
  ADMIN_APPROVAL_DETAILS: 'Approval Details',
  ADMIN_APPROVAL_TYPE: 'Approval Type',
  ADMIN_APPROVAL_SEND_EMAIL: 'Send Email Notification',
  ADMIN_APPROVAL_TEAMS_INTEGRATION: 'Notifications Integration Available',
  ADMIN_APPROVAL_MANDATE: 'Mandate Across All Users',
  ADMIN_EVENT_TYPE: 'Event Type',
  ADMIN_DELIVERY_TYPE: 'Delivery Type',
  ADMIN_APPROVAL_LEVELS: 'Approval Levels',
  ADMIN_ADD_APPROVAL: 'Add Level/Slab',
  ADMIN_MINIMUM_SLAB: 'Minimum Slab',
  ADMIN_MAXIMUM_SLAB: 'Maximum Slab',
  ADMIN_APPROVAL_BY: 'Approval By',
  ADMIN_SEQUENTIAL_TEXT: 'Approval needs to be done in the order mandatorily ie L1<L2<L3',
  ADMIN_PARALLEL_TEXT: 'Approvals can be done parallely without any order',
  ADMIN_MANDATE_YES_TEXT: 'All associated users of that role need to approve',
  ADMIN_MANDATE_NO_TEXT: 'Approval of any one associated user of that role is enough',
  ADMIN_APPROVAL_SEQUENTIAL: 'Sequential',
  ADMIN_APPROVAL_PARALLEL: 'Parallel',
  ADMIN_THRESHOLD_BASED_ON: 'Threshold based on',

  INDENT_SELECT_DOCUMENT_TYPE_DOWNLOAD: 'Select the document type to download',
  INDENT_RETRY_SUCCESS: 'Retry Successful',
  INDENT_RETRY_FAIL: 'Retry Failed',
  INDENT_POD_UPLOAD_MSG: "POD upload started in background. You'll receive rejected line item list in email ",
  INDENT_POD_UPLOAD_ERR: 'Error in POD upload',
  INDENT_NO_FILE_SELECTED: 'No file selected',
  INDENT_UNABLE_TO_PROCESS: 'Unable to process your xlsx file',
  INDENT_MATERIAL_BULK_UPLOAD_WAIT: 'Material Bulk upload is processing your file.Please wait...',
  INDENT_MATERIAL_BULK_UPLOAD_PROCESS: 'Material Bulk upload is processing your file in the background. You will receive an email soon about the upload.',
  INDENT_MATERIAL_DELETE_UPLOAD_PROCESS: 'Material Delete upload is processing your file.Please wait...',
  INDENT_MATERIAL_BULK_UPLOAD_PROCESS_BACKGROUND: 'Material Delete upload is processing your file in the background',
  INDENT_DELIVERY_RESHIPPED: 'Deliveries reshipped successfully',
  INDENT_REJECTION_EMAIL: 'Rejection has sent to your email',
  INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD_PROCESS: 'Material Invoice Grn Bulk upload is processing your file.Please wait...',
  INDENT_MATERIAL_INVOICE_GRN_BULK_UPLOAD_PROCESS_BACKGROUND: 'Material Invoice Grn Bulk upload is processing your file in the background.',
  INDENT_YES_PROCEED: 'YES, PROCEED',
  INDENT_LOCATION_NOT_AVAILABLE: 'Location Not Available',
  INDENT_NO_ACCESSIBLE_DESTINATIONS: 'No accessible destinations',
  INDENT_SELECT_TRANSPORTER_TO_INDENT: 'Select a transporter to indent',
  INDENT_MATERIAL: 'Material',
  INDENT_POSITION: 'Position',
  INDENT_AUDIT_NOT_FOUND: 'Audit not found for the delivery',
  SORT_BY_ACTION: 'Sort By Action',
  INDENT_RESHIPING_CARTONS_PROMPT: 'Are you sure you want to re-ship all cartons by changing Ship Method? Add reason for re-shipping if sure.',
  INDENT_CARRIER_LOADING: 'Carrier Loading...',
  INDENT_RESHIPING_SUCCESS: 'ReShip Processing Successfully',
  INDENT_CEILING_PRICE: 'CEILING PRICE',
  INDENT_FREIGHT_AMOUNT_MISSING: 'freight amount missing',
  INDENT_CHOOSE_VEHICLE_REQ_DATE: 'Choose vehicle requirement date',
  INDENT_SELECT_TRANSPORTERS: 'Select transporter(s)',
  INDENT_REQUEST_FOR_QUOTES: 'Requested for quote(s)',
  INDENT_RFQ_TAGS: 'Selected tags will display here',
  INDENT_NO_RESULT_FOUND: 'No results found',
  INDENT_SOURCE_CITY: 'SOURCE CITY',
  INDENT_GATE_REF_ID: 'GATE REF ID',
  INDENT_IN_PROGRESS: 'In Progress',
  INDENT_BOOKING_FAILED: 'Booking Failed',
  INDENT_PLEASE_WAIT: 'Please wait',
  INDNET_AWAITING_UPDATE_TRANSPORTER: 'Awaiting update from Transporter',
  INDENT_RETRIGGER: 'Retrigger',
  INDENT_FETCH: 'Fetch',
  INDENT_TRACKING_HISTORY_EMPTY: 'Tracking History is Empty',
  INDENT_TRACKING_NUMBER_SAVED: 'Tracking number saved',
  INDENT_RETURN_CREATED: 'Return Indent will be created for :',
  INDENT_DISCARD: 'Discard',
  INDENT_PACKING_NOTES: 'Packing Notes ',
  INDENT_CLEAR: 'Clear',
  INDENT_NOTHING_TO_SHOW: 'Nothing to show',
  INDENT_NOTES_CREATED: 'Notes created!',
  INDENT_NOTES_CREATING_ERR: 'Error while creating notes!',
  INDENT_NOTES_UNEXPECTED_ERR: 'Unexpected error while creation notes!',
  INDENT_RESPONSE: 'Response',
  INDENT_CHANGING_TIMESTAMP: 'Changing the timestamp will affect',
  INDENT_CHAING_TIMESTAMP_PROMPT: 'Are you sure you want to edit the timestamp?',
  INDENT_DATE_SAVE_FAILED: 'Date save failed!',
  INDENT_NOTES: 'Notes',
  INDENT_NOTES_REMOVED: 'Notes removed!',
  INDENT_NOTES_REMOVED_ERR: 'Error while removing notes!',
  INDENT_NOTES_REMOVED_UNEXPECTED_ERR: 'Unexpected error while removing notes!',
  INDENT_DOCUMENTS_FETCHING_FAILED: 'Documents fetching failed!',
  INDENT_MANUAL_CHARGE_INFO: ' Manual Charge Information',
  INDENT_CARRIER_HACH_RATE: 'Carrier HACH Rate ',
  INDENT_CARRIER_LIST_RATE: 'Carrier List Rate ',
  INDENT_FREIGHT_CHARGES_FAILED: 'Freight charges fetching failed!',
  INDENT_FREIGHT_CHARGES_CHECKING: 'No values have been entered by user!',
  INDENT_FREIGHT_CHARGES_SUCCESS: 'Freight charges Update Success',

  MDM_DETENTION_TRUCK_TYPES: 'Truck Types',
  MDM_DETENTION_DELAY: 'Detention Delay',
  MDM_SOURCE_DESTINATION: 'Select Source & Destination',
  MDM_NO_DROPOFF_SELECTED: 'No dropoffs selected',
  MDM_SELECT_DESTINATION: 'Select Destination',
  MDM_SELECT_MODE: 'Select Mode',
  MDM_EXIM_DOCUMENT: 'Documents',
  MDM_PICK_DATE: 'Pick a date',
  MDM_SELECT: 'Select',
  MDM_SEARCH: 'Search',
  MDM_SUBMIT: 'Submit',
  MDM_REJECT_REASON: 'Reject Reason',
  MDM_SELECT_OPTIONS: 'Select options',
  FREIGHT_APPROVAL: 'Freight Approval',
  SELECT_FREIGHT_RATE_REASON: 'Please select a reason for freight rate',



  // integration api history
  FP_POSTING: 'Freight Provision Posting',
  MP_POSTING: 'Modified Picklist',
  SHIPMENT_STATUS: 'Shipment Status',
  DISCARD_OPTIMA: 'Discard Optima',

  // consistent UI
  INDENT_VEHICLE_ASSIGNMENT_TOAST_MSG: 'Truck assigned for indent {order_number}',
  INDENT_INSPECTION_ACCEPTANCE_TOAST_MSG: 'Inspection done for {order_number}',
  INDENT_TRUCK_OUT_TOAST_MSG: 'Truck dispatched for indent {order_number}',
  INDENT_TRUCK_IN_TOAST_MSG: 'Truck arrived for indent {order_number}',
  INDENT_MARK_AS_DELIVERED_TOAST_MSG: 'Indent number {order_number} is marked as delivered',
  INDENT_CASH_COLLECTED: 'Cash Collected',
  INDENT_CASH_RECEIVED_ON_HAND: 'Cash received on hand',
  INDENT_ENTER_CASH_COLLECTED: 'Enter cash collected',
  INDENT_ENTER_VALID_AMOUNT: 'Please enter a valid amount',
  INDENT_YET_TO_COLLECT_CASH: 'Yet to collect / deliver',
  INDENT_LR_NUMBER_TOAST_MSG: 'LR number saved successfully',
  INDENT_INSPECTION_REJECTION_TOAST_MSG: 'Truck rejected in inspection for {order_number}',
  INDENT_SEAL_NUMBER_UPDATE_TOAST_MSG: 'Seal Number Successfully Updated for {order_number}',
  INDENT_ATTACHMENT_ADDED_TOAST_MSG: 'Inspection Attachment added successfully',
  INDENT_RESET_ALL: 'Reset All',
  INDENT_FILTER_FROM_OPS_CONTROL_TOWER: 'filter from ops control tower has been applied',
  INDENT_GLOBAL_SEARCH: 'Global search based filters has been applied',
  INDENT_CHANGE_SHIP_METHOD: 'Change Ship Method',
  INDENT_WEIGHTS:'WEIGHTS',
  INDENT_TARE_WEIGHT:'TARE WEIGHT (MT)',
  INDENT_GROSS_WEIGHT:'GROSS WEIGHT (MT)',
  INDENT_ENTER_TARE_WEIGHT:'Enter Tare Weight',
  INDENT_ENTER_GROSS_WEIGHT:'Enter Gross Weight',
  INDENT_REASON_UPDATE:'Reason To Update',
  INDENT_REASON_VALIDATION:'(Minimum 15 characters required)',
  INDENT_COMMENTS:'Comments',
  INDENT_WEIGHT_TRUCK_OUT_REASON:'Please enter Gross weight to proceed for Truck out',
  INDENT_WEIGHT_TRUCK_IN_REASON:'Please enter Tare weight to proceed for Truck in',
  ADD_COMMENT: 'Add a Comment',
  INDENT_CANCEL_DRAFT_PROMPT: 'Are you sure you want to cancel draft',
  INDENT_PRINT_OPTIONS: 'Print Options',
  INDENT_PRINT_ALL: 'Print all ( Across deliveries )',
  INDENT_PERCENTAGE_OF_CONTRACT_RATE: '% of contract rate',
  INDENT_ENTER_PERCENTAGE: 'Enter %',
  INDENT_SIMPLIFIED_FREIGHT: 'Simplified Freight',
  INDENT_SIMPLIFIED_FREIGHT_RATE: 'Simplified Freight Rate',
  INDENT_AIR_FREIGHT: 'Air Freight',
  INDENT_AIR_FREIGHT_AMOUNT: 'Air Freight Amount',
  INDENT_INTL_AIR_FREIGHT: 'Intl Air Freight',
  INDENT_COLLECT_HANDLING_FEE: 'Collect Handling Fee',
  INDENT_FORWARDING_FEE: 'Forwarding Fee',
  INDENT_INLAND_FEE: 'Inland Fee',
  INDENT_MOTOR_FREIGHT: 'Motor Freight',
  INDENT_OCEAN_FREIGHT: 'Ocean Freight',
  INDENT_OTHER_CHARGES: 'Other Charges',
  INDENT_POSTAGE: 'Postage',
  INDENT_POSTAGE_CHARGES: 'Postage Charges',
  INDENT_INSURANCE_FEE: 'Insurance Fee',
  INDENT_PACKING_HANDLING_FEE: 'Packing and Handling Fee',
  INDENT_LETTER_OF_CREDIT_DOCUMENTS: 'Letter of Credit Documents',
  INDENT_FREIGHT_CHARGES_UPDATING_FAILED: 'Freight charges Updating failed!',
  INDENT_SEARCH_BY_ITEM: 'Search by Item ID/Tag',
  INDENT_REFRESH: 'Refresh',
  INDENT_EDITED: 'Edited',
  INDENT_STATUS_CODE: 'status code',
  INDENT_SHOW: 'Show',
  INDENT_HIDE: 'Hide',
  INDENT_EDIT_DATE_TIME: 'Edit Date/Time',
  INDENT_DATE_SAVE_SUCCESSFUL: 'Date save successful!',
  INDENT_UNEXPECTED_ERROR_FETCHING_NOTES: 'Unexpected error while fetching notes!',
  INDENT_ADD_TRACKING_NUMBER: 'Add Tracking Number',
  INDENT_TRACKING_FETCH_FAILS: 'Tracking Fetch Fails. Please try after some time',
  INDENT_RETRIGGER_BOOKING_SUCCESSFUL: 'ReTrigger Booking is successfull, Please check Timeline after sometime',
  INDENT_RETRIGGER_FAILS: 'Retrigeer Fails. Please try after some time',
  INDENT_CONSIGNMENT_TRACKING_FETCH_FAILS: 'Consignment Tracking Fetch Fails. Please try after some time',
  INDENT_VEHICLE_INPUT_TYPE_XX: 'XX',
  INDENT_VEHICLE_INPUT_TYPE_XO: 'X0',
  INDENT_VEHICLE_INPUT_TYPE_XXOO: 'XX00',
  INDENT_VEHICLE_INPUT_TYPE_OOOO: '0000',
  INDENT_EXIT: 'Exit',
  INDENT_CHASSIS_NUMBER_SAMPLE: '900132CTZOXXXX',
  INDENT_ENGINE_NUMBER_SAMPLE: 'CTZP12345XXXX',
  INDENT_DRIVER_MOBILE_NUMBER_SAMPLE: '99XXXXXXXX',
  INDENT_LICENSE_NUMBER_SAMPLE: '311121/1212/1',
  INDENT_ENTER_VEHICLE_LENGTH: 'Enter Vehicle Length',
  INDENT_ENTER_VEHICLE_WIDTH: 'Enter Vehicle Width',
  INDENT_ENTER_VEHICLE_HEIGHT: 'Enter Vehicle height',
  INDENT_ENTER_REASON: 'Enter Reason',
  INDENT_DIMENSION: 'Dimension',
  INDENT_CHOOSE_COUNTRY: 'Choose Country',
  INDENT_SHIP_TO_COUNTRY: 'Ship To Country',
  INDENT_CHOOSE_SHIPMETHOD: 'Choose ShipMethod',
  INDENT_CHOOSE_CARRIER: 'Choose Carrier',
  INDENT_SHIP_TO_ADDRESS: 'Ship To Address',
  INDENT_SHIP_TO_STATE: 'Ship to State',
  INDENT_SHIP_TO_CITY: 'Ship to City',
  INDENT_POSTAL_CODE: 'Postal Cde',
  INDENT_CONTACT_NAME: 'Contact Name',
  INDENT_TERMS_OF_SALE: 'Terms Of Sale',
  INDENT_CHOOSE_TERMS_OF_SALE: 'Choose Terms Of Sale',
  INDENT_ENTER_CONTACT_NAME: 'Enter Name',
  INDENT_DUTIES_AND_TAXES: 'Duties And Taxes',
  INDENT_CHOOSE_DUTIES_AND_TAXES: 'Choose Duties And Taxes',
  INDENT_PICK_A_DAY: 'Pick a day',
  INDENT_ENTER_CEILING_PRICE: 'Enter Ceiling price',
  INDENT_ENTER_HISTORICAL_PRICE: 'Enter Historical price',
  INDENT_SEARCH_FOR_TRANSPORTER: 'Search for Transporter',
  INDENT_TPARTY_ADDRESS: 'Tparty Address',
  INDENT_TPARTY_STATE: 'Tparty State',
  INDENT_TPARTY_COUNTRY: 'Tparty To Country',
  INDENT_TPARTY_CITY: 'Tparty CITY',
  INDENT_TPARTY_POSTAL_CODE: 'Tparty Postal Code',
  INDENT_TPARTY_PHONE_NUMBER: 'Tparty Phone Number',
  INDENT_TPARTY_CONTACT_NUMBER: 'Tparty Contact Number',
  INDENT_TPARTY_ACCT_NUMBER: 'Tparty Acct Number',
  INDENT_TPARTY_ACCOUNT_NUMBER: 'Tparty Account Number',
  INDENT_ENTER_COUNTRY_NAME: 'Enter Country',
  INDENT_ENTER_PHONE_NUMBER: 'Enter Phone Number',
  INDENT_ENTER_ACCT_NUMBER: 'Enter Acct Number',
  INDENT_ENTER_NUMBER: 'Enter Number',
  INDENT_ADD_REASON: 'Add Reason',
  INDENT_ENTER_SHIPMENT_NUMBER: 'Enter Shipment No.',
  INDENT_REGENERATE_PAYMENT: 'Retrigger Payment',
  SELECT_CONTRACTED_TRANSPORTER: 'Select Contracted Transporter',
  PICK_AT_LEAST: 'Pick at least',
  SELECT_TRANSPORTER: 'Select a Transporter',
  SHOW_SELECTED: 'Show Selected',
  SELECT_ALL: 'Select All',
  INDENT_START_END_DATE: 'Start Date - End Date',
  INDENT_DELIVERED_INDENTS_EXCLUDED: 'Note:Delivered Indent will not be included',
  DISCARD_INDENTS_REVIEW: 'You have reviewed some items. Are you sure you want to leave and discard your progress?',
  PARTIAL_INDENTS_REVIEW: 'You have not reviewed all the indents. Do you still want to continue?',
  // Depot
  GATE_UPDATE_SUCCESS: 'Gate Updated Successfully',
  GATE_NAME_VALIDATE_ERR: 'name is not allowed to be empty - Validation  error',
  ENTER_REFRENCE_ID: 'Please enter reference id',
  SELECT_MANAGER: 'Please select manager',
  DOCK_CREATE_FAILED: 'Dock creation failed',
  DOCK_USER_SELECT: 'Please select dock users',
  SELECT_GATE_DOCK: 'Select a gate to add a dock',
  SELECT_REASON: 'Select Reason',
  REINDENT_REASON_INFO: 'Reason should be 15 to 60 characters',

  // PAY

  // Common labels
  DETAILS_SLIDER: 'DETAILS',
  UPDATE_SLIDER: 'UPDATE',
  REMARKS: 'REMARKS',
  TIMELINE: 'TIMELINE',
  CHARGES: 'CHARGES',
  DETAILS: 'DETAILS',
  CONFIRMATION: 'Confirmation',
  INVOICE_INDENT_DETAILS: 'Indent Details',
  INVOICES: 'Invoices',
  EXPAND: 'Expand',
  COLLAPSE: 'Collapse',
  TOTAL_INDENTS: 'Total Indents',
  REQUESTED: 'Requested',
  SYSTEM_GENERATED: 'System Generated',
  CANCEL: 'Cancel',
  REJECT: 'Reject',
  OVERRIDE:'Override',
  ADD: 'Add',
  ATTACHMENTS: 'Attachments',
  CALCULATIONS: 'Calculations',
  TRIP: 'Trip',
  FREIGHT_RATE: 'Freight Rate',
  MIN_RATE: 'Min Rate',
  FREIGHT_UNIT: 'Unit',
  QUANTITY_SHORT_FORM: 'Qty',
  MATERIAL: 'Material',
  NO_DATA: 'No Data',
  SEARCH: 'Search',
  SEARCH_BY_INDENT_ID: 'Search by Indent Id',
  REMOVE: 'Remove',
  CLEAR_ALL: 'Clear All',
  LOADING_DETAILS: 'Loading Details!',
  TRANSPORTER_DEBIT: 'TRANSPORTER DEBIT',
  COMMENTS_ATTACHMENTS: 'COMMENTS + ATTACHMENTS',
  COMMENTS: 'COMMENTS',
  DISCUSS: 'DISCUSS',
  YES: 'YES',
  NO: 'NO',
  EDIT: 'Edit',
  UPDATE: 'Update',
  LR_ATTACHMENTS: 'LR Attachments',
  RESET_ALL: 'RESET ALL',
  APPLY: 'APPLY',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  SAVE: 'Save',
  FROM: 'from',
  TO: 'to',
  LIST: 'List',
  SELECT: 'Select',
  TRANSPORTERS: 'Transporters',
  NO_DATA_AVAILABLE: 'No data available',
  SELECTED: 'Selected',
  REJECTED: 'Rejected',
  WHATS_NEW: "What's New",
  SEE_IT_LATER: 'See it later',
  EXPLORE_NOW: 'Explore now',
  LEARN_MORE: 'Learn More',
  TASK: 'Task',
  DISCARD: 'Discard',
  AFTER: 'After',
  CONSECUTIVE: 'consecutive',
  ATTENTION: 'Attention',
  VIEWED: 'Viewed',
  Partial_Amount_Paid: 'Partial Amount Paid',

  // Buttons
  INVOICE_SUMMARY: 'Summary',
  INVOICE_PREVIEW: 'Preview',
  MAIL_INVOICE_AND_ANNEXURE: 'Mail Invoice and Annexure',
  INVOICE_EXPORT: 'Export',
  ATTACHMENT_UPLOAD: 'Upload',
  INVOICE_REJECT: 'Reject',
  INVOICE_RETURN: 'Return',
  INVOICE_CHECKED: 'Checked',
  INVOICE_APPROVE: 'Approve',
  INVOICE_VERIFY: 'Verify',
  GENERATE_INVOICE: 'Generate Invoice',
  RE_SUBMIT: 'Re-Submit',
  INVOICE_PRINT: 'Invoice',
  E_INVOICE: 'E-Invoice',
  ANNEXURE_1_PRINT: 'Annexure-1',
  ANNEXURE_2_PRINT: 'Annexure-2',
  REFRESH_LATEST_LOCATION: 'Refresh Location',
  NO_LOCATION_FOUND: 'No pings found',
  YES_DISCARD: 'Yes, Discard',

  // RFB Headers
  PAY_INDENT_ID: 'Indent ID',
  PAY_STATUS: 'Status',
  PAY_DELIVERED_DATE: 'Delivered Date',
  PAY_ROUTE: 'Route',
  PAY_VEHICLE_TYPE: 'Vehicle Type',

  // Freight Bill Headers
  BILL_NO: 'Bill No',
  NO_OF_INDENTS: 'No of Indents',
  CATEGORY: 'Category',
  BILL_NUMBER: 'Bill Number',
  BILL_DATE: 'Bill Date',
  DEPOT_TOTAL:'Amount :',

  // Invoice Headers
  INVOICE_INVOICE_NO: 'Invoice No',
  INVOICE_STATUS: 'Status',
  INVOICE_CREATED_AT: 'Created At',
  INVOICE_TRANSPORTER: 'Transporter',
  INVOICE_TRANSPORTER_REF_ID: 'Transporter Ref Id',
  INVOICE_AMOUNT: 'Amount',
  INVOICE_PAYMENT_DUE_DATE: 'Payment Due Date',
  INVOICE_COUNTRY: 'Country',
  INVOICE_TYPE: 'Invoice type',
  INVOICE_DATE: 'Date',
  INVOICE_GST_TYPE: 'GST Type',
  INVOICE_DISCOUNT_STATUS: 'Discount Status',
  INVOICE_LEGAL_ENTITY: 'Legal Entity',
  INVOICE_AGE: 'Age (in days)',
  INVOICE_DEPOT: 'Depot',
  INVOICE_CLIENT: 'Client',

  // Invoice Search Parameters
  INVOICE_SEARCH_INVOICE_NUMBER: 'Invoice number',
  INVOICE_SEARCH_TRANSPORTER: 'Transporter',
  INVOICE_SEARCH_INDENT_ID: 'Indent ID',
  INVOICE_SEARCH_LR_NUMBER: 'LR Number',
  INVOICE_SEARCH_PO_NUMBER: 'PO Number',
  INVOICE_SEARCH_ACCOUNT_ASSN_NO: 'Account assignment no.',
  INVOICE_SEARCH_SHIPMENT_NO: 'Shipment Number',
  INVOICE_SEARCH_INDENT_NUMBER: 'Indent Number',
  INVOICE_TRUCK_TYPE: 'Truck Type',
  INVOICE_SHIPMENT_ID: 'Shipment ID',

  // Invoice details
  RETRY_FREIGHT_INVOICE: 'RETRY FREIGHT INVOICE',
  INVOICE_LR_NUMBERS: 'LR Numbers',
  INVOICE_INFO: 'INFO',
  INVOICE_PAYMENT_POSTED_REF: 'Payment Posted Ref No',
  INVOICE_PAYMENT_PAID_REF: 'Payment Paid Ref No',
  VERIFY_INVOICE: 'Verify Invoice',

  DELETE_ATTACHMENT_PROMPT: 'Are you sure you want to delete the attachment?',
  INVOICE_ATTACHMENT: 'Invoice Attach',
  DIGITALLY_SIGNED_INVOICE: 'Digitally Signed Invoice',

  SYSTEM_CHARGE: 'System',
  TRANSPORTER_CHARGE: 'Transporter',
  CHARGE_TYPE: 'Type',
  ROUTE: 'Route',
  VEHICLE_NO: 'Vehicle No',
  ASSOCIATED: 'Associated',
  ACCOUNT_ASSN_NO: 'Acct. Assmt. No.',
  FREIGHT_INVOICE_RATIO: 'Freight-to-Invoice Ratio',
  CONSIGNEES: 'Consignees',
  WEIGHT_SHORT_FORM: 'Wt',
  VOLUME_SHORT_FORM: 'Vl',
  REFERENCE_ID: 'Ref Id',
  MATERIAL_INVOICE_NUMBER: 'Material Invoice Number',

  ADD_COMMENT: 'Add a comment',

  // Charges
  FREIGHT: 'Freight',
  TRANSIT_DELAY: 'Transit Delay',
  LOADING: 'Loading',
  LOADING_DETENTION: 'Loading detention',
  UNLOADING_DETENTION: 'Unloading detention',
  UNLOADING: 'Unloading',
  LR_CHARGE: 'LR',
  ADDITIONAL_POINT_CHARGE: 'Additional Point',
  ODA_CHARGE: 'ODA',
  MISCELLANEOUS_CHARGE: 'Miscellaneous charge',
  SLA_DELAY: 'SLA Delay',
  FIXED_CHARGE: 'Fixed charge',
  DEDUCTIBLES: 'Deductibles',
  BFR_CHARGE: 'BFR',
  SHORTAGE: 'Shortage',
  DAMAGE: 'Damage',
  CARTON_DAMAGE: 'Carton damage',
  LEAKAGE: 'Leakage',
  DEBIT_SUB_TOTAL: 'Debits Sub Total',
  EXTRA_KM_CHARGE: 'EXTRA KM CHARGE',
  TOTAL: 'TOTAL',
  RTO_CHARGES: 'RTO Charges',
  MALL_CHARGE: 'Mall Charge',
  APPOINTMENT_CHARGE: 'Appointment Charge',
  ECC: 'ECC',
  MINIMUM_RTO_CHARGES: 'Minimum RTO Charges',


  // Summary slider
  INVOICE_NUMBER: 'Invoice Number',
  IRN_NUMBER: 'IRN Number',
  INVOICE_DATE: 'Invoice Date',
  TAX_PAYABLE_REVERSE_CHARGE: 'Tax payable on reverse charge',
  PLACE_OF_SUPPLY: 'PLACE OF SUPPLY',
  HSN_SAC: 'HSN/SAC',
  PO_NUMBER: 'PO Number',
  BILL_TO_PARTY: 'Bill to Party',
  GSTIN: 'GSTIN',
  NAME_OF_ENTITY: 'Name of Entity',
  ADDRESS: 'Address',
  CITY: 'City',
  STATE: 'State',
  TOTAL_AMOUNT_DISCOUNTED: 'Total Amount(Discounted)',
  DISCOUNT_AMOUNT: 'Discount Amount',
  TOTAL_AMOUNT: 'Total Amount',
  TOTAL_TAXABLE_VALUE: 'Total Taxable Value',
  TOTAL_BASE_VALUE: 'Total Base Value',
  EXTRA_KMS_TRAVELLED: 'Extra KMs Travelled',
  TOTAL_INVOICE_VALUE: 'TOTAL INVOICE VALUE',
  PAY_EARLY: 'Pay Me Early',
  PAY_MSME_RANGE_ERROR_MESSAGE: 'MSMEs payments can not be held more than 45 days',
  PAY_BY_DATE: 'Pay by date',
  SERVICE_PROVIDER_STATE: 'Service provider state',
  GST_METHOD: 'GST Method',
  TAX: 'TAX',
  CGST: 'CGST',
  SGST: 'SGST',
  IGST: 'IGST',

  // Ready for billing
  PAY_CLIENT: 'Client',
  PAY_DEPOT: 'Depot',
  PAY_DATE_FILTER_TYPE: 'Date filter type',
  PAY_DATE: 'Date',
  PAY_INDENT_TYPE: 'Indent Type',
  PAY_STATUS_TYPE: 'Status Type',
  PAY_DELIVERY_TYPE: 'Delivery Type',
  PAY_TAX: 'Tax',
  PAY_UPDATE_INDENT: 'Update Indent',
  PAY_PO_NUMBER: 'PO Number',
  PAY_ACC_ASSGN_NO: 'Acct. Assmt. No.',
  PAY_PHYSICAL_LR: 'PHYSICAL LR',
  PAY_LEGAL_ENTITY: 'Legal Entity',
  PAY_SLAB_RANGE: 'SLAB RANGE',
  PAY_TOTAL_FREIGHT_RATE: 'Total Freight Rate',
  PAY_RATE: 'RATE',

  // Error message
  PAY_INVALID_INVOICE_DATE: 'Please change the invoice date to resubmit',
  PAY_INVALID_INDENT_SELECTION: 'Selected Indents should have single pickup & dropoff, same location, depot-depot movement only',
  PAY_CANNOT_BE_BLANK: 'Cannot be blank',
  PAY_CONFIRM_CHANGE_PROMPT: 'Please confirm the change',
  PAY_SEZ_MESSAGE: 'Supply to SEZ under bond/LOU at 0% GST',
  PAY_NEGATIVE_INVOICE_MESSAGE: 'The invoice amount is negative or zero, can\'t able to generate',
  PAY_NO_PERMISSIONS: 'No Permissions',
  PAY_DIGITAL_VERIFICATION_NEEDED: 'Digitally signed invoice is not verified',
  PAY_BY_DATE_REQUIRED: 'Pay by date is required',
  PAY_BY_DATE_RANGE: 'Select pay by date within range',
  PAY_INVALID_DISCOUNT_AMOUNT: 'Not a valid discount amount',
  PAY_GREATER_DISCOUNT_AMOUNT: 'Discount can\'t be greater than or equal to invoice amount',
  PAY_DISCOUNT_AMOUNT_REQUIRED: 'Discount amount is required',
  PAY_GSTIN_REQUIRED: 'GSTIN is required',
  PAY_SERVICE_PROVIDER_REQUIRED: 'Service provider is required',
  ACK_DATE: 'ACK Date',
  ACK_NO: 'ACK No.',
  PAY_COMMENTS_REQUIRED: 'Comments are required',
  PAY_COMMENT_ATTACHMENT_MANDATORY: 'Comment / Attachment Mandatory',
  PAY_AMOUNT_COMMENT_REQUIRED: 'Amount change and comments are required',
  PAY_LR_NOT_AVAILABLE: 'LR numbers not available',
  PAY_MISSING_REQUIRED_CUSTOM_FIELDS: 'Custom Invoice Fields are required',
  PAY_ACCESSORIAL_CHARGES: 'Accessorial Charges',
  PAY_ADD_NEW_CONTRACT: 'Add New Contract',
  PAY_DELETE_CONTRACT_PROMPT: 'Are you sure you want to delete contract',

  // Wallet search parameters
  WALLET_SEARCH_INDENT_ID: 'Indent ID',
  WALLET_SEARCH_SHIPMENT_NUMBER: 'Shipment number',

  // Wallet Headers
  WALLET_INDENT_ID: 'Indent ID',
  WALLET_STATUS: 'Status',
  WALLET_CLIENT: 'Client',
  WALLET_ROUTE: 'Route',
  WALLET_SHIPMENT_NUMBER: 'Shipment no',
  WALLET_REASON: 'Reason',
  WALLET_AMOUNT: 'Amount',
  WALLET_TRANSPORTER: 'Transporter',

  WALLET_DEPOT: 'Depot',
  WALLET_DATE: 'Date',
  WALLET_TOTAL: 'Wallet Total',
  WALLET_SYSTEM_CHARGE: 'System',
  WALLET_TRANSPORTER_CHARGE: 'Transporter',
  WALLET_SHIPPER_CHARGE: 'Shipper',
  WALLET_TOTAL_AMOUNT: 'TOTAL AMOUNT',

  WALLET_REJECT: 'REJECT',
  WALLET_ACCEPT: 'ACCEPT',
  WALLET_SUBMIT: 'Submit',

  //Wallet Settlement comment
  WALLET_SELLETMENT_COMMENT: 'Comment',
  WALLET_SETTLED_BY: 'Settled By',
  WALLET_SETTLED_AT: 'Settled At',
  WALLET_SETTLEMENT_CONFIRMATION: 'Are you sure you want to settle the wallet entry?',
  WALLET_SETTLE: 'SETTLE',
  WALLET_SETTLED_LABEL: 'Wallet Settled',


  DOCK_SHORT_CODE_ERR: 'Please enter short code',
  DOCK_NAME_ERR: 'Please enter dock name',
  DUPLICATE_REFERENCE_ID: 'Entered reference id already exists',
  DEPOT_USER_REQUIRED: 'Please select depot user',
  OPTIMA_DC_MOVEMENT: 'Optima based dc movement',

  // Redirection Master
  SOURCE_DEPOT_NAME:'Source Depot Name',
  REDIRECTION_DEPOT_NAME:'Redirection Depot Name',
  REDIRECTION_DEPOT_GATE:'Redirection Depot Gate',
  ORDER_TYPE:'Order Type',
  ASSOCIATED_MATERIAL_CATEGORY:'Associated Material Categories',
  ASSOCIATED_STATE_CITY:'Associated State/City',
  MDM_REDIRECTION_MASTER: 'Redirection Master',
  MDM_REDIRECTION_GATE: 'Redirection Gate',
  MDM_REDIRECTION_ASSOCIATE_BY: 'Associated By',
  MDM_REDIRECTION_MASTER_CREATE_SUCCESS: 'Redirection Rule Added Successfully',
  MDM_REDIRECTION_MASTER_UPDATE_SUCCESS: 'Redirection Rule Updated Successfully',

  // Package master
  MDM_PACKAGE_ID: 'Package Id',
  MDM_PACKAGE_DESCRIPTION: 'Description',
  MDM_PACKAGE_TYPE: 'Type',
  MDM_PACKAGE_MAX_STACK: 'Max stack',
  MDM_PACKAGE_HEIGHT: 'Height',
  MDM_PACKAGE_WEIGHT: 'Weight',
  MDM_PACKAGE_VOLUME: 'Volume',
  MDM_PACKAGE_LENGTH: 'Length',
  MDM_PACKAGE_BREADTH: 'Breadth',
  MDM_PACKAGE_WEIGHT_CAPACITY: 'Weight capacity',
  MDM_PACKAGE_VOLUME_CAPACITY: 'Volume capacity',
  MDM_PACKAGE_LOAD_TYPE: 'Load type',
  MDM_PACKAGE_CAN_LOAD_ON_TOP: 'Can lot on top',
  MDM_PACKAGE_MAX_SKU: 'Max sku',
  MDM_PACKAGE_MAX_IN_TRUCK: 'Max in truck',
  MDM_PACKAGE_MAX_WEIGHT: 'Max weight',
  MDM_PACKAGE_MAX_MATERIALS: 'Max materials',

  // Deviations
  EXCEPTION_EXPECTED: 'Expected',
  EXCEPTION_ACTUAL: 'Actual',
  EXCEPTION_DEVIATION: 'Deviation',
  EXCEPTION_SOURCE: 'Source',
  EXCEPTION_DESTINATION: 'Destination',
  EXCEPTION_MATERIAL_CODE: 'Material Code',
  EXCEPTION_TYPE: 'Type',
  EXCEPTION_INDENT_NUMBER: 'Indent Number',
  EXCEPTION_MATERIAL_INVOICE_NO: 'Invoice Number',
  EXCEPTION_GO_TO_INDENT: 'Go To Indents',
  EXCEPTION_INDENTS: 'Indents',

  //ptl group actions
  PTL_GROUP_ACTION_PROGRESS: 'Action in progress',
  DASHBOARD_UNLOADING_VS_ETA: 'Active Unloading VS ETA',
  DASHBOARD_NO_DATA_AVAILABLE: 'No data available',

  // Transporter Profile Constants
  TRANSPORTER_PROFILE_CONTACT: 'Contact',
  TRANSPORTER_PROFILE_CONFIGURATIONS: 'Configurations',
  TRANSPORTER_PROFILE_CERTIFICATIONS: 'Certifications',
  TRANSPORTER_PROFILE_FSSAI: 'FSSAI',
  TRANSPORTER_PROFILE_TDS: 'TDS',
  TRANSPORTER_PROFILE_CERTIFICATE_NUMBER: 'Certificate Number',
  TRANSPORTER_PROFILE_VALID_TILL: 'valid till',
  TRANSPORTER_PROFILE_PICK_DATE: 'Pick a date',
  TRANSPORTER_PROFILE_STATE_WISE_GSTIN: 'State-Wise GSTIN',
  TRANSPORTER_PROFILE_DELETE: 'DELETE',
  TRANSPORTER_PROFILE_ADD_HSN_SAC: 'Add HSN/SAC',
  TRANSPORTER_PROFILE_HSN_SAC_NAME: 'Name',
  TRANSPORTER_PROFILE_ENTER_NAME: 'Enter Name',
  TRANSPORTER_PROFILE_HSN_SAC_CODE: 'Code',
  TRANSPORTER_PROFILE_ENTER_CODE: 'Enter Code',
  TRANSPORTER_PROFILE_COMPANIES_SERVICING: 'COMPANIES SERVICING',
  TRANSPORTER_PROFILE_PRE_FIX: 'PRE-FIX',
  TRANSPORTER_PROFILE_LR_NUMBER_FROM: 'LR NUMBER FROM',
  TRANSPORTER_PROFILE_LR_COUNT_TO: 'LR COUNT TO',
  TRANSPORTER_PROFILE_CURRENT: 'CURRENT',
  TRANSPORTER_PROFILE_TYPE: 'TYPE',
  TRANSPORTER_PROFILE_ADD_GSTIN: 'Add GSTIN',
  TRANSPORTER_PROFILE_GSTN: 'GSTIN',
  TRANSPORTER_PROFILE_ENTER_GSTN: 'Enter GST number',
  TRANSPORTER_PROFILE_ENTER_REFERENCE_ID: 'Enter reference ID',
  TRANSPORTER_PROFILE_ENTER_ACK_NO: 'Enter Ack number',
  TRANSPORTER_PROFILE_ENTER_ACK_DATE: 'Select Ack date',
  TRANSPORTER_PROFILE_SELECT_STATE: 'Select state',
  TRANSPORTER_PROFILE_E_INVOICE: 'Enable E-Invoice',
  TRANSPORTER_PROFILE_ENTER_ADDRESS: 'Enter Address',

  // FAP invoice settings labels
  ADMIN_INVOICE_SETTINGS: 'Admin Invoice Settings',
  INVOICES_WITH_NO_DISCREPANCY: 'Invoices with no discrepancy',
  ALLOW_AUTO_APPROVAL: 'Allow Auto-Approval',
  CURRENCY_ADJUSTMENT_FEES: 'Currency Adjustment Fees',
  ADJUSTMENT_ADD_NEW: 'Add New',
  FROM_CURRENCY: 'From Currency',
  TO_CURRENCY: 'To Currency',
  VALUE: 'Value',
  FEES: 'Fees',

  //integration
  INTEGRATION: 'Integrations',
  INTEGRATION_RETRIGGER: 'RETRIGGER',
  INTEGRATION_INTEGRATION_LOG: 'Integration Logs',
  INTEGRATION_ENTITY_ID: 'Entity Id',
  INTEGRATION_ERROR_INTERFACE: 'Error Interface:',
  INTEGRATION_API_NAME: 'API Name',
  INTEGRATION_UPDATED_DATE: 'Updated date',
  INTEGRATION_MITM_STATUS_code: 'MITM Status code',
  INTEGRATION_MITM_MESSAGE: 'MITM Message',
  INTEGRATION_MITM_URL: 'MITM URL',
  INTEGRATION_ERP_URL: 'Erp URL',
  INTEGRATION_ENTITY_TYPE: 'Entity Type',
  INTEGRATION_ERP_STATUS_CODE: 'Erp Status code',
  INTEGRATION_ERP_MESSAGE: 'Erp Message',
  INTEGRATION_JSON_FILENAME: 'JSON payload',
  INTEGRATION_EXCEL_FILENAME: 'Excel Filename',
  INTEGRATION_DETAILS: 'Details',
  INTEGRATION_PAYLOAD: 'Payload',
  INTEGRATION_DOWNLOAD_JSON: 'Download Json',
  INTEGRATION_DOWNLOAD_EXCEL: 'Download Excel',
  INTEGRATION_SUCCESSFUL: 'SUCCESSFUL',
  INTEGRATION_TRANSACTIONS_OUTBOUND: 'Transactions Outbound',
  INTEGRATION_TRANSACTIONS_INBOUND: 'Transactions Inbound',
  INTEGRATION_ALL_OUTBOUND: 'All Outbound',
  INTEGRATION_EPOD: 'EPOD',
  FREIGHT_PROVISION: 'Freight Provision',
  FREIGHT_INVOICE: 'Freight Invoice',
  INTEGRATION_MATERIAL_INVOICE: 'Material Invoice',
  INTEGRATION_GRN: 'GRN',
  INTEGRATION_BULK_INDENT: 'Bulk Indent',
  INTEGRATION_DIRECT_DISPATCH: 'Direct Dispatch',
  INDENT_INTEGRATION: 'INTEGRATIONS',
  PAYLOAD_UNAVAILABLE_MSG: 'JSON Payload not available',
  EXCEPTION_SOURCE_NAME: 'Source Name',
  EXCEPTION_SOURCE_REF_ID: 'Source Ref id',
  EXCEPTION_MATERIAL_NAME: 'Material Name',
  EXCEPTION_IN_MATERIAL_CODE: 'in Code',
  COUNT: 'COUNT',
  MDM_ASSOCIATE_MATERIALS:'ASSOCIATE MATERIALS',
  MDM_ADD_ASSOCIATE_MATERIAL:'ADD ASSOCIATE MATERIAL',
  MDM_CHILD_MATERIAL_CODE: 'CHILD MATERIAL CODE',
  MDM_ENTER_CHILD_MATERIAL: 'Enter Child Material Code',
  MDM_PARENT_FRACTION: 'PARENT FRACTION',
  MDM_CHILD_FRACTION: 'CHILD FRACTION',
  MDM_ENTER_PARENT_FRACTION: 'Enter parent fraction',
  MDM_ENTER_CHILD_FRACTION: 'Enter Child fraction',
  NO_OF_MATERIALS_RETURNED: 'No. of Materials Returned',
  RETURN_COUNT_EXCEED_ERROR: 'Return count must be less than available materials',
  RETURN_COUNT_NEGATIVE_VALUE_ERROR: 'Return count cannot be a negative value',
  SUBMIT_GRN: 'Submit GRN',
  UPDATE_RETURN_MATERIALS: 'Update Return',
  MARK_ALL_RETURN: 'Mark (all Materials) as Return',
  EDIT_EPOD_TO_SAVE: 'Edit S/D/CD to save',
  RETURN_DELIVERIES_CREATION_SUCCESS: 'Return deliveries created successfully!',
  RETURN_DELIVERIES_CREATION_FAILED: 'Return delivery creation failed',
  RETURN_MATERIAL: 'RETURN',
  RETURN_MATERIALS_UNSAVED_WARNING: 'Return values have not been saved. Changes will be lost if not saved!',
  NO_MATERIALS_TO_RETURN: 'No materials to return',
  INDENT_REJECT_BASE_FREIGHT: 'Reject Base Freight ?',
  INDENT_REJECTION_REASON_FREIGHT:'Please add reason for rejection of base Freight.',
  NO_PICKUPS_DROPS: 'No pickups found',
  ACTION_CANNOT_BE_PERFORMED: 'Action cannot be performed',
  COMPLETE_PREVIOUS_TASKS: 'Please complete previous pickups/drops',
  COMPLETE_PREVIOUS_PICKUP: 'Material not picked',
  LAST_MILE_CUSTOMER_NA: 'Customer is not available',
  LAST_MILE_CUSTOMER_NOT_REACHABLE: 'Customer is not reachable',
  LAST_MILE_REPORTED_AT: 'Reported At',
  LAST_MILE_RELEASE_AT: 'POD Date',
  CASH_ON_DELIVERY: 'COD',
  LAST_MILE_UNLOADING_START_AT: 'Unloading Start At',
  LAST_MILE_UNLOADING_END_AT: 'Unloading End At',
  LAST_MILE_NOT_DELIVERED_MSSG: '{consignee_name} from indent {order_number} has been marked as not delivered',
  LAST_MILE_PICKUP_COMPLETED_MSSG: '{consignee_name} from indent {order_number} has been marked as pickup completed',
  LAST_MILE_DROP_COMPLETED_MSSG: '{consignee_name} from indent {order_number} has been marked as delivered',
  LAST_MILE_OTHER_REASON: 'Others',
  // Planning
  PLANNING: 'Planning',
  NO_DELIVERY_ITEMS: 'No Delivery Items',
  DELIVERY_LISTING_FAILED: 'Delivery Listing Failed',
  DELIVERY_DATE_PLACEHOLDER: 'Start Date - End Date',
  ALL_CONSIGNEES: 'All Consignees',
  SELECT_DEPOT: 'SELECT DEPOT',
  DELIVERIES_DATE_FILTER: 'Date Filter',
  DISCARD_MATERIALS: 'Discard Materials',
  DISCARD_PROMPT_TEXT: 'Are you sure want to discard the selected materials from the return delivery list?',
  REQUEST_INDENT: 'Request Indent',
  CONSIGNEE_DETAILS: 'Consignee Details',
  DESTINATION: 'Destination',
  WEIGHT_KG: 'Weight (Kg)',
  VOLUME_CFT: 'Volume (CFT)',
  MATERIAL_QTY: 'Material Qty',
  INDENT_ID: 'INDENT ID',
  RECIEVED_DATE: 'Received Date',
  MATERIAL_CODE: 'MATERIAL CODE',
  RETURN: 'Return',
  PLANNING_MATERIALS: 'MATERIALS',
  SOURCE_COUNT_LIMIT_EXCEEDED: 'Source count limit exceeded',
  NO_RETURN_REQUESTS: 'No Return Requests',
  REQUEST_LISTING_FAILED: 'Request listing failed',
  DELIVERY_DATE_PLACEHOLDER: 'Select Date Range',
  PLANNING_INDENT_NUMBER: 'Indent Number',
  PLANNING_MATERIAL: 'Material',
  PLANNING_DELIVERY_NUMBER: 'Delivery Number',
  PLANNING_QUANTITY: 'Quantity',
  PLANNING_WEIGHT: 'Weight',
  PLANNING_INVOICE_NUMBER: 'Invoice Number',
  PLANNING_RETURN_SHORT: 'R',
  PLANNING_REQUEST: 'REQUEST',
  PLANNING_REJECT: 'REJECT',
  PLANNING_REJECT_REQUEST: 'Reject Request',
  REJECT_REQUEST_CONTENT: 'Are you sure you want to reject the return request?',
  PUT_BACK_RETURN: 'Put back to return delivery list',
  PLANNING_DISCARD_MATERIALS: 'Discard Materials',
  PLANNING_INDENT: 'INDENT',
  PLANNING_SELECT_A_DESTINATION: 'Select a Destination',
  PLANNING_SELECT_DESTINATION: 'Select Destination',
  PLANNING_SELECT_TRANSPORTER: 'Select Transporter',
  RETURN_REASON: 'Return reason',
  PLANNING_REQUEST_ID: 'REQUEST ID',
  PLANNING_ROUTE: 'ROUTE',
  PLANNING_TRANSPORTER: 'TRANSPORTER',
  PLANNING_VEHICLE_TYPE: 'VEHICLE TYPE',
  SHIPMENT_NUMBER: 'SHIPMENT NUMBER',
  PLANNING_DRIVER_NUMBER: 'Driver Number',
  PLANNING_RETURN_TYPE: 'Return Type',
  PLANNING_ALL: 'All',
  PLANNING_RETURNED_BY_APPROVER: 'Returned by approver',
  PLANNING_PENDING_TO_BE_PROCESSED: 'Pending to be processed',
  MDM_ENTER_CHILD_FRACTION: 'Enter child fraction',
  TOUR_OPTIMIZER: 'TourOptimizer',
  ORDER_UPLOAD: 'Order Upload',
  VEHICLE_UPLOAD: 'Vehicle Upload',
  TS_OPTIMIZE: 'Optimize',
  TS_VIEW: 'View',
  TS_CLEAR: 'Clear',
  TS_VEHICLE_CODE: 'Vehicle Code',
  TS_COUNTRY_CODE: 'Country Code',
  TS_TITLE: 'Tour Optimizer Settings',
  TS_ENTER_VEHICLE_CODE: 'Enter Vehicle Code',
  TS_ENTER_COUNTRY_CODE: 'Enter Country Code',
  OPTIMA_MATERIAL_WITH_CONSIGNEE:'Material with consignee Upload',
  ALL: 'All',
  LR_BOOKING: 'LR Booking',
  LR_CANCELLATION: 'LR Cancellation',
  LR_UPDATE: 'LR Update',
  LR_TRACKING: 'LR Tracking',
  COURIER_PARTNER_STATUS_CODE: "Courier Partner Status Code",
  COURIER_PARTNER_MESSAGE: "Courier Partner Message",
  COURIER_PARTNER_URL: "Courier Partner URL",
  COURIER_RETRIGGER:"RETRIGGER",
  COURIER_TRANSACTIONS: 'UNSUCCESSFUL TRANSACTIONS',
  COURIER_SUCCESSFUL: 'SUCCESSFUL TRANSACTIONS',
  LR_POD_FETCH: 'LR POD Fetch',
  MDM_LOGIN_ACTIVE_STATUS: 'Login Active Status',
  AUTO_CANCEL_COURIER_COMMENT: 'All Consignments are Cancelled',
  AUTO_CANCEL_COURIER_SUBTEXT: 'Consignment was Cancelled for all consignees via courier integration',
  RETURN_TYPE: 'Return Type',

  // Login screen
  REMAINING_ATTEMPTS: 'Remaining attempts',
  EMAIL_OR_PASSWORD_INCORRECT: 'Email or password is incorrect',
  PASSWORD_INCORRECT: 'Password is incorrect',
  LOGIN_WARNING: 'Warning',
  UNSUCCESSFUL_LOGIN_WARNING_TEXT: 'unsuccessful login attempts, your account will be locked.',
  ACCOUNT_HAS_BEEN_LOCKED: 'Account has been locked.',
  TOO_MANY_FAILED_ATTEMPTS_MSG: 'Too many failed attempts. Please contact your administrator.',
  MASTERS: 'MASTERS',
  MATERIAL_NAME: 'Material Name',
  TWO_FACTOR_AUTHENTICATION: 'Two-factor Authentication',
  ENTER_OTP: 'Enter OTP:',
  TIME_LEFT: 'Time left',
  RESEND_OTP: 'Resend OTP',
  TMS_DAY: 'day',
  TMS_DAYS: 'days',
  COST_DETAILS: 'Cost Details',
  RETURN_INDENT_ID: 'Return Indent Id',
  TRANSPORTER_VEHICLE: 'Transporter | Vehicle',
  RETURN_INDENT_ID_SHIPMENT_NUMBER: 'Return Indent Id | Shipment Number',
  MATERIAL_QUANTITY: 'Material Quantity',
  MATERIAL_INVOICE_N0: 'Material Invoice No.',
  PENALTY_ORDER_NUMBER: 'Penalty Order Number',
  RETURN_ORDER_NUMBER: 'Return Order Number',
  PENALTY_REFERENCE_NUMBERS: 'Penalty Reference Numbers',
  PAYMENT_SETTLEMENT: 'PAYMENT SETTLEMENT',
  HEADER_PAYMENT_SETTLEMENT: 'Payment Settlement',
  FORM_PENALTY_REFERENCE_NUMBER: 'PENALTY REFERENCE NUMBER',
  GENERATED: 'Generated',
  ERP_CN_ISSUED: 'ERP CN Issued',
  ERP_RETURN_CREATED: 'ERP Return Created',
  ERP_INVOICE_SETTLED: 'ERP Invoice Settled',
  MDM_TRANSPORT_HANDLING_EQUIPMENT_MASTER: 'Transport Handling Equipment',
  MDM_EXCLUDED_MATERIAL_DIVISION: 'Exclude Material Division',
  MDM_EXCLUDED_MATERIAL_CATEGORIES: 'Exclude Material Category',
  MDM_TRANSPORT_HANDLING_WEIGHTAGE: 'Transport Handling Weightage',
  MDM_TRANSPORT_HANDLING_NAME: 'Transport Handling Name',
  MDM_TRANSPORT_HANDLING_TYPE_MODE: 'Transport Handling Type Mode',
  OTHERS: 'Others',
  INDENT_EDIT_POPUP_TITLE: 'Indent Edit/Update Reason',
  APPLY_TO_RELATED_DROPS: "Apply To Related Drop-Off's",
  APPLY_TO_RELATED_DROPS_DESCRIPTION: 'It will populate same timestamp for all other drop-offs',
  REINDENT_REASON: 'Reindent Reason',
  INDENT_GRN_REJECTION: 'GRN Rejection',
  REASON_TO_REJECT: 'REASON TO REJECT',
  INDENT_DESTINATION_NAME: 'Destination Name',
  INDENT_DESTINATION_REF_ID: 'Destination Ref id',
  REINDENT_REASON: 'Reindent Reason',
  INVOICE_WITH_CREATED:'Invoice No | Created',
  TRANSPORTER_WITH_REF: 'Transporter | Ref Id',
  SELECTED: 'selected',
  DELETE_FUTURE_CONTRACT_COMFORMATION_MESSAGE:'Are you sure you want to delete this future contract. Please verify all details before deleting a future contract as the action can’t be reversed.',
  PAYMENT_SETTLEMENT_GR_SUBMITTED: 'Make sure GR (Goods Receipt) is Submitted in ERP.',
  PAYMENT_SETTLEMENT_INVOICE_SETTLED: 'Make sure Invoice is Settled for the shipment.',
  PAYMENT_SETTLEMENT_MOVE_NEXT_STATUS: 'Will move to next status once you submit.',
  PAYMENT_SETTLEMENT_MARK_COMPLETED: 'Mark As Completed',
  LAST_DROP_UNDELIVERED_WARNING: 'Last drop-off is being marked as Undelivered and Indent will move to next status',
  NO_PAGE_PERMISSION: 'Sorry you don’t have permission to access this page',
  REASON_TYPES: 'Reason Types',
  ADMIN_REASON_SETTINGS: 'Reason Settings',
  REASON_INDENT_EDIT: 'Indent Edit',
  REASON_INDENT_REINDENT: 'Indent Reindent',
  REASON_INDENT_REJECTION: 'Indent Rejection',
  REASON_INDENT_FREIGHT_AMOUNT: 'Indent Freight Amount',
  REASON_OPTIMA_EDIT: 'Optima Edit',
  REASON_OPTIMA_SPLIT: 'Optima Split',
  REASON_OPTIMA_COMBINE: 'Optima Combine',
  REASON_OPTIMA_REJECET: 'Optima Reject',
  REASON_OVERRIDE_VAHAN_SARATHI: 'Override vahan sarathi reason',
  VAHAN_SARATHI_VERFICATION: 'Vahan & Sarathi Verification',
  SARATHI_VERIFICATION: 'Sarathi Verification',
  VAHAN_VERIFICATION: 'Vahan Verification',
  ADMIN_DELETE_REASON_CONFORMATION_MESSAGE: 'Are you sure you want to delete reason',
  ADMIN_DELETE_REASON: 'DELETE REASON',
  REJECTED_BY_TRANSPORTER_USER: 'Rejected By Transporter User',
  ROLES: 'Roles',
  STATUS_NAME: 'Status Name',
  REASON_LR_ATTACHMENT_REJECTION: 'LR Attachment Rejection reason',
  REJECT_DOCUMENT: 'Reject Document',
  SELECT_FOR_DOCUMENT_REASON: 'Please select a reason for document rejection.',

};

module.exports = {
  localisationConstants,
};
